var canonApp = canonApp || (function() {
        
    const I18N = {
        "zh": {
            "assistant_title": "Canon 網上商店選購助理",
            "search_placeholder": "輸入你想搵啲咩、或產品型號，例如 TS8870, PG-745...",
            "btn_start_wizard": "幫我挑選最合適型號",
            "btn_browse_all": "直接瀏覽所有型號",
            "btn_restart": "重新選擇",
            "btn_buy": "詳情及購買",
            "btn_back": "返回",
            "search_fallback": "搜尋 \"{query}\" ",
            "group_printer": "打印機", 
            "group_consumable": "墨水及碳粉",
            "ink_correspond": "對應耗材:",
            "ink_hover_title": "支援個別型號 / 顏色:",
            "hot_tags": "熱門搜尋",
            "home_search_title": "話我知你想搵咩？",
            "home_search_sub": "更快去到產品頁面",
            "home_menu_title": "唔知點揀好？一步步幫你揀最啱你嘅型號：",
            "wizard_hero_title": "答幾條問題，就搵到最啱你嘅型號！",
            "or_browse_all": "或者 直接瀏覽所有型號",
            "toner_placeholder": "輸入打印機或碳粉型號",
            "ink_placeholder": "輸入打印機或墨水型號",
            "toner_result_empty": "請先選擇打印機或碳粉型號",
            "ink_result_empty": "請先選擇打印機或墨水型號",
            "toner_suitable": "適用之碳粉：",
            "ink_suitable": "適用之墨水系列：",
            "recommended_models": "推介型號",
            "no_result": "無合適嘅型號，請重新選擇",
            "browse_all_models": "所有型號",
            "based_on_choices": "根據你嘅要求：",
            "finder_toner_title": "碳粉搜尋",
            "finder_ink_title": "墨水搜尋",
            "toner_helper": "<strong>唔肯定部機配咩碳粉？</strong><br>直接輸入你的 <b>打印機型號</b>（例如 LBP623），我就會即刻話你知適用嘅碳粉！",
            "ink_helper": "<strong>唔肯定部機配咩墨水？</strong><br>直接輸入你的 <b>打印機型號</b>（例如 TS8870），我就會即刻話你知適用嘅墨水！",
            "imagesquare_title": "Canon Image Square 選購助理",
            "info_title": "資訊",
            "group_cameras": "相機及攝錄機",
            "group_lenses": "相機鏡頭",
            "no_relevant_models": "找不到相關型號",
            "btn_find_perfect_match": "搵最啱我嘅型號",
            "assistant_suffix": "選購助理",
            "spec_size": "尺寸：",
            "spec_type": "類型：",
            "spec_color": "顏色：",
            "spec_speed": "打印速度：",
            "spec_fax": "傳真：",
            "spec_duplex": "雙面打印：",
            "spec_adf": "自動送稿機：",
            "spec_single_pass": "同步式自動雙面掃描：",
            "spec_wifi": "Wi-Fi：",
            "spec_scan_res": "掃瞄器解像度：",
            "spec_resolution": "解像度：",
            "spec_af": "自動對焦：",
            "spec_fps": "連拍速度：",
            "spec_video": "影片最高解像度：",
            "spec_card": "記憶卡：",
            "spec_weight": "重量：",
            "spec_samples": "鏡頭實拍：",
            "spec_supported_inks": "{x} 支援的墨水型號：",
            "spec_supported_papers": "{x} 支援的相紙型號：",
            "omni_ink_for_printer": "{x} 適用的墨水型號",
            "omni_paper_for_printer": "{x} 適用的相紙型號",
            "omni_toner_for_printer": "{x} 適用的碳粉型號",
            "spec_applicable_for": "適用於",
            "spec_applicable_ink": "適用墨水",
            "spec_applicable_toner": "適用碳粉",
            "spec_etc": "等",
            "val_monochrome": "黑白",
            "val_color": "彩色",
            "val_colors": "{x} 色",
            "val_speed_mono": "每分鐘 {x} 頁 (黑白)",
            "val_speed_both": "每分鐘 {x} 頁 (黑白)、{y} 頁 (彩色)",
            "val_yes": "有",
            "val_no": "無",
            "val_megapixels": " 萬像素",
            "val_fps_speed": "每秒最高 {x} 張",
            "no_image": "無相片",
            "grp_ff": "全片幅",
            "grp_apsc": "APS-C",
            "grp_prime": "定焦",
            "grp_zoom": "變焦",
            "grp_inkjet": "PIXMA 噴墨打印機",
            "grp_portable": "PIXMA 流動式打印機",
            "grp_refill": "PIXMA 加墨式打印機",
            "grp_selphy": "SELPHY 便攜式打印機",
            "grp_inspic": "iNSPiC 便攜式打印機",
            "grp_laser": "imageCLASS 雷射打印機",
            "price_prefix": "",
            "price_suffix": "起",
            "grp_other_printers": "其他打印機",
            "only_applicable_for": "只適用於："
        },
        "en": {
            "assistant_title": "Canon Online Store Virtual Assistant",
            "search_placeholder": "Click here & enter model, e.g. TS8870, PG-745...",
            "btn_start_wizard": "Help me choose",
            "btn_browse_all": "Browse all models ▾",
            "btn_restart": "Start Over",
            "btn_buy": "View & Buy",
            "btn_back": "Back",
            "search_fallback": "Search \"{query}\" ",
            "group_printer": "Printers", 
            "group_consumable": "Ink & Toner",
            "ink_correspond": "Corresponding Consumables:",
            "ink_hover_title": "Supported models / colors:",
            "hot_tags": "Hot Searches",
            "home_search_title": "What are you looking for?",
            "home_search_sub": "Go to product page directly",
            "home_menu_title": "Not sure what to buy? Let us help you:",
            "wizard_hero_title": "Answer a few questions to find your perfect match!",
            "or_browse_all": "OR BROWSE ALL MODELS",
            "toner_placeholder": "Enter a printer or toner model",
            "ink_placeholder": "Enter a printer or ink model",
            "toner_result_empty": "Please select a printer or toner model first",
            "ink_result_empty": "Please select a printer or ink model first",
            "toner_suitable": "Suitable Toner:",
            "ink_suitable": "Suitable Ink Series:",
            "recommended_models": "Recommended Models",
            "no_result": "No suitable models found, please try again.",
            "browse_all_models": "All Models",
            "based_on_choices": "Based on your choices:",
            "finder_toner_title": "Toner Finder",
            "finder_ink_title": "Ink Finder",
            "toner_helper": "<strong>Not sure which toner to use?</strong><br>Enter your <b>printer model</b> (e.g., LBP623), and we'll show you the compatible toner instantly!",
            "ink_helper": "<strong>Not sure which ink to use?</strong><br>Enter your <b>printer model</b> (e.g., TS8870), and we'll show you the compatible ink instantly!",
            "imagesquare_title": "Canon Image Square Virtual Assistant",
            "info_title": "Information",
            "group_cameras": "Cameras & Camcorders (EOS R)",
            "group_lenses": "Lenses (RF / RF-S)",
            "no_relevant_models": "No relevant models found",
            "btn_find_perfect_match": "Find my perfect match",
            "assistant_suffix": " Assistant",
            "spec_size": "Size: ",
            "spec_type": "Type: ",
            "spec_color": "Color: ",
            "spec_speed": "Print Speed: ",
            "spec_fax": "Fax: ",
            "spec_duplex": "Auto Duplex: ",
            "spec_adf": "ADF: ",
            "spec_single_pass": "Single-pass Auto Duplex Scan: ",
            "spec_wifi": "Wi-Fi: ",
            "spec_scan_res": "Scanner Res: ",
            "spec_resolution": "Resolution: ",
            "spec_af": "AF: ",
            "spec_fps": "FPS: ",
            "spec_video": "Max Video Res: ",
            "spec_card": "Memory Card: ",
            "spec_weight": "Weight: ",
            "spec_samples": "Sample Images:",
            "spec_supported_inks": "Ink models supported by {x}:",
            "spec_supported_papers": "Photo paper models supported by {x}:",
            "omni_ink_for_printer": "Ink models for {x}",
            "omni_paper_for_printer": "Photo paper models for {x}",
            "omni_toner_for_printer": "Toner models for {x}",
            "spec_applicable_for": "For",
            "spec_applicable_ink": "Suitable Ink",
            "spec_applicable_toner": "Suitable Toner",
            "spec_etc": "etc.",
            "val_monochrome": "Monochrome",
            "val_color": "Color",
            "val_colors": "{x} Colors",
            "val_speed_mono": "{x} ipm (B&W)",
            "val_speed_both": "{x} ipm (B&W), {y} ipm (Color)",
            "val_yes": "Yes",
            "val_no": "No",
            "val_megapixels": " MP",
            "val_fps_speed": "Up to {x} fps",
            "no_image": "No Image",
            "grp_ff": "Full Frame",
            "grp_apsc": "APS-C",
            "grp_prime": "Prime",
            "grp_zoom": "Zoom",
            "grp_inkjet": "PIXMA Inkjet Printers",
            "grp_portable": "PIXMA Portable Printers",
            "grp_refill": "PIXMA Refillable Printers",
            "grp_selphy": "SELPHY Compact Printers",
            "grp_inspic": "iNSPiC Portable Printers",
            "grp_laser": "imageCLASS Laser Printers",
            "price_prefix": "From ",
            "price_suffix": "",
            "grp_other_printers": "More Printers",
            "only_applicable_for": "Only applicable for: "
        }
    };
    
    let isEnMode = window.location.pathname.startsWith('/en') || window.location.pathname.includes('/en/');
    let lang = window.VA_CURRENT_LANG || (isEnMode ? "en" : "zh"); 
    let t = I18N[lang] || I18N["zh"];

    const getLangStr = (obj) => (typeof obj === 'object' && obj !== null) ? (obj[lang] || obj['zh'] || '') : obj;

    const VA_CONSUMABLE_CONFIG = {
        applyAll: false,
        whitelistHandles: ['pg-785-pg-795-cl-786-series']
    };

    const normalizeConsumable = s => (s || '').toString().toUpperCase().replace(/[^A-Z0-9]/g, '');

    const APP_CONFIG = {
        "menu_tree": {
            "root": [
                { id: "latest", label: {zh: "最新優惠", en: "Latest Offers"}, type: "mode", target: "latest_promos", image: "https://store.hk.canon/cdn/shop/files/canon-logo_800x800.png", tags: "優惠,推廣,promo,offer,sale,最新,discount,折扣,promotion,price" },
                { id: "cam", label: {zh: "相機、攝錄機", en: "Cameras & Camcorders"}, type: "submenu", target: "cam_sub", image: "https://store.hk.canon/cdn/shop/files/01_eos_r3_front_body_500_1.jpg", tags: "相機,無反,機身,camera,mirrorless,eos r,eos,cam" },
                { id: "lens", label: {zh: "鏡頭", en: "Lenses"}, type: "submenu", target: "lens_sub", image: "https://store.hk.canon/cdn/shop/files/01_rf70_200_f2.8_l_is_usm_z_wh_side_1200_1.jpg", tags: "鏡,鏡頭,大三元,lens,lenses,rf,微距" },
                { id: "print", label: {zh: "打印機", en: "Printers"}, type: "submenu", target: "print_sub", image: "https://store.hk.canon/cdn/shop/files/ts8851_as_fr_cl_wht_en_1.jpg", tags: "打印機,印表機,打單機,相片打印,printer,pixma,print" },
                { id: "ink", label: {zh: "墨水", en: "Ink Finder"}, type: "mode", target: "ink", image: "https://store.hk.canon/cdn/shop/files/pg-830bk_pi_500.jpg", tags: "墨,墨水,ink,cartridge,refill,color,加墨" },
                { id: "toner", label: {zh: "碳粉", en: "Toner Finder"}, type: "mode", target: "toner", image: "https://store.hk.canon/cdn/shop/files/crg070_front_oth_copy.jpg", tags: "碳粉,toner,cartridge,laser,雷射" },
                { id: "paper", label: {zh: "相紙", en: "Photo Paper"}, type: "submenu", target: "paper_sub", image: "https://store.hk.canon/cdn/shop/files/rp-108.jpg", tags: "相紙,紙,paper,photo paper,print media" },
                { id: "acc", label: {zh: "配件", en: "Accessories"}, type: "submenu", target: "acc_sub", image: "https://store.hk.canon/cdn/shop/files/lp-e6p_slant_1200.jpg", tags: "配件,acc,accessories,電池,battery,charger,火牛" },
                { id: "fans", label: {zh: "相機袋及 Canon 精品", en: "Camera Bags"}, type: "link", url: "https://store.hk.canon/collections/canon-fans-shop", image: "https://store.hk.canon/cdn/shop/files/untitled_design_6__1.jpg", tags: "fans,周邊,精品,merch,merchandise,premium,canon,禮品,袋,bag,backpack" },
                { id: "others", label: {zh: "其他", en: "Others"}, type: "submenu", target: "others_sub", image: "https://store.hk.canon/cdn/shop/files/sandisk_extreme_pro_v30_256gb_r180_w130__1.jpg", tags: "其他,others,scanner,掃瞄器,望遠鏡" }
            ],
            "cam_sub": [
                { id: "eosr", label: {zh: "EOS R 無反相機", en: "EOS R Mirrorless Cameras"}, type: "mode", target: "eosr", image: "https://store.hk.canon/cdn/shop/files/01_eos_r3_front_body_500_1.jpg", tags: "相機,無反,機身,camera,mirrorless,eos r,全片幅,ff,apsc,aps-cvlog,拍片,video" },
                { id: "powershot", label: {zh: "PowerShot 輕便相機", en: "PowerShot Compact Cameras"}, type: "link", url: "https://store.hk.canon/collections/powershot", image: "https://store.hk.canon/cdn/shop/files/v10_white_square_2.png", tags: "powershot,ps,dc,輕便相機,傻瓜機,拍片,compact camera,vlog,v1,v10,g7x,golf,video" },
                { id: "ixus", label: {zh: "IXUS 復古相機", en: "IXUS Retro Cameras"}, type: "link", url: "https://store.hk.canon/products/ixus-285-hs-a", image: "https://store.hk.canon/cdn/shop/files/ec399kai_std_fronttop_lh_silver_oth.jpg", tags: "ixus,復古,輕便相機,dc,ccd,retro,vintage,傻瓜機" },
                { id: "cinema_eos", label: {zh: "Cinema EOS 攝錄機", en: "Cinema EOS Camcorders"}, type: "link", url: "https://store.hk.canon/collections/camcorder", image: "https://store.hk.canon/cdn/shop/files/eos_c70_01_1.jpg", tags: "cinema,電影機,攝錄機,camcorder,cinema,ceos,cinema eos,c50,c70,拍片,video" },
                { id: "pro_cam", label: {zh: "專業攝錄機", en: "Professional Camcorders"}, type: "link", url: "https://store.hk.canon/collections/camcorder", image: "https://store.hk.canon/cdn/shop/files/xf605_slantleft.jpg", tags: "專業攝錄機,pro cam,xf,xa,camcorder,拍片,video" },
                { id: "dslr", label: {zh: "EOS 單反相機", en: "EOS DSLR Cameras"}, type: "link", url: "https://store.hk.canon/products/eos-1500d", image: "https://store.hk.canon/cdn/shop/files/pr_large_201267_2.jpg", tags: "單反,dslr,1500d" }
            ],
            "lens_sub": [
                { id: "rf_lens", label: {zh: "RF 鏡頭", en: "RF Lenses"}, type: "mode", target: "rf", image: "https://store.hk.canon/cdn/shop/files/01_rf70_200_f2.8_l_is_usm_z_wh_side_1200_1.jpg", tags: "rf鏡,無反鏡,rf lens,大三元,小三元,鏡,lens" },
                { id: "ef_lens", label: {zh: "EF 鏡頭", en: "EF Lenses"}, type: "link", url: "https://store.hk.canon/collections/ef-lens", image: "https://store.hk.canon/cdn/shop/files/pr_large_201140.jpg", tags: "ef鏡,單反鏡,ef lens,鏡,lens" },
                { id: "cinema_lens", label: {zh: "EF Cinema 電影鏡頭", en: "EF Cinema Lenses"}, type: "link", url: "https://store.hk.canon/collections/ef-cinema-lens", image: "https://store.hk.canon/cdn/shop/files/cn-e50mm-t1.3-fp-x.jpg", tags: "電影鏡,cinema lens,cn-e,鏡,lens,video" }
            ],
            "print_sub": [
                { id: "anyprinter", label: {zh: "我想你幫我揀", en: "Help me choose"}, type: "mode", target: "printer", image: "https://store.hk.canon/cdn/shop/files/01_as_fr_ts4070_bbg_w.jpg", tags: "揀打印機,help me choose printer,find printer" },
                { id: "pixma", label: {zh: "PIXMA 家用打印機", en: "PIXMA Home Printers"}, type: "mode", target: "printer_pixma", image: "https://store.hk.canon/cdn/shop/files/ts83xx_as_fr_cl2_red_en_resized_1_1_1_1.jpg", tags: "pixma,噴墨,inkjet,家用,home printer,印相,printer,打印機,scanner,掃瞄器,加墨,refill,ciss" },
                { id: "selphy", label: {zh: "SELPHY 輕便打印機", en: "SELPHY Compact Photo Printers"}, type: "mode", target: "printer_selphy", image: "https://store.hk.canon/cdn/shop/files/01_k525_rd_top_body.png", tags: "selphy,過膠,相片打印機,手機印相,photo printer,printer" },
                { id: "inspic", label: {zh: "iNSPiC 便攜式打印機", en: "iNSPiC Portable Printers"}, type: "mode", target: "printer_inspic", image: "https://store.hk.canon/cdn/shop/files/product_iNSPiC_PV-223-PK_front.jpg?v=1780023248&width=300", tags: "inspic,便攜,流動,portable,pocket,相片打印機,手機印相,photo printer,printer" },
                { id: "imageclass", label: {zh: "雷射打印機", en: "Laser Printers"}, type: "mode", target: "printer_laser", image: "https://store.hk.canon/cdn/shop/files/mf662cdw_rfront_1.jpg", tags: "imageclass,雷射,laser,鐳射,辦公室,office printer,碳粉機,printer,scanner,掃瞄器" },
                { id: "business", label: {zh: "商用噴墨打印機", en: "Business Inkjet Printers"}, type: "mode", target: "printer_business", image: "https://store.hk.canon/cdn/shop/files/fy23at_b2_as_fr_cl_en.jpg", tags: "商用,maxify,business,office,打單機,printer" },
                { id: "biz_sol", label: {zh: "商業文件方案", en: "Business Solutions"}, type: "link", url: "https://hk.canon/zh_HK/business", image: "https://hk.canon/media/image/2025/06/25/2425ce32b7124b7c87abb200301edc91_imageFORCE+Multi-function+Device+F_ASIA+01.png", tags: "商業方案,b2b,business solutions,影印機,copier,printer" }
            ],
            "paper_sub": [
                { id: "selphy_paper", label: {zh: "SELPHY 相紙", en: "SELPHY Photo Paper"}, type: "link", url: "https://store.hk.canon/collections/selphy-paper", image: "https://store.hk.canon/cdn/shop/files/rp-108.jpg", tags: "selphy相紙,相紙,paper" },
                { id: "photo_paper", label: {zh: "相紙及打印紙", en: "Photo Paper & Print Media"}, type: "link", url: "https://store.hk.canon/collections/paper", image: "https://store.hk.canon/cdn/shop/files/sg-201-4x6-_50__1.jpg", tags: "相紙,photo paper,光面,絨面,paper" },
                { id: "copier_paper", label: {zh: "影印紙", en: "Copier Paper"}, type: "link", url: "https://store.hk.canon/collections/paper", image: "https://store.hk.canon/cdn/shop/files/top_color_paper_2.jpg", tags: "影印紙,a4紙,白紙,copy paper,a4 paper,paper" }
            ],
            "acc_sub": [
                { id: "eos_acc", label: {zh: "EOS 系統配件", en: "EOS Accessories"}, type: "link", url: "https://store.hk.canon/collections/eos-camera-accessory", image: "https://store.hk.canon/cdn/shop/files/lp-e6p_slant_1200.jpg", tags: "相機配件,電池,火牛,快門線,袋,bag,backpack,battery,charger,acc" },
                { id: "lens_acc", label: {zh: "鏡頭配件", en: "Lens Accessories"}, type: "link", url: "https://store.hk.canon/collections/lens-accessory", image: "https://store.hk.canon/cdn/shop/files/lens_hood_ew-83p_1_1.jpg", tags: "鏡頭配件,遮光罩,filter,濾鏡,hood,acc" },
                { id: "flash_acc", label: {zh: "Speedlite 閃光燈", en: "Speedlite Flashes"}, type: "link", url: "https://store.hk.canon/collections/speedlite", image: "https://store.hk.canon/cdn/shop/files/01_el-1_ver.2__thefront_1200.jpg", tags: "閃光燈,閃燈,speedlite,flash,打燈,acc" },
                { id: "compact_acc", label: {zh: "輕便相機配件", en: "Compact Camera Accessories"}, type: "link", url: "https://store.hk.canon/collections/digital-compact-camera-accessory", image: "https://store.hk.canon/cdn/shop/files/nb-13l_b-holo.jpg", tags: "輕便相機配件,compact acc,acc,相機配件,電池,火牛,battery,charger" },
                { id: "video_acc", label: {zh: "攝錄機配件", en: "Camcorder Accessories"}, type: "link", url: "https://store.hk.canon/collections/camcorder-accessory", image: "https://store.hk.canon/cdn/shop/files/bp-a60_1.jpg", tags: "攝錄機配件,video acc,acc,相機配件,電池,火牛,battery,charger" },
                { id: "print_acc", label: {zh: "打印機配件", en: "Printer Accessories"}, type: "link", url: "https://store.hk.canon/collections/printer-accessory", image: "https://store.hk.canon/cdn/shop/files/px_large_61156.jpg", tags: "打印機配件,墨盒,print acc,acc,電池,火牛,battery,charger" }
            ],
            "others_sub": [
                { id: "scanner", label: {zh: "掃瞄器", en: "Scanners"}, type: "link", url: "https://store.hk.canon/collections/scanner", image: "https://store.hk.canon/cdn/shop/files/p1.jpg", tags: "掃瞄器,scanner,scan" },
                { id: "binocular", label: {zh: "望遠鏡", en: "Binoculars"}, type: "link", url: "https://store.hk.canon/collections/binocular", image: "https://store.hk.canon/cdn/shop/files/18x50is_slant_500_1.jpg", tags: "望遠鏡,binocular,睇演唱會,觀鳥" },
                { id: "memorycard", label: {zh: "記憶卡", en: "Memory Cards"}, type: "link", url: "https://store.hk.canon/collections/memory-card", image: "https://store.hk.canon/cdn/shop/files/sandisk_extreme_pro_v30_256gb_r180_w130__1.jpg", tags: "記憶卡,sd卡,cfexpress,memory card,sd card,cfast" }
            ]
        },
        
        "printer": {
            headerTitle: {zh: "打印機", en: "Printers"}, title: {zh: "答幾條問題，就搵到最啱你嘅型號", en: "Answer a few questions to find your perfect match!"}, dbKey: "PRINTER_DB",
            baseFilter: p => true,
            steps: [
                { id: "type", question: {zh: "你想要咩類型嘅打印機？", en: "Which type of printer do you want?"}, options: [
                    { label: {zh: "無所謂", en: "Doesn't matter"}, value: "all" },
                    { label: {zh: "噴墨 (彩色更靚)", en: "Inkjet (Better colors)"}, value: "inkjet" },
                    { label: {zh: "雷射 (啲字防水唔化開)", en: "Laser (Waterproof text)"}, value: "laser" },
                    { label: {zh: "細細部", en: "Compact"}, value: "compact" }
                ], matcher: (p, s) => {
                    let type = (p.type || '').toString().toLowerCase().trim();
                    if(s === 'inkjet') return type === 'inkjet' || type === 'inkjet_portable' || type === 'inkjet_refill';
                    if(s === 'laser') return type === 'laser';
                    if(s === 'compact') return type === 'selphy' || type === 'inkjet_portable' || type === 'inspic';
                    return true;
                }},
                { id: "photo", question: {zh: "會印啲咩？", en: "What will you print?"}, options: [
                    { label: {zh: "印相", en: "Photos"}, value: "Y" },
                    { label: {zh: "印文件、功課", en: "Documents / Homework"}, value: "doc" }
                ], matcher: (p, s) => {
                    if (s === 'Y') return (p.photo||'').toString().trim() === 'Y';
                    let type = (p.type || '').toString().toLowerCase().trim();
                    return type !== 'selphy' && type !== 'inspic';
                }},
                { id: "size", question: {zh: "打印尺寸需要去到幾大？", en: "What is the maximum print size?"}, options: [
                    { label: {zh: "2R", en: "2R"}, value: "2R" },
                    { label: {zh: "4R", en: "4R"}, value: "4R" },
                    { label: {zh: "A4", en: "A4"}, value: "A4" },
                    { label: {zh: "A3 或 A3+", en: "A3 or A3+"}, value: "A3" },
                    { label: {zh: "A2", en: "A2"}, value: "A2" }
                ], matcher: (p, s) => {
                    let size = (p.size||'').toString().trim().toUpperCase();
                    let type = (p.type||'').toString().toLowerCase().trim();
                    if(s === '2R') return size === '2R' || size.includes('CARD-SIZE') || ['4R','A4','A3','A3+','A2'].includes(size);
                    if(s === '4R') return ['4R','A4','A3','A3+','A2'].includes(size);
                    if(s === 'A4') return ['A4','A3','A3+','A2'].includes(size);
                    if(s === 'A3') return ['A3','A3+','A2'].includes(size);
                    if(s === 'A2') return size === 'A2';
                    return false;
                }},
                { id: "color", question: {zh: "要印彩色定黑白？", en: "Color or Monochrome?"}, options: [
                    { label: {zh: "彩色", en: "Color"}, value: "color" },
                    { label: {zh: "黑白", en: "Monochrome"}, value: "mono" }
                ], matcher: (p, s) => {
                    let c = parseInt(p.color) || 0;
                    let type = (p.type || '').toString().toLowerCase().trim();
                    if (s === 'color') return c >= 2 || type === 'selphy' || type === 'inspic';
                    if (s === 'mono') return c === 1;
                    return false;
                }},
                { id: "scan", question: {zh: "需要掃瞄器嗎？", en: "Do you need a scanner?"}, options: [
                    { label: {zh: "需要", en: "Yes"}, value: "Y" },
                    { label: {zh: "唔需要", en: "No"}, value: "N" }
                ], matcher: (p, s) => {
                    const hasScan = p.scanRes && p.scanRes !== 'N' && p.scanRes.toString().trim() !== '' && p.scanRes.toString().trim() !== '-';
                    return s === 'Y' ? hasScan : !hasScan;
                }},
                { id: "duplex", question: {zh: "需要自動雙面打印嗎？", en: "Do you need auto duplex printing?"}, options: [
                    { label: {zh: "需要", en: "Yes"}, value: "Y" },
                    { label: {zh: "唔需要", en: "No"}, value: "N" }
                ], matcher: (p, s) => {
                    if (s === 'Y') return (p.duplex||'').toString().trim() === 'Y';
                    return true;
                }},
                { id: "speed", question: {zh: "對打印速度有咩要求？", en: "Any requirements on print speed?"}, options: [
                    { label: {zh: "無所謂", en: "Doesn't matter"}, value: "all" },
                    { label: {zh: "每分鐘 20-29 張", en: "20-29 pages per min"}, value: "mid" },
                    { label: {zh: "每分鐘 30 張或以上", en: "30+ pages per min"}, value: "high" }
                ], matcher: (p, s) => {
                    if (s === 'all') return true;
                    let sp = parseInt(p.speedMono)||0;
                    if (s === 'mid') return sp >= 20 && sp <= 29;
                    if (s === 'high') return sp >= 30;
                    return false;
                }},
                { id: "fax", question: {zh: "需要 Fax 傳真功能嗎？", en: "Do you need fax functionality?"}, options: [
                    { label: {zh: "需要", en: "Yes"}, value: "Y" },
                    { label: {zh: "唔需要", en: "No"}, value: "N" }
                ], matcher: (p, s) => s === 'Y' ? (p.fax||'').toString().trim() === 'Y' : (p.fax||'').toString().trim() === 'N' }
            ]
        },
        "printer_pixma": {
            headerTitle: {zh: "PIXMA 家用打印機", en: "PIXMA Home Printers"}, title: {zh: "答幾條問題，就搵到最啱你嘅型號", en: "Answer a few questions to find your perfect match!"}, dbKey: "PRINTER_DB",
            baseFilter: p => ['inkjet', 'inkjet_refill', 'inkjet_portable'].includes((p.type || '').toString().toLowerCase().trim()) && !(p.model || '').toUpperCase().includes('MAXIFY'),
            steps: [
                { id: "photo", question: {zh: "你會印啲咩？", en: "What will you print?"}, options: [ { label: {zh: "印相", en: "Photos"}, value: "Y" }, { label: {zh: "印文件、功課", en: "Documents / Homework"}, value: "N" } ], matcher: (p, s) => s === 'Y' ? (p.photo||'').toString().trim() === 'Y' : true },
                { id: "size", question: {zh: "打印尺寸需要去到幾大？", en: "What is the maximum print size?"}, options: [ { label: {zh: "A4", en: "A4"}, value: "A4" }, { label: {zh: "A3 或 A3+", en: "A3 or A3+"}, value: "A3" }, { label: {zh: "A2", en: "A2"}, value: "A2" } ], matcher: (p, s) => {
                    let size = (p.size||'').toString().trim().toUpperCase();
                    if(s === 'A4') return true;
                    if(s === 'A3') return ['A3','A3+','A2'].includes(size);
                    if(s === 'A2') return size === 'A2';
                    return false;
                }},
                { id: "scan", question: {zh: "需要掃瞄器嗎？", en: "Do you need a scanner?"}, options: [ { label: {zh: "需要", en: "Yes"}, value: "Y" }, { label: {zh: "唔需要", en: "No"}, value: "N" } ], matcher: (p, s) => { const hasScan = p.scanRes && p.scanRes !== 'N' && p.scanRes.toString().trim() !== '' && p.scanRes.toString().trim() !== '-'; return s === 'Y' ? hasScan : !hasScan; } },
                { id: "duplex", question: {zh: "需要自動雙面打印嗎？", en: "Do you need auto duplex printing?"}, options: [ { label: {zh: "需要", en: "Yes"}, value: "Y" }, { label: {zh: "唔需要", en: "No"}, value: "N" } ], matcher: (p, s) => s === 'Y' ? (p.duplex||'').toString().trim() === 'Y' : true },
                { id: "fax", question: {zh: "需要 Fax 傳真功能嗎？", en: "Do you need fax functionality?"}, options: [ { label: {zh: "需要", en: "Yes"}, value: "Y" }, { label: {zh: "唔需要", en: "No"}, value: "N" } ], matcher: (p, s) => s === 'Y' ? (p.fax||'').toString().trim() === 'Y' : (p.fax||'').toString().trim() === 'N' }
            ]
        },
        "printer_selphy": {
            headerTitle: {zh: "SELPHY 輕便打印機", en: "SELPHY Compact Photo Printers"}, title: {zh: "答幾條問題，就搵到最啱你嘅型號", en: "Answer a few questions to find your perfect match!"}, dbKey: "PRINTER_DB",
            baseFilter: p => (p.type || '').toString().toLowerCase().trim() === 'selphy',
            steps: [
                { id: "size", question: {zh: "打印尺寸需要去到幾大？", en: "What is the maximum print size?"}, options: [ { label: {zh: "2R", en: "2R"}, value: "2R" }, { label: {zh: "4R", en: "4R"}, value: "4R" } ], matcher: (p, s) => {
                    let size = (p.size||'').toString().trim().toUpperCase();
                    if(s === '2R') return true;
                    if(s === '4R') return ['4R','A4','A3','A3+','A2'].includes(size);
                    return false;
                }}
            ]
        },
        "printer_inspic": {
            headerTitle: {zh: "iNSPiC 便攜式打印機", en: "iNSPiC Portable Printers"}, title: {zh: "iNSPiC 系列", en: "iNSPiC Series"}, dbKey: "PRINTER_DB",
            baseFilter: p => /inspic/i.test(p.type || ''),
            skipWizard: true,
            steps: []
        },
        "printer_laser": {
            headerTitle: {zh: "雷射打印機", en: "Laser Printers"}, title: {zh: "答幾條問題，就搵到最啱你嘅型號", en: "Answer a few questions to find your perfect match!"}, dbKey: "PRINTER_DB",
            baseFilter: p => (p.type || '').toString().toLowerCase().trim() === 'laser',
            steps: [
                { id: "color", question: {zh: "你要印彩色定黑白？", en: "Color or Monochrome?"}, options: [ { label: {zh: "彩色", en: "Color"}, value: "color" }, { label: {zh: "黑白", en: "Monochrome"}, value: "mono" } ], matcher: (p, s) => {
                    let c = parseInt(p.color) || 0;
                    if (s === 'color') return c >= 2;
                    if (s === 'mono') return c === 1;
                    return false;
                }},
                { id: "scan", question: {zh: "需要掃瞄器嗎？", en: "Do you need a scanner?"}, options: [ { label: {zh: "需要", en: "Yes"}, value: "Y" }, { label: {zh: "唔需要", en: "No"}, value: "N" } ], matcher: (p, s) => { const hasScan = p.scanRes && p.scanRes !== 'N' && p.scanRes.toString().trim() !== '' && p.scanRes.toString().trim() !== '-'; return s === 'Y' ? hasScan : !hasScan; } },
                { id: "duplex", question: {zh: "需要自動雙面打印嗎？", en: "Do you need auto duplex printing?"}, options: [ { label: {zh: "需要", en: "Yes"}, value: "Y" }, { label: {zh: "唔需要", en: "No"}, value: "N" } ], matcher: (p, s) => s === 'Y' ? (p.duplex||'').toString().trim() === 'Y' : (p.duplex||'').toString().trim() === 'N' },
                { id: "speed", question: {zh: "對打印速度有咩要求？", en: "Any requirements on print speed?"}, options: [ { label: {zh: "每分鐘 20 張以下", en: "Under 20 pages/min"}, value: "low" }, { label: {zh: "每分鐘 20-29 張", en: "20-29 pages/min"}, value: "mid" }, { label: {zh: "每分鐘 30 張或以上", en: "30+ pages/min"}, value: "high" } ], matcher: (p, s) => { let sp = parseInt(p.speedMono)||0; if(s==='low') return sp<=19; if(s==='mid') return sp>=20 && sp<=29; if(s==='high') return sp>=30; return false; } },
                { id: "fax", question: {zh: "需要 Fax 傳真功能嗎？", en: "Do you need fax functionality?"}, options: [ { label: {zh: "需要", en: "Yes"}, value: "Y" }, { label: {zh: "唔需要", en: "No"}, value: "N" } ], matcher: (p, s) => s === 'Y' ? (p.fax||'').toString().trim() === 'Y' : (p.fax||'').toString().trim() === 'N' }
            ]
        },
        "printer_business": {
            headerTitle: {zh: "商用噴墨打印機", en: "Business Inkjet Printers"}, title: {zh: "答幾條問題，就搵到最啱你嘅型號", en: "Answer a few questions to find your perfect match!"}, listTitle: {zh: "商用噴墨打印機", en: "Business Inkjet Printers"}, dbKey: "PRINTER_DB",
            baseFilter: p => (p.model || '').toUpperCase().includes('MAXIFY'),
            steps: [
                { id: "fax", question: {zh: "你需要 Fax 傳真功能嗎？", en: "Do you need fax functionality?"}, options: [ { label: {zh: "需要", en: "Yes"}, value: "Y" }, { label: {zh: "唔需要", en: "No"}, value: "N" } ], matcher: (p, s) => s === 'Y' ? (p.fax||'').toString().trim() === 'Y' : (p.fax||'').toString().trim() === 'N' }
            ]
        },
        "eosr": {
            headerTitle: {zh: "EOS R 無反相機", en: "EOS R Mirrorless Cameras"}, title: {zh: "答幾條問題，就搵到最啱你嘅型號", en: "Answer a few questions to find your perfect match!"}, dbKey: "CAMERA_DB",
            baseFilter: p => true,
            steps: [
                { id: "sensor", question: {zh: "你想要咩類型嘅相機？", en: "Which type of camera do you want?"}, options: [ { label: {zh: "全片幅 (啲相明顯靚過手機)", en: "Full Frame (Noticeably better quality)"}, value: "Full Frame" }, { label: {zh: "APS-C (部機輕巧啲)", en: "APS-C (More compact)"}, value: "APS-C" } ], matcher: (p, s) => (p.sensor||'').toString().trim() === s },
                { id: "resolution", question: {zh: "需要幾多像素？", en: "How many megapixels do you need?"}, options: [ { label: {zh: "無所謂", en: "Doesn't matter"}, value: "all" }, { label: {zh: "3000萬或以上", en: "30MP or above"}, value: "30" }, { label: {zh: "4000萬或以上 (多啲裁相空間)", en: "40MP or above (More cropping flexibility)"}, value: "40" } ], matcher: (p, s) => {
                    if (s === 'all') return true;
                    let res = parseFloat(p.resolution) || 0;
                    if (s === '30') return res >= 30;
                    if (s === '40') return res >= 40;
                    return false;
                }},
                { id: "video", question: {zh: "拍片最多需要幾多解像度？", en: "What is the maximum video resolution you need?"}, options: [ { label: {zh: "無所謂", en: "Doesn't matter"}, value: "all" }, { label: {zh: "6K", en: "6K"}, value: "6K" }, { label: {zh: "8K", en: "8K"}, value: "8K" } ], matcher: (p, s) => {
                    if (s === 'all') return true;
                    let vid = (p.video||'').toString().toUpperCase();
                    if (s === '6K') return vid.includes('6K') || vid.includes('7K') || vid.includes('8K');
                    if (s === '8K') return vid.includes('8K');
                    return false;
                }}
            ]
        },
        "rf": {
            headerTitle: {zh: "RF 鏡頭", en: "RF Lenses"}, title: {zh: "答幾條問題，就搵到最啱你嘅型號", en: "Answer a few questions to find your perfect match!"}, dbKey: "LENS_DB",
            baseFilter: p => true,
            steps: [
                { id: "type", question: {zh: "你想要咩類型嘅鏡頭？", en: "Which type of lens do you want?"}, options: [ 
                    { label: {zh: "變焦鏡頭", en: "Zoom Lenses"}, value: "Zoom" }, 
                    { label: {zh: "定焦鏡頭", en: "Prime Lenses"}, value: "Fixed" },
                    { label: {zh: "RF-S 鏡頭 (APS-C 專用)", en: "RF-S Lenses (For APS-C)"}, value: "RFS" },
                    { label: {zh: "VR 鏡頭", en: "VR Lenses"}, value: "VR" },
                    { label: {zh: "增距鏡及轉接環", en: "Extenders & Adapters"}, value: "Extender" }
                ], matcher: (p, s) => { 
                    let t = (p.type||'').toString();
                    if (s === 'Zoom') return t.includes('變焦');
                    if (s === 'Fixed') return t.includes('定焦');
                    if (s === 'RFS') return t.includes('RF-S');
                    if (s === 'VR') return t.includes('VR');
                    if (s === 'Extender') return t.includes('增距鏡');
                    return false;
                }},
                { id: "focal", question: {zh: "想要咩焦距？", en: "Which focal length?"}, options: [ 
                    { label: {zh: "超廣角", en: "Ultra Wide"}, value: "ultra" }, 
                    { label: {zh: "廣角", en: "Wide"}, value: "wide" }, 
                    { label: {zh: "標準 (及中距)", en: "Standard (& Medium Telephoto)"}, value: "standard" }, 
                    { label: {zh: "遠攝 (及超遠攝)", en: "Telephoto (& Super Telephoto)"}, value: "tele" } 
                ], matcher: (p, s) => {
                    let t = (p.type||'').toString();
                    if (s === 'ultra') return t.includes('超廣角');
                    if (s === 'wide') return t.includes('廣角') && !t.includes('超廣角');
                    if (s === 'standard') return t.includes('標準');
                    if (s === 'tele') return t.includes('遠攝');
                    return false;
                }},
                { id: "aperture", question: {zh: "想要幾大光圈？", en: "What aperture size?"}, options: [ 
                    { label: {zh: "無所謂", en: "Doesn't matter"}, value: "all" }, 
                    { label: {zh: "大光圈 (f/2.8 或以上)", en: "Large (f/2.8+)"}, value: "large" }, 
                    { label: {zh: "超大光圈 (f/1.8 或以上)", en: "Super Large (f/1.8+)"}, value: "superlarge" } 
                ], matcher: (p, s) => {
                    if (s === 'all') return true;
                    let a = parseFloat(p.apertureLarge) || 99;
                    if (s === 'large') return a <= 2.8;
                    if (s === 'superlarge') return a <= 1.8;
                    return false;
                }}
            ]
        }
    };

    let productData = {};
    let finderState = { 
        mode: 'full', history: [], 
        currentMenuId: 'root', currentMenuTitle: '',
        currentConfig: null, wizardStepIdx: 0, currentProducts: [],
        isHubMode: false
    };

    function processData(rawDb) {
        const processedCAMERA = (rawDb.CAMERA || []).map(row => {
            let displayPrice = row[7] ? row[7] : row[6]; 
            let pVaries = (row[12] && row[12].toString().trim() !== '') ? true : false;
            
            let handle = row[1] ? row[1].toString().trim() : (row[0]||'').toLowerCase().replace(/\s+/g, '-');
            let img = row[39];
            let url = row[40];
            
            if (typeof window.VA_LIQUID_PRICES !== 'undefined' && window.VA_LIQUID_PRICES[handle]) {
                if (!img || img.toString().trim() === '') img = window.VA_LIQUID_PRICES[handle].image;
                if (!url || url.toString().trim() === '') url = window.VA_LIQUID_PRICES[handle].url;
            }

            return {
                model: row[0], sku: handle, camType: row[2], price: displayPrice,
                price_min: displayPrice, compare_at_max: row[7] ? row[6] : null, price_varies: pVaries,
                image: img, url: url, weight: row[41], sensor: row[42], 
                resolution: row[43], af: row[44], ibis: row[45], fps: row[46], 
                video: row[47], card: row[48], 
                f1_en: row[49], f1_tc: row[50], 
                f2_en: row[51], f2_tc: row[52], 
                f3_en: row[53], f3_tc: row[54], 
                kv_en: row[55], 
                kv_tc: row[56] || row[55],
                tvc: row[57] || null,
                features_en: row[49], features_tc: row[50] 
            };
        });
        
        const processedLENS = (rawDb.LENS || []).map(row => {
            const sampleImages = [];
            for (let i = 18; i <= 27; i++) {
                if (row[i] && row[i].toString().trim() !== '') sampleImages.push(row[i].toString().trim());
            }
            let displayPrice = row[3] ? row[3] : row[2]; 
            
            let modelName = row[0];
            if (lang === 'en') {
                if (modelName.includes('插入式濾鏡')) modelName = 'Drop-in Filter Mount Adapter EF-EOS R';
                else if (modelName.includes('控制環')) modelName = 'Control Ring Mount Adapter EF-EOS R';
                else if (modelName.includes('鏡頭轉接器 EF-EOS R')) modelName = 'Mount Adapter EF-EOS R';
            }

            let handle = row[1] ? row[1].toString().trim() : (row[0]||'').toLowerCase().replace(/\s+/g, '-');
            let img = row[5];
            let url = row[6];

            if (typeof window.VA_LIQUID_PRICES !== 'undefined' && window.VA_LIQUID_PRICES[handle]) {
                if (!img || img.toString().trim() === '') img = window.VA_LIQUID_PRICES[handle].image;
                if (!url || url.toString().trim() === '') url = window.VA_LIQUID_PRICES[handle].url;
            }

            return {
                model: modelName, sku: handle, price: displayPrice, image: img, url: url,
                price_min: displayPrice, compare_at_max: row[3] ? row[2] : null, price_varies: false,
                weight: row[7], focalLow: row[8], focalHigh: row[9], 
                apertureLarge: row[10], apertureZoom: row[11], 
                is: row[12], type: row[13], hybrid: row[14], powerZoom: row[15], 
                f_en: row[16], f_tc: row[17],
                samples: sampleImages,
                features_en: row[16], features_tc: row[17]
            };
        });

        const processedPrinter = (rawDb.PRINTER || []).map(row => {
            let displayPrice = row[3] ? row[3] : row[2]; 
            
            let handle = row[1] ? row[1].toString().trim() : (row[0]||'').toLowerCase().replace(/\s+/g, '-');
            let img = row[4];
            let url = row[5];

            if (typeof window.VA_LIQUID_PRICES !== 'undefined' && window.VA_LIQUID_PRICES[handle]) {
                if (!img || img.toString().trim() === '') img = window.VA_LIQUID_PRICES[handle].image;
                if (!url || url.toString().trim() === '') url = window.VA_LIQUID_PRICES[handle].url;
            }

            return {
                model: row[0], sku: handle, price: displayPrice, image: img, url: url,
                price_min: displayPrice, compare_at_max: row[3] ? row[2] : null, price_varies: false,
                type: row[6], size: row[7], color: row[8], photo: row[9], fax: row[10],
                speedMono: row[11], speedColor: row[12], duplex: row[13], adf: row[14],
                scanRes: row[15], singlePass: row[16], wifi: row[17], display: row[18],
                features_en: row[19], features_tc: row[20]
            };
        });

        const getBaseModels = (name) => {
            if (!name) return [];
            let clean = name.toLowerCase().replace(/twin pack|value pack|vp|fax cartridge|series/g, '').trim();
            let results = [];

            let m1 = clean.match(/([a-z]+[\s-]*\d+)/g);
            if (m1) {
                m1.forEach(m => {
                    let base = m.replace(/\s+/g, '-');
                    results.push(base);
                    if (base.startsWith('drum-')) {
                        results.push(base.replace('drum-', 'cartridge-'));
                        results.push(base.replace('drum-', ''));
                    }
                });
            }

            let m2 = clean.match(/(ep-[a-z])/g);
            if (m2) m2.forEach(m => results.push(m.replace(/\s+/g, '-')));

            let fallback = clean
                .replace(/\b(xl|xxl|h|l|ii|bk|c|m|y|gy|pbk|mbk|pc|pm|r|g|dgy|lgy|pgy|co|b|pb)\b/g, '')
                .replace(/[^a-z0-9]+/g, '-')
                .replace(/^-+|-+$/g, '');
            if (fallback) results.push(fallback);

            return [...new Set(results)].filter(Boolean);
        };

        const findLiquidMatch = (baseModels) => {
            if (typeof window.VA_LIQUID_PRICES === 'undefined' || !window.VA_LIQUID_PRICES) return null;
            const liquidKeys = Object.keys(window.VA_LIQUID_PRICES);

            for (let base of baseModels) {
                if (!base) continue;
                let regex = new RegExp(`(^|-)${base}(-|$)`, 'i');
                let matchedKey = liquidKeys.find(k => regex.test(k));
                if (matchedKey) return { sku: matchedKey, data: window.VA_LIQUID_PRICES[matchedKey] };
            }
            return null;
        };

        const processConsumables = (rawRows) => {
            let results = [];
            rawRows.forEach(row => {
                let printerModel = row[0];
                let seriesNameFallback = row[1]; 
                let rawItems = [];
                for (let j = 4; j < row.length; j++) {
                    if (row[j] && row[j].toString().trim() !== '') {
                        rawItems.push(row[j].toString().trim());
                    }
                }

                let liquidMatches = new Map();

                rawItems.forEach(item => {
                    let bases = getBaseModels(item);
                    let match = findLiquidMatch(bases);
                    if (match) {
                        if (!liquidMatches.has(match.sku)) {
                            liquidMatches.set(match.sku, { data: match.data, inks: new Set() });
                        }
                        liquidMatches.get(match.sku).inks.add(item);
                    }
                });

                liquidMatches.forEach((val, sku) => {
                    let title = val.data.title || seriesNameFallback || val.inks.values().next().value;
                    results.push({
                        m: printerModel,
                        t: title,
                        i: val.data.image || '',
                        u: val.data.url || '',
                        sku: sku,
                        inks: Array.from(val.inks)
                    });
                });
            });
            return results;
        };

        const processedToner = processConsumables(rawDb.TONER || []);
        const processedInk = processConsumables(rawDb.INK || []);

        return { 
            CAMERA_DB: processedCAMERA,
            LENS_DB: processedLENS,
            PRINTER_DB: processedPrinter,
            TONER_DB: processedToner, 
            INK_DB: processedInk 
        };
    }

    function applyI18N() {
        let isISQ = (typeof finderState !== 'undefined' && finderState.initialMode === 'imagesquare') || window.VIRTUAL_ASSISTANT_MODE === 'imagesquare';
        document.getElementById('app-title').innerHTML = isISQ ? t.imagesquare_title : t.assistant_title;
        document.getElementById('canonOmniInput').placeholder = t.search_placeholder;
        const searchLabel = document.querySelector('.home-search-label');
        if (searchLabel) searchLabel.innerHTML = `${t.home_search_title}<span class="home-search-sub">${t.home_search_sub}</span>`;
        const menuTitle = document.getElementById('home-menu-title-text');
        if (menuTitle) menuTitle.innerText = t.home_menu_title;
        const hubHeroTitle = document.getElementById('hub-hero-title');
        if (hubHeroTitle) hubHeroTitle.innerText = t.wizard_hero_title;
        const divSpan = document.querySelector('.canon-hub-divider span');
        if (divSpan) divSpan.innerText = t.or_browse_all;
        document.getElementById('canonTonerInput').placeholder = t.toner_placeholder;
        document.getElementById('canonInkInput').placeholder = t.ink_placeholder;
        const tonerHelper = document.querySelector('#view-toner .canon-finder__helper-text');
        if (tonerHelper) tonerHelper.innerHTML = t.toner_helper;
        const inkHelper = document.querySelector('#view-ink .canon-finder__helper-text');
        if (inkHelper) inkHelper.innerHTML = t.ink_helper;
        document.getElementById('canonTonerMetaLabel').innerText = t.toner_suitable;
        document.getElementById('canonInkMetaLabel').innerText = t.ink_suitable;
        const resultTitle = document.getElementById('result-header-title');
        if (resultTitle) resultTitle.innerText = t.recommended_models;
        const btnRestart = document.getElementById('btn-restart-wizard');
        if (btnRestart) btnRestart.innerText = t.btn_restart;
        const tonerQBtn = document.getElementById('canonTonerQuickBuyBtn');
        if (tonerQBtn) tonerQBtn.innerText = lang === 'zh' ? '幫我落埋單' : 'Quick Buy';
        const inkQBtn = document.getElementById('canonInkQuickBuyBtn');
        if (inkQBtn) inkQBtn.innerText = lang === 'zh' ? '幫我落埋單' : 'Quick Buy';
        const tonerBuyBtn = document.getElementById('canonTonerBuyBtn');
        if (tonerBuyBtn) tonerBuyBtn.innerText = lang === 'zh' ? '詳情' : 'Details';
        const inkBuyBtn = document.getElementById('canonInkBuyBtn');
        if (inkBuyBtn) inkBuyBtn.innerText = lang === 'zh' ? '詳情' : 'Details';
        document.getElementById('canonTonerName').innerText = t.toner_result_empty;
        document.getElementById('canonInkName').innerText = t.ink_result_empty;
        document.querySelectorAll('.quick-tags-label').forEach(el => el.innerText = t.hot_tags);
    }

    function init(targetMode) {
        applyI18N();
        
        if (!window.CANON_GLOBAL_DATA || !window.CANON_GLOBAL_DATA.PRODUCT_DB) {
            console.warn("window.CANON_GLOBAL_DATA.PRODUCT_DB missing. Using fallback dummy data for rendering.");
            window.CANON_GLOBAL_DATA = window.CANON_GLOBAL_DATA || {};
            window.CANON_GLOBAL_DATA.PRODUCT_DB = {
                CAMERA: [["系統更新中", "eos-r1", "EOS R", "", "", "機身", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "https://store.hk.canon/cdn/shop/files/01_eos_r1_front_body_1200.jpg", "https://store.hk.canon/products/eos-r1", "1115", "Full Frame", "24.2", "Advanced AI Autofocus", "Y", "40", "6K DCI RAW 60p", "2 x CFexpress Type-B", "", "專業可靠", "", "高速", "", "", "https://store.hk.canon/cdn/shop/files/R1-banner_3.jpg", "https://store.hk.canon/cdn/shop/files/R1-banner_2.jpg", ""]],
                LENS: [["系統更新中", "extender-rf1-4x", "", "", "", "https://store.hk.canon/cdn/shop/files/extender_rf1.4x_side_1200.jpg", "https://store.hk.canon/products/extender-rf-1-4x", "", "", "", "", "", "N", "增距鏡及鏡頭轉接環|Extenders & Mount Adapters", "N", "N", "", "", "", "", "", "", "", "", "", "", "", ""]],
                PRINTER: [
                    ["系統更新中", "imageprograf-pro-310", "", "", "https://store.hk.canon/cdn/shop/files/pro310_as_fr_eur_asa.jpg", "https://store.hk.canon/products/imageprograf-pro-310", "Inkjet", "A3+", "10", "Y", "N", null, null, "N", "N", "N", "N", "Y", "3\" LCD", "Professional Photo Quality", "專業級相片質素"],
                    ["系統更新中", "pixma-e4570", "", "", "https://store.hk.canon/cdn/shop/files/e45xx_series_as_fr.jpg", "https://store.hk.canon/products/pixma-e4570", "Inkjet", "A4", "4", "N", "Y", 8.8, 4.4, "Y", "Y", "600x1200", "N", "Y", "2-line LCD", "High Page Yield, Low Printing Cost", "高印量，低打印成本"]
                ],
                TONER: [["系統更新中", "Cartridge 326", "https://store.hk.canon/cdn/shop/files/326_resized.jpg", "https://store.hk.canon/products/cartridge-326"]],
                INK: [["系統更新中", "PG-740 / CL-741", "https://store.hk.canon/cdn/shop/files/smb-ink-740.jpg", "", "PG-740", "PG-740XL", "CL-741", "CL-741XL", "PG-740XL + CL-741XL Value Pack , PG-740XL Twin Pack", "", "", "", "", "", "", "", "", "", "", "", "", "", "", ""]]
            };
        }

        window.reloadVAData = function() {
            if (!window.CANON_GLOBAL_DATA || !window.CANON_GLOBAL_DATA.PRODUCT_DB) return;
            
            productData = processData(window.CANON_GLOBAL_DATA.PRODUCT_DB);

            if (typeof window.VA_LIQUID_PRICES !== 'undefined') {
                let addedHandles = new Set();
                ['CAMERA_DB', 'LENS_DB', 'PRINTER_DB', 'TONER_DB', 'INK_DB'].forEach(key => {
                    productData[key].forEach(p => addedHandles.add(p.sku || ''));
                });

                for (let handle in window.VA_LIQUID_PRICES) {
                    if (addedHandles.has(handle)) continue;

                    let item = window.VA_LIQUID_PRICES[handle];
                    let hLower = handle.toLowerCase();
                    let tLower = (item.title || '').toLowerCase();

                    let orphan = {
                        model: item.title, sku: handle, price: item.price / 100,
                        compare_at_max: item.compare_at ? item.compare_at / 100 : null,
                        price_varies: item.price_varies, image: item.image, url: item.url,
                        features_en: '', features_tc: '', isOrphan: true
                    };

                    if (hLower.includes('pixma') || hLower.includes('selphy') || hLower.includes('imageclass') || hLower.includes('maxify') || hLower.includes('printer') || tLower.includes('打印機')) {
                        if (hLower.includes('pixma-g')) {
                            orphan.type = 'Inkjet_Refill';
                        } else if (hLower.includes('pixma') || hLower.includes('maxify')) {
                            orphan.type = 'Inkjet';
                        } else if (hLower.includes('selphy')) {
                            orphan.type = 'SELPHY';
                        } else if (hLower.includes('imageclass')) {
                            orphan.type = 'Laser';
                            
                            // imageCLASS Logic
                            let origTitle = (item.title || '').toUpperCase();
                            let match = origTitle.match(/(MF|LBP)\s*\d+([A-Z]*)/);
                            if (match) {
                                let prefix = match[1];
                                let suffix = match[2] || '';
                                
                                if (prefix === 'MF') orphan.scan = 'Y';
                                
                                if (suffix.includes('C')) orphan.color = '4';
                                else orphan.color = '1';
                                
                                if (suffix.includes('D')) orphan.duplex = 'Y';
                                if (suffix.includes('W')) orphan.wifi = 'Y';
                            }
                        } else {
                            orphan.type = 'Other_Printer'; 
                        }
                        productData.PRINTER_DB.push(orphan);
                    } else if (hLower.includes('eos-r') || hLower.includes('eosr') || tLower.includes('eos r')) {
                        orphan.sensor = 'Other_Camera'; 
                        productData.CAMERA_DB.push(orphan);
                    } else if (hLower.match(/^(rf-?s?)/) || tLower.includes('rf')) {
                        orphan.type = '其他 RF 鏡頭|Other RF Lenses';
                        productData.LENS_DB.push(orphan);
                    }
                }
            }

            // Unlisted status auto detection
            if (typeof window.VA_LIQUID_PRICES !== 'undefined' && Object.keys(window.VA_LIQUID_PRICES).length > 0) {
                const filterActive = (p) => {
                    if (!p.sku) return false; 
                    return window.VA_LIQUID_PRICES.hasOwnProperty(p.sku);
                };
                ['CAMERA_DB', 'LENS_DB', 'PRINTER_DB', 'TONER_DB', 'INK_DB'].forEach(key => {
                    productData[key] = productData[key].filter(filterActive);
                });
            }

            // Short-term redirection to EN
            if (lang === 'en') {
                const fixUrl = (url) => {
                    if (typeof url !== 'string') return url;
                    return url.replace('store.hk.canon/products/', 'store.hk.canon/en/products/')
                              .replace('store.hk.canon/collections/', 'store.hk.canon/en/collections/')
                              .replace('store.hk.canon/search', 'store.hk.canon/en/search')
                              .replace('hk.canon/zh_HK/', 'hk.canon/en_HK/')
                              .replace(/^\/products\//, '/en/products/')
                              .replace(/^\/collections\//, '/en/collections/');
                };
                ['CAMERA_DB', 'LENS_DB', 'PRINTER_DB'].forEach(key => productData[key].forEach(p => { p.url = fixUrl(p.url); }));
                ['TONER_DB', 'INK_DB'].forEach(key => productData[key].forEach(p => { p.u = fixUrl(p.u); }));
                
                for (let menuKey in APP_CONFIG.menu_tree) {
                    APP_CONFIG.menu_tree[menuKey].forEach(item => {
                        if (item.url) item.url = fixUrl(item.url);
                    });
                }
            }
        };

        window.reloadVAData(); // Initial load

        setupOmniSearch('canonOmniInput', 'canonOmniDropdown', 'canonOmniClear');
        setupOmniSearch('canonTonerInput', 'canonTonerList', 'canonTonerClear', 'canonTonerToggle', 'toner');
        setupOmniSearch('canonInkInput', 'canonInkList', 'canonInkClear', 'canonInkToggle', 'ink');

        document.addEventListener('keydown', function(e) {
            if (e.ctrlKey || e.altKey || e.metaKey || e.key.length > 1 || e.key === ' ') return;
            
            const activeTag = document.activeElement ? document.activeElement.tagName : '';
            if (activeTag === 'INPUT' || activeTag === 'TEXTAREA') return;
            
            const omniInput = document.getElementById('canonOmniInput');
            const tonerInput = document.getElementById('canonTonerInput');
            const inkInput = document.getElementById('canonInkInput');
            
            let focusedInput = null;
            if (omniInput && omniInput.offsetParent !== null) { 
                focusedInput = omniInput;
            } else if (tonerInput && tonerInput.offsetParent !== null) {
                focusedInput = tonerInput;
            } else if (inkInput && inkInput.offsetParent !== null) {
                focusedInput = inkInput;
            }
            
            if (focusedInput) {
                focusedInput.focus({ preventScroll: true });
                setTimeout(scrollToVA, 50);
            }
        });

        const appWrapper = document.getElementById('canon-app-wrapper');
        if (appWrapper) {
            appWrapper.addEventListener('click', (e) => {
                if (window.innerWidth <= 768) {
                    const tBtn = e.target.closest('.canon-card-btn, .canon-header-back, .reset-btn, .quick-tag-pill, .omni-shortcut');
                    if (tBtn) {
                        setTimeout(scrollToVA, 50);
                    }
                }
            });
        }

        finderState.initialMode = targetMode || (typeof window.VIRTUAL_ASSISTANT_MODE !== 'undefined' ? window.VIRTUAL_ASSISTANT_MODE : 'full');
        routeTo(finderState.initialMode, true);

        // Loading Screen
        setTimeout(() => {
            const headerArea = document.getElementById('app-header-area');
            const contentArea = document.querySelector('.canon-ai-content');
            if (headerArea) headerArea.classList.add('is-ready');
            if (contentArea) contentArea.classList.add('is-ready');

            const liquidLoader = document.getElementById('va-liquid-loader');
            if (liquidLoader) {
                liquidLoader.style.opacity = '0';
                setTimeout(() => liquidLoader.remove(), 300);
            }
        }, 50);
    }

    function scrollToVA() {
        const wrapper = document.getElementById('canon-app-wrapper');
        if (wrapper) {
            const offset = window.innerWidth <= 768 ? 20 : 80;
            const y = wrapper.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({top: y, behavior: 'smooth'});
        }
    }

    function routeTo(mode, isRoot = false) {
        finderState.mode = mode;
        
        hideAllViews();
        document.getElementById('result-area').style.display = 'none';
        
        const headerArea = document.getElementById('app-header-area');
        const aiContentArea = document.querySelector('.canon-ai-content');
        if (mode === 'full' || mode === 'imagesquare') {
            headerArea.classList.add('is-home-mode');
            if (aiContentArea) aiContentArea.classList.add('is-home-mode');
        } else {
            headerArea.classList.remove('is-home-mode');
            if (aiContentArea) aiContentArea.classList.remove('is-home-mode');
        }
        
        if (mode === 'full' || mode === 'imagesquare') {
            const isISQ = finderState.initialMode === 'imagesquare';
            updateHeader(isISQ ? t.imagesquare_title : t.assistant_title, "", false);
            renderMenu('root');
            document.getElementById('view-home').style.display = 'block';
            if (isISQ) {
                document.getElementById('canon-app-wrapper').classList.add('mode-imagesquare');
                document.body.style.overflow = 'hidden'; 
            }
        } else if (mode === 'toner') {
            updateHeader(t.finder_toner_title, "", !isRoot, goBack);
            renderConsumablesTags('toner');
            document.getElementById('view-toner').style.display = 'block';
            document.getElementById('canonTonerResult').style.display = 'block';
            document.getElementById('canonTonerRow').classList.add('is-empty');
            document.getElementById('canonTonerName').textContent = t.toner_result_empty;
            document.getElementById('canonTonerName').style.color = "#86868b";
            document.getElementById('canonTonerBuyBtn').classList.add('btn-disabled');
            setTimeout(() => { triggerAutoBanners(); }, 100);
        } else if (mode === 'ink') {
            updateHeader(t.finder_ink_title, "", !isRoot, goBack);
            renderConsumablesTags('ink');
            document.getElementById('view-ink').style.display = 'block';
            document.getElementById('canonInkResult').style.display = 'block';
            document.getElementById('canonInkRow').classList.add('is-empty');
            document.getElementById('canonInkName').textContent = t.ink_result_empty;
            document.getElementById('canonInkName').style.color = "#86868b";
            document.getElementById('canonInkBuyBtn').classList.add('btn-disabled');
            document.getElementById('canonInkListDetails').innerHTML = '';
            const metaLabelEl = document.getElementById('canonInkMetaLabel');
            if (metaLabelEl) metaLabelEl.innerText = t.ink_suitable;
            setTimeout(() => { triggerAutoBanners(); }, 100);
        } else if (mode === 'latest_promos') {
            updateHeader(lang === 'zh' ? '最新優惠' : 'Latest Offers', "", !isRoot, goBack);
            renderLatestPromosMode();
            document.getElementById('result-area').style.display = 'block';
            document.getElementById('result-header-title').style.display = 'none';
            document.getElementById('btn-restart-wizard').style.display = 'none';
        } else if (APP_CONFIG[mode]) {
            finderState.currentConfig = APP_CONFIG[mode];
            document.getElementById('view-wizard').style.display = 'block';
            startWizard(isRoot, true);
        } else if (mode.endsWith('_wizard')) {
            let baseMode = mode.replace('_wizard', '');
            if (APP_CONFIG[baseMode]) {
                finderState.currentConfig = APP_CONFIG[baseMode];
                document.getElementById('view-wizard').style.display = 'block';
                startWizard(isRoot, false);
            }
        }
        
        setTimeout(() => { triggerAutoBanners(); }, 100);
    }

    function goBack() {
        if (finderState.history.length > 0) {
            const prev = finderState.history.pop();
            finderState.mode = prev.mode;
            finderState.currentMenuId = prev.menuId;
            finderState.currentMenuTitle = prev.menuTitle;
            
            if (prev.mode === 'full' || prev.mode === 'imagesquare') {
                if (prev.menuId === 'root') { routeTo(finderState.initialMode, true); } 
                else { 
                    document.getElementById('view-home').style.display = 'block';
                    hideAllViewsExcept('view-home');
                    renderMenu(prev.menuId, prev.menuTitle); 
                }
            } else {
                routeTo(prev.mode, true);
            }
        } else {
            routeTo(finderState.initialMode, true);
        }
    }

function resetFlow(preventScroll = false) {
        finderState.history = [];
        routeTo(finderState.initialMode, true);
        if (!preventScroll) {
            setTimeout(scrollToVA, 100); 
        }
    }

    function toggleLanguage() {
        lang = lang === 'zh' ? 'en' : 'zh';
        window.VA_CURRENT_LANG = lang;
        t = I18N[lang] || I18N["zh"];
        
        const isqLangSwitch = document.getElementById('isq-lang-switch');
        if (isqLangSwitch) isqLangSwitch.innerText = lang === 'zh' ? 'EN' : '中文';
        
        applyI18N();
        resetFlow();
    }

    function hideAllViews() { hideAllViewsExcept(null); }
    function hideAllViewsExcept(keepId) {
        ['view-home', 'view-category-hub', 'view-wizard', 'view-toner', 'view-ink'].forEach(id => {
            if(id !== keepId) document.getElementById(id).style.display = 'none';
        });
        document.getElementById('result-area').style.display = 'none';
        
        if (document.getElementById('result-grid')) {
            document.getElementById('result-grid').innerHTML = '';
            document.getElementById('result-grid').classList.remove('latest-promos-grid');
        }
        if (document.getElementById('hub-product-grid')) document.getElementById('hub-product-grid').innerHTML = '';
        if (document.getElementById('hub-wizard-options')) document.getElementById('hub-wizard-options').innerHTML = '';
        if (document.getElementById('options-container')) document.getElementById('options-container').innerHTML = '';
        
        document.querySelectorAll('.canon-omni-input').forEach(input => input.value = '');
        document.querySelectorAll('.canon-omni-clear').forEach(btn => btn.style.display = 'none');
        document.querySelectorAll('.canon-omni-dropdown').forEach(dd => dd.classList.remove('is-open'));
    }

    function updateHeader(title, subtitle, showBack, backAction) {
        document.getElementById('app-title').innerHTML = title;
        document.getElementById('app-subtitle').innerText = subtitle;
        document.getElementById('app-subtitle').style.display = subtitle ? 'block' : 'none';
        const backBtn = document.getElementById('global-back-btn');
        if (showBack) { backBtn.style.display = 'inline-block'; backBtn.onclick = backAction; backBtn.innerHTML = `&lt; ${t.btn_back}`; } 
        else { backBtn.style.display = 'none'; }
    }

    function renderMenu(menuId, menuTitle = "") {
        const grid = document.getElementById('options-container');
        grid.innerHTML = '';
        
        finderState.currentMenuId = menuId;
        finderState.currentMenuTitle = menuTitle;

        if (menuId === 'print_sub') {
            document.getElementById('home-search-wrapper').style.display = 'none';
            document.getElementById('home-menu-title-text').style.display = 'none';
            updateHeader(getLangStr(menuTitle), getLangStr(APP_CONFIG.printer.steps[0].question), true, goBack);
        } else {
            document.getElementById('home-search-wrapper').style.display = 'block';
            document.getElementById('home-menu-title-text').style.display = 'block';
            if (menuId !== 'root') updateHeader(getLangStr(menuTitle), "", true, goBack);
            else {
                const isISQ = finderState.initialMode === 'imagesquare';
                updateHeader(isISQ ? t.imagesquare_title : t.assistant_title, "", false);
            }
        }

        const items = APP_CONFIG.menu_tree[menuId];
        if (!items) return;

        const container = document.getElementById('home-menu-container');
        container.innerHTML = '';

        items.forEach(item => {
            const btn = document.createElement('div');
            btn.className = 'canon-card-btn';
            let imgHtml = item.image ? `<div class="canon-card-img-wrap"><div class="canon-card-img-bg" style="background-image: url('${item.image}');"></div></div>` : '';
            btn.innerHTML = `${imgHtml}<div class="canon-card-text">${getLangStr(item.label)}</div>`;
            
            btn.onclick = () => {
                if (typeof gtag === 'function') {
                    gtag('event', 'va_menu_click', {
                        va_mode: finderState.mode,
                        menu_id: menuId,
                        clicked_item_id: item.id,
                        clicked_item_name: getLangStr(item.label),
                        action_type: item.type
                    });
                }

                if (item.type === 'link') window.location.href = item.url;
                else if (item.type === 'submenu') {
                    finderState.history.push({ mode: finderState.mode, menuId: menuId, menuTitle: menuTitle });
                    renderMenu(item.target, item.label);
                }
                else if (item.type === 'mode') {
                    finderState.history.push({ mode: finderState.mode, menuId: menuId, menuTitle: menuTitle });
                    routeTo(item.target);
                }
                else if (item.type === 'info') showInfo(item.message);
            };
            container.appendChild(btn);
        });
    }

    function showInfo(msg) {
        hideAllViewsExcept('view-wizard');
        document.getElementById('view-wizard').style.display = 'block';
        document.getElementById('wizard-hero-box').style.display = 'none';
        document.getElementById('options-container').style.display = 'none';
        document.getElementById('wizard-progress-bar').style.opacity = '0';
        document.getElementById('wizard-question-text').style.display = 'none';
        let backBtnContainer = document.getElementById('wizard-back-btn-container');
        if (backBtnContainer) backBtnContainer.style.display = 'none';
        document.querySelector('.canon-info-box').innerHTML = msg;
        document.getElementById('info-container').style.display = 'block';
        updateHeader(t.info_title, "", true, goBack);
        document.getElementById('global-back-btn').innerHTML = '&lt; 返回';
    }

    function renderWizardHeroImages(containerId, products) {
        const container = document.getElementById(containerId);
        if (!container) return;
        container.innerHTML = '';
        
        if (containerId === 'hub-wizard-images' && window.hubHeroInterval) {
            clearInterval(window.hubHeroInterval);
        } else if (containerId === 'wizard-hero-images' && window.wizardHeroInterval) {
            clearInterval(window.wizardHeroInterval);
        }

        let displayProds = products.filter(p => p.image && p.image !== '#').slice(0, 5);
        if (displayProds.length === 0) {
            container.style.display = 'none';
            return;
        }
        
        container.style.display = 'block';

        const track = document.createElement('div');
        track.className = 'wizard-image-track';
        
        displayProds.forEach((p) => {
            const slide = document.createElement('div');
            slide.className = 'wizard-image-slide';
            slide.innerHTML = `<img src="${p.image}" alt="${p.model}" title="${p.model}">`;
            track.appendChild(slide);
        });
        
        if (displayProds.length > 1) {
            const cloneSlide = document.createElement('div');
            cloneSlide.className = 'wizard-image-slide';
            cloneSlide.innerHTML = `<img src="${displayProds[0].image}" alt="${displayProds[0].model}" title="${displayProds[0].model}">`;
            track.appendChild(cloneSlide);
        }
        
        container.appendChild(track);
        
        if (displayProds.length > 1) {
            let currentIndex = 0;
            const intervalId = setInterval(() => {
                currentIndex++;
                track.style.transition = 'transform 0.5s cubic-bezier(0.25, 1, 0.5, 1)';
                track.style.transform = `translateX(-${currentIndex * 100}%)`;
                
                if (currentIndex === displayProds.length) {
                    setTimeout(() => {
                        track.style.transition = 'none';
                        currentIndex = 0;
                        track.style.transform = `translateX(0%)`;
                    }, 500); 
                }
            }, 1500); 
            
            if (containerId === 'hub-wizard-images') window.hubHeroInterval = intervalId;
            else window.wizardHeroInterval = intervalId;
        }
    }

    function startWizard(isRoot = false, isHubMode = true) {
        finderState.isRoot = isRoot;
        finderState.isHubMode = isHubMode;
        
        let db = productData[finderState.currentConfig.dbKey];
        finderState.currentProducts = finderState.currentConfig.baseFilter ? db.filter(finderState.currentConfig.baseFilter) : db;
        
        finderState.wizardStepIdx = 0;
        finderState.wizardHistory = [];
        
        if (document.getElementById('result-grid')) document.getElementById('result-grid').innerHTML = '';
        if (document.getElementById('hub-product-grid')) document.getElementById('hub-product-grid').innerHTML = '';
        
        updateHeader(getLangStr(finderState.currentConfig.headerTitle || finderState.currentConfig.title), "", !isRoot, wizardGoBack);
        document.getElementById('global-back-btn').innerHTML = `&lt; ${t.btn_back}`;
        
        if (finderState.currentConfig.skipWizard) {
            showWizardResults();
            return;
        }
        
        document.querySelector('.result-header-text').style.display = 'block'; 
        document.getElementById('btn-restart-wizard').style.display = 'inline-flex';
        document.getElementById('result-area').style.display = 'none';
        document.getElementById('info-container').style.display = 'none';
        document.getElementById('wizard-hero-box').style.display = 'block';
        document.getElementById('options-container').style.display = 'grid';
        renderWizardStep();
    }

    function renderWizardStep() {
        let step = finderState.currentConfig.steps[finderState.wizardStepIdx];
        
        if (finderState.currentProducts.length <= 1 || !step) { 
            showWizardResults(); 
            return; 
        }

        let validOptions = [];
        step.options.forEach(opt => {
            const count = finderState.currentProducts.filter(p => step.matcher(p, opt.value)).length;
            if (count > 0) validOptions.push({opt: opt, count: count});
        });

        if (validOptions.length === 0) { 
            showWizardResults(); 
            return; 
        } 

        if (validOptions.length === 1 || validOptions.every(vo => vo.count === finderState.currentProducts.length)) {
            let autoVal = validOptions[0].opt.value;
            finderState.wizardHistory.push({ stepIdx: finderState.wizardStepIdx, products: [...finderState.currentProducts], autoSkipped: true });
            finderState.currentProducts = finderState.currentProducts.filter(p => step.matcher(p, autoVal));
            finderState.wizardStepIdx++;
            renderWizardStep();
            return;
        }

        let showBack = !finderState.isRoot || finderState.wizardHistory.length > 0;
        updateHeader(getLangStr(finderState.currentConfig.headerTitle || finderState.currentConfig.title), "", showBack, wizardGoBack);
        document.getElementById('global-back-btn').innerHTML = `&lt; ${t.btn_back}`;

        document.getElementById('wizard-progress-bar').style.opacity = '0.15';
        document.getElementById('wizard-progress-bar').style.width = ((finderState.wizardStepIdx) / finderState.currentConfig.steps.length) * 100 + '%';
        
        if (finderState.wizardStepIdx === 0 && finderState.isHubMode) {
            document.getElementById('view-category-hub').style.display = 'block';
            document.getElementById('view-wizard').style.display = 'none';
            document.getElementById('result-area').style.display = 'none'; 
            document.getElementById('result-header-title').style.display = 'none';
            document.getElementById('btn-restart-wizard').style.display = 'none';
            
            document.getElementById('hub-hero-title').innerText = t.wizard_hero_title;
            document.getElementById('hub-wizard-question').innerText = getLangStr(step.question);
            renderWizardHeroImages('hub-wizard-images', finderState.currentProducts);

            const hubGrid = document.getElementById('hub-wizard-options');
            hubGrid.innerHTML = '';
            
            step.options.forEach(opt => {
                const nextProducts = finderState.currentProducts.filter(p => step.matcher(p, opt.value));
                const disabled = nextProducts.length === 0;

                const btn = document.createElement('div');
                btn.className = 'canon-card-btn';
                if(disabled) btn.style.opacity = '0.4';
                btn.innerHTML = `<div class="canon-card-text" style="font-size:15px;">${getLangStr(opt.label)}</div>`;
                
                if (!disabled) {
                    btn.onclick = () => {
                        if (typeof gtag === 'function') {
                            gtag('event', 'va_wizard_step', {
                                va_mode: finderState.mode,
                                va_step_index: finderState.wizardStepIdx + 1,
                                va_question: getLangStr(step.question),
                                va_answer: getLangStr(opt.label)
                            });
                        }
                        finderState.wizardHistory.push({ stepIdx: finderState.wizardStepIdx, products: [...finderState.currentProducts], autoSkipped: false });
                        finderState.currentProducts = nextProducts;
                        finderState.wizardStepIdx++;
                        renderWizardStep();
                        setTimeout(scrollToVA, 10);
                    };
                }
                hubGrid.appendChild(btn);
            });

            renderResultGrid('hub-product-grid', finderState.currentProducts, true);

        } else {
            document.getElementById('view-category-hub').style.display = 'none';
            document.getElementById('view-wizard').style.display = 'block';
            document.getElementById('result-area').style.display = 'none';
            document.getElementById('info-container').style.display = 'none';
            document.getElementById('wizard-hero-box').style.display = 'block';
            document.getElementById('options-container').style.display = 'grid';

            document.getElementById('wizard-progress-bar').style.opacity = '0.15';
            document.getElementById('wizard-progress-bar').style.width = ((finderState.wizardStepIdx) / finderState.currentConfig.steps.length) * 100 + '%';
            
            const heroTitle = document.getElementById('wizard-hero-title');
            const heroImageContainer = document.getElementById('wizard-hero-image-box-container');
            if (finderState.wizardStepIdx === 0) {
                heroTitle.innerText = getLangStr(finderState.currentConfig.title);
                if (heroImageContainer) heroImageContainer.style.display = 'flex';
                renderWizardHeroImages('wizard-hero-images', finderState.currentProducts);
            } else {
                if (heroImageContainer) heroImageContainer.style.display = 'none';
            }

            document.getElementById('wizard-question-text').style.display = 'block';
            document.getElementById('wizard-question-text').innerText = getLangStr(step.question);

            const regGrid = document.getElementById('options-container');
            regGrid.innerHTML = '';
            
            step.options.forEach(opt => {
                const nextProducts = finderState.currentProducts.filter(p => step.matcher(p, opt.value));
                const disabled = nextProducts.length === 0;

                const btn = document.createElement('div');
                btn.className = 'canon-card-btn';
                if(disabled) btn.style.opacity = '0.4';
                btn.innerHTML = `<div class="canon-card-text" style="font-size:15px;">${getLangStr(opt.label)}</div>`;
                
                if (!disabled) {
                    btn.onclick = () => {
                        if (typeof gtag === 'function') {
                            gtag('event', 'va_wizard_step', {
                                va_mode: finderState.mode,
                                va_step_index: finderState.wizardStepIdx + 1,
                                va_question: getLangStr(step.question),
                                va_answer: getLangStr(opt.label)
                            });
                        }
                        finderState.wizardHistory.push({ stepIdx: finderState.wizardStepIdx, products: [...finderState.currentProducts], autoSkipped: false });
                        finderState.currentProducts = nextProducts;
                        finderState.wizardStepIdx++;
                        renderWizardStep();
                        setTimeout(scrollToVA, 10);
                    };
                }
                regGrid.appendChild(btn);
            });
        }
    }

    function wizardGoBack() {
        if (finderState.wizardHistory.length === 0) { 
            goBack();
            return; 
        }
        
        let prev = finderState.wizardHistory.pop();
        while (prev.autoSkipped && finderState.wizardHistory.length > 0) {
            prev = finderState.wizardHistory.pop();
        }
        if (prev.autoSkipped) {
            goBack();
            return;
        }

        let backBtnContainer = document.getElementById('wizard-back-btn-container');
        if (backBtnContainer) {
            if (finderState.wizardStepIdx > 0 && !finderState.isHubMode) {
                backBtnContainer.style.display = 'block';
            } else {
                backBtnContainer.style.display = 'none';
            }
        }

        finderState.wizardStepIdx = prev.stepIdx;
        finderState.currentProducts = prev.products;
        
        hideAllViewsExcept('view-wizard');
        document.getElementById('view-wizard').style.display = 'block';
        document.getElementById('wizard-hero-box').style.display = 'block';
        document.getElementById('options-container').style.display = 'grid';
        document.getElementById('wizard-question-text').style.display = 'block';
        
        renderWizardStep(); 
    }

    function showWizardResults() {
        document.getElementById('view-category-hub').style.display = 'none';
        document.getElementById('view-wizard').style.display = 'block'; 
        
        document.getElementById('wizard-hero-box').style.display = 'none';
        document.getElementById('options-container').innerHTML = '';
        document.getElementById('wizard-progress-bar').style.opacity = '0';
        document.getElementById('wizard-question-text').style.display = 'none';
        
        let headerTitle = getLangStr(finderState.currentConfig.skipWizard ? (finderState.currentConfig.listTitle || finderState.currentConfig.headerTitle || finderState.currentConfig.title) : (finderState.currentConfig.headerTitle || finderState.currentConfig.title));
        let headerSub = finderState.currentConfig.skipWizard ? "" : t.based_on_choices;
        
        const restartAction = () => {
            document.getElementById('global-back-btn').innerHTML = `&lt; ${t.btn_back}`; 
            resetFlow();
            scrollToVA();
        };
        
        updateHeader(headerTitle, headerSub, true, restartAction);
        document.getElementById('global-back-btn').innerHTML = t.btn_restart; 
        
        document.getElementById('result-area').style.display = 'block';
        document.getElementById('result-header-title').style.display = finderState.currentConfig.skipWizard ? 'none' : 'block';
        document.getElementById('btn-restart-wizard').style.display = finderState.currentConfig.skipWizard ? 'none' : 'inline-flex';
        
        if (typeof gtag === 'function') {
            gtag('event', 'va_wizard_complete', {
                va_mode: finderState.mode,
                va_results_count: finderState.currentProducts.length,
                va_results_models: finderState.currentProducts.map(p => p.model).join(', ')
            });
        }

        renderResultGrid('result-grid', finderState.currentProducts, false, !finderState.currentConfig.skipWizard);
    }

    function groupAndSortProducts(products, dbKey) {
        let groups = {};
        let sortedProducts = [...products];

        if (dbKey === 'CAMERA_DB') {
            sortedProducts.forEach(p => {
                let key = (p.sensor || '').toString().trim();
                let label = key === 'Full Frame' ? t.grp_ff : (key === 'APS-C' ? t.grp_apsc : (key === 'Other_Camera' ? (lang === 'en' ? 'Other EOS R Cameras' : '其他 EOS R 相機') : key));
                if (!groups[label]) groups[label] = [];
                groups[label].push(p);
            });
            let orderedGroups = {};
            if (groups[t.grp_ff]) orderedGroups[t.grp_ff] = groups[t.grp_ff];
            if (groups[t.grp_apsc]) orderedGroups[t.grp_apsc] = groups[t.grp_apsc];
            for (let k in groups) if (k !== t.grp_ff && k !== t.grp_apsc) orderedGroups[k] = groups[k];
            return orderedGroups;
        } else if (dbKey === 'LENS_DB') {
            const orderKeys = [
                "超廣角變焦鏡頭", "廣角定焦鏡頭", "標準變焦鏡頭", "標準及中距定焦鏡頭",
                "遠攝變焦鏡頭", "遠攝及超遠攝定焦鏡頭", "VR 鏡頭", "RF-S 鏡頭", "增距鏡及鏡頭轉接環", "其他 RF 鏡頭"
            ];
            
            let orderedGroups = {};
            sortedProducts.forEach(p => {
                let typeStr = (p.type || '').toString().trim();
                let parts = typeStr.split('|');
                let tc = parts[0] || typeStr;
                let en = parts[1] || tc;
                let label = lang === 'zh' ? tc : en;
                
                if (!orderedGroups[tc]) orderedGroups[tc] = { label: label, items: [] };
                orderedGroups[tc].items.push(p);
            });
            
            let finalGroups = {};
            orderKeys.forEach(k => {
                if (orderedGroups[k] && orderedGroups[k].items.length > 0) {
                    finalGroups[orderedGroups[k].label] = orderedGroups[k].items;
                    delete orderedGroups[k];
                }
            });
            for (let k in orderedGroups) {
                finalGroups[orderedGroups[k].label] = orderedGroups[k].items;
            }
            return finalGroups;
        } else if (dbKey === 'PRINTER_DB') {
            const zhInspic = 'iNSPiC 便攜式打印機';
            const enInspic = 'iNSPiC Portable Printers';
            const fallbackInspic = (lang === 'zh' ? zhInspic : enInspic);

            sortedProducts.forEach(p => {
                let rawType = (p.type || '').toString().toLowerCase().trim();
                let label = '';
                if (rawType === 'inkjet') label = t.grp_inkjet;
                else if (rawType === 'inkjet_portable') label = t.grp_portable;
                else if (rawType === 'inkjet_refill') label = t.grp_refill;
                else if (rawType === 'selphy') label = t.grp_selphy;
                else if (rawType.includes('inspic')) label = t.grp_inspic || fallbackInspic;
                else if (rawType === 'laser') label = t.grp_laser;
                else if (rawType === 'other_printer') label = t.grp_other_printers;
                
                if (!label) label = p.type || t.grp_other_printers || 'Others';
                if (!groups[label]) groups[label] = [];
                groups[label].push(p);
            });
            let orderedGroups = {};
            let order = [t.grp_inkjet, t.grp_portable, t.grp_refill, t.grp_selphy, t.grp_inspic || fallbackInspic, t.grp_laser, t.grp_other_printers].filter(x => x && x !== 'undefined');
            order.forEach(k => { if (groups[k]) orderedGroups[k] = groups[k]; });
            for (let k in groups) if (!order.includes(k) && k !== 'undefined') orderedGroups[k] = groups[k];
            return orderedGroups;
        } else {
            groups[t.browse_all_models] = sortedProducts;
            return groups;
        }
    }

    function generatePromoPills(sku, layout = 'card') {
        let liquidData = typeof window.VA_LIQUID_PRICES !== 'undefined' ? window.VA_LIQUID_PRICES[sku] : null;
        let data = (window.CANON_GLOBAL_DATA && window.CANON_GLOBAL_DATA.SHOPIFY_DATA) ? window.CANON_GLOBAL_DATA.SHOPIFY_DATA : (window.CANON_GLOBAL_DATA || { bundles: [], promotions: [] });
        
        if (!liquidData) return '';
        
        let pId = String(liquidData.id || '').trim();
        let pColls = liquidData.collections || [];
        
        let pVarIdsStr = [];
        let pVarsRaw = liquidData.variants;
        if (pVarsRaw) {
            if (typeof pVarsRaw === 'string') {
                pVarsRaw.split(',').forEach(v => pVarIdsStr.push(String(v).trim()));
            } else if (Array.isArray(pVarsRaw)) {
                pVarsRaw.forEach(v => pVarIdsStr.push(String(typeof v === 'object' ? (v.id || v) : v).trim()));
            } else if (typeof pVarsRaw === 'object') {
                Object.keys(pVarsRaw).forEach(k => pVarIdsStr.push(String(k).trim()));
            }
        }
        if (data.variants && data.variants[sku]) {
            data.variants[sku].forEach(v => pVarIdsStr.push(String(typeof v === 'object' ? (v.id || v) : v).trim()));
        }
        pVarIdsStr = [...new Set(pVarIdsStr)].filter(Boolean);
        // ------------------------------------------------

        let matchedLabels = [];
        let isExclusiveAll = false;
        let isExclusiveOption = false;

        let exclusivePromo = (data.promotions || []).find(p => p.handle === 'canon-store-exclusive');
        if (exclusivePromo) {
            let pIdsStr = exclusivePromo.product_ids || [];
            if (typeof pIdsStr === 'string') pIdsStr = pIdsStr.split(',').map(s => s.trim());
            else if (Array.isArray(pIdsStr)) pIdsStr = pIdsStr.map(String);

            let vIdsStr = exclusivePromo.variant_ids || [];
            if (typeof vIdsStr === 'string') vIdsStr = vIdsStr.split(',').map(s => s.trim());
            else if (Array.isArray(vIdsStr)) vIdsStr = vIdsStr.map(String);

            let vpIdsStr = exclusivePromo.variant_parent_ids || [];
            if (typeof vpIdsStr === 'string') vpIdsStr = vpIdsStr.split(',').map(s => s.trim());
            else if (Array.isArray(vpIdsStr)) vpIdsStr = vpIdsStr.map(String);

            let isWholeProductExplicit = pId && pIdsStr.includes(pId);
            let isVariantParent = pId && vpIdsStr.includes(pId);

            if (isWholeProductExplicit) {
                isExclusiveAll = true;
            } else if (pVarIdsStr.length > 0 && vIdsStr.length > 0) {
                let matchCount = pVarIdsStr.filter(vid => vIdsStr.includes(vid)).length;
                if (matchCount > 0) {
                    if (matchCount === pVarIdsStr.length) isExclusiveAll = true;
                    else isExclusiveOption = true;
                }
            } else if (isVariantParent) {
                isExclusiveOption = true;
            }
        }

        if (isExclusiveAll) {
            matchedLabels.push({ text: lang === 'en' ? 'Canon Store Exclusive' : 'Canon 商店限定', type: 'exclusive' });
        } else if (isExclusiveOption) {
            matchedLabels.push({ text: lang === 'en' ? 'Canon Store Exclusive Option' : 'Canon 商店限定選項', type: 'exclusive' });
        }

        // Date Calculator
        const now = Math.floor(Date.now() / 1000);

        const isMatch = (promo) => {
            let sTime = promo.start_time || promo.start;
            let eTime = promo.end_time || promo.end;
            if (typeof sTime === 'string') sTime = Math.floor(new Date(sTime).getTime() / 1000);
            if (typeof eTime === 'string') eTime = Math.floor(new Date(eTime).getTime() / 1000) + 86399;
            
            if (sTime && sTime > now) return false;
            if (eTime && eTime < now) return false;

            if (promo.storewide === true || promo.storewide === 'true') return true;
            
            let pIdsStr = promo.product_ids || [];
            if (typeof pIdsStr === 'string') pIdsStr = pIdsStr.split(',').map(s => s.trim());
            if (pId && pIdsStr.map(String).includes(pId)) return true;

            let vpIdsStr = promo.variant_parent_ids || [];
            if (typeof vpIdsStr === 'string') vpIdsStr = vpIdsStr.split(',').map(s => s.trim());
            else if (Array.isArray(vpIdsStr)) vpIdsStr = vpIdsStr.map(String);
            if (pId && vpIdsStr.includes(pId)) return true;

            let cIdsStr = promo.collection_ids || [];
            if (typeof cIdsStr === 'string') cIdsStr = cIdsStr.split(',').map(s => s.trim());
            if (pColls.length > 0 && cIdsStr.some(cid => pColls.map(String).includes(String(cid)))) return true;

            let vIdsStr = promo.variant_ids || [];
            if (typeof vIdsStr === 'string') vIdsStr = vIdsStr.split(',').map(s => s.trim());
            if (pVarIdsStr.length > 0 && vIdsStr.length > 0 && pVarIdsStr.some(vid => vIdsStr.map(String).includes(vid))) return true;

            return false;
        };

        (data.bundles || []).forEach(b => {
            // No pill sceneario
            if (b.pinned === 'Yes, banner only' || !b.title) return;
            if (isMatch(b)) matchedLabels.push({ text: b.title, type: 'bundle' });
        });

        (data.promotions || []).forEach(p => {
            let handle = p.handle || '';
            if (handle === 'canon-store-exclusive' || handle.includes('weee') || handle.includes('tradein')) return;
            // Banner only sceneario
            if (p.pinned === 'Yes, banner only' || !p.title) return;
            if (isMatch(p)) matchedLabels.push({ text: p.title, type: 'promo' });
        });

        if (matchedLabels.length === 0) return '';

        if (layout === 'search') {
            let excLabels = matchedLabels.filter(l => l.type === 'exclusive');
            let otherLabels = matchedLabels.filter(l => l.type !== 'exclusive');
            matchedLabels = [...excLabels];
            if (otherLabels.length > 0) {
                let count = otherLabels.length;
                let text = lang === 'en' ? count + (count > 1 ? ' promotions' : ' promotion') : count + ' 項優惠';
                matchedLabels.push({ text: text, type: 'promo' });
            }
        }

        let maxPills = 2; 
        let displayLabels = matchedLabels.slice(0, maxPills);
        let remaining = matchedLabels.length - displayLabels.length;

        let productUrl = liquidData ? liquidData.url : '#';
        let clickAttr = '';
        let cursorStyle = '';
        if (productUrl !== '#') {
            cursorStyle = ' cursor: pointer;';
            if (layout === 'search') {
                clickAttr = ` onclick="event.stopPropagation(); window.canonApp.showVAPromosListModal('${sku}');" ontouchstart="event.stopPropagation(); this.setAttribute('data-t', '0');" ontouchmove="this.setAttribute('data-t', '1');" ontouchend="if(this.getAttribute('data-t') === '0') { event.preventDefault(); event.stopPropagation(); window.canonApp.showVAPromosListModal('${sku}'); }"`;
            } else {
                clickAttr = ` onclick="event.stopPropagation(); window.location.href='${productUrl}';" ontouchstart="event.stopPropagation(); this.setAttribute('data-t', '0');" ontouchmove="this.setAttribute('data-t', '1');" ontouchend="if(this.getAttribute('data-t') === '0') { event.preventDefault(); event.stopPropagation(); window.location.href='${productUrl}'; }"`;
            }
        }

        let html = '';
        displayLabels.forEach(l => {
            let bg = l.type === 'exclusive' ? 'linear-gradient(130deg, #8a3ff3, #fe7cc5, #ffb8e0)' : 'rgba(0,0,0,0.7)';
            let maxWidth = layout === 'card' ? '150px' : '100px';
            html += `<span style="background: ${bg}; color: #fff; font-weight: ${l.type === 'exclusive' ? '700' : '500'}; font-size: 10px; padding: 4px 8px; border-radius: 6px; display: inline-block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: ${maxWidth}; box-shadow: 0 2px 6px rgba(0,0,0,0.1); letter-spacing: 0.02em; line-height: 1.2;${cursorStyle}"${clickAttr}>${l.text}</span>`;
        });
        if (remaining > 0) html += `<span style="background: rgba(0,0,0,0.5); color: #fff; font-weight: 500; font-size: 10px; padding: 4px 6px; border-radius: 6px; display: inline-block; white-space: nowrap; box-shadow: 0 2px 6px rgba(0,0,0,0.1); line-height: 1.2;${cursorStyle}"${clickAttr}>+${remaining}</span>`;

        if (layout === 'card') return `<div class="promo-pills-container" style="position:absolute; top:12px; left:12px; display:flex; flex-direction:column; gap:4px; z-index:10; align-items: flex-start;">${html}</div>`;
        return `<div class="promo-pills-container" style="display:flex; gap:4px; align-items:center; position:relative; z-index:10;">${html}</div>`;
    }

    function renderResultGrid(containerId, products, isHubMode = false, isCompareMode = false) {
        const grid = document.getElementById(containerId);
        if (!grid) return;
        grid.innerHTML = '';
        if (products.length === 0) {
            grid.innerHTML = `<div style="text-align:center; width:100%; padding:40px; color:#86868b;">${t.no_result}</div>`;
            return;
        }

        let sortedInput = [...products];
        const dbKey = finderState.currentConfig?.dbKey;
        if (dbKey === 'CAMERA_DB') {
            const getPrice = (p) => {
                if (!p.price) return 0;
                let m = p.price.toString().match(/[\d,.]+/);
                return m ? parseFloat(m[0].replace(/,/g, '')) : 0;
            };
            sortedInput.sort((a, b) => getPrice(b) - getPrice(a));
        } else if (dbKey === 'LENS_DB') {
            sortedInput.sort((a, b) => a.model.localeCompare(b.model, undefined, {numeric: true}));
        } else if (dbKey === 'PRINTER_DB') {
            sortedInput.sort((a, b) => b.model.localeCompare(a.model, undefined, {numeric: true}));
        }

        let finalProducts = [];
        let groupMarkers = []; 
        
        if (isHubMode) {
            let grouped = groupAndSortProducts(sortedInput, dbKey);
            for (const [groupName, groupProducts] of Object.entries(grouped)) {
                groupMarkers.push({ index: finalProducts.length, title: groupName });
                finalProducts.push(...groupProducts);
            }
        } else {
            finalProducts = sortedInput;
        }

        let oldNav = grid.querySelector('.canon-hub-nav');
        if (oldNav) oldNav.remove();

        let stickyNav = null;
        if (isHubMode && groupMarkers.length > 1) {
            stickyNav = document.createElement('nav');
            stickyNav.className = 'canon-hub-nav';
        }

        let allSpecsData = [];
        finalProducts.forEach(p => {
            let pSpecs = [];
            let featureText = lang === 'zh' ? p.features_tc : p.features_en;
            
            if (finderState.currentConfig?.dbKey === 'PRINTER_DB') {
                if (featureText) pSpecs.push({ id: 'p_feat', label: '', val: `<strong>${featureText}</strong>` });
                
                const typeMap = { 
                    'inkjet': {zh: '噴墨', en: 'Inkjet'}, 
                    'inkjet_refill': {zh: '噴墨，加墨式', en: 'Inkjet, Refillable'}, 
                    'inkjet_portable': {zh: '噴墨，流動式', en: 'Inkjet, Portable'}, 
                    'selphy': {zh: '小型相片打印機', en: 'Compact Photo Printer'}, 
                    'inspic': {zh: '小型相片打印機', en: 'Compact Photo Printer'},
                    'laser': {zh: '雷射', en: 'Laser'} 
                };
                const rawType = (p.type || '').toString().toLowerCase().trim();
                const pType = typeMap[rawType] ? typeMap[rawType][lang] : p.type;
                
                const cVal = p.color ? p.color.toString().trim() : '';
                let isMono = !cVal || cVal === '0' || cVal === '1';
                if (rawType === 'selphy' || rawType === 'inspic') isMono = false; // Photo printers as color
                
                const pColor = isMono ? t.val_monochrome : (cVal && cVal !== '0' && cVal !== '1' ? t.val_colors.replace('{x}', cVal) : t.val_color);
                
                if (p.size) pSpecs.push({ id: 'p_size', label: t.spec_size, val: p.size });
                if (pType) pSpecs.push({ id: 'p_type', label: t.spec_type, val: pType });
                if (cVal || rawType === 'selphy' || rawType === 'inspic') {
                    pSpecs.push({ id: 'p_color', label: t.spec_color, val: pColor });
                }
                
                const spdMono = parseInt(p.speedMono) || 0;
                const spdColor = parseInt(p.speedColor) || 0;
                if (isMono || spdColor === 0) {
                    if (spdMono > 0) pSpecs.push({ id: 'p_speed', label: t.spec_speed, val: t.val_speed_mono.replace('{x}', spdMono) });
                } else {
                    pSpecs.push({ id: 'p_speed', label: t.spec_speed, val: t.val_speed_both.replace('{x}', spdMono).replace('{y}', spdColor) });
                }
                
                let hasFax = (p.fax||'').toString().trim() === 'Y';
                let hasDuplex = (p.duplex||'').toString().trim() === 'Y';
                let hasAdf = (p.adf||'').toString().trim() === 'Y';
                let hasSinglePass = (p.singlePass||'').toString().trim() === 'Y';
                let hasWifi = (p.wifi||'').toString().trim() === 'Y';
                let hasScanBool = (p.scan||'').toString().trim() === 'Y';

                const lblYes = t.val_yes;
                const lblNo = t.val_no;

                if (isCompareMode) {
                    pSpecs.push({ id: 'p_scan_bool', label: lang === 'zh' ? '掃瞄器：' : 'Scanner: ', val: hasScanBool ? lblYes : lblNo });
                    pSpecs.push({ id: 'p_fax', label: t.spec_fax, val: hasFax ? lblYes : lblNo });
                    pSpecs.push({ id: 'p_duplex', label: t.spec_duplex, val: hasDuplex ? lblYes : lblNo });
                    pSpecs.push({ id: 'p_adf', label: t.spec_adf, val: hasAdf ? lblYes : lblNo });
                    pSpecs.push({ id: 'p_singlePass', label: t.spec_single_pass, val: hasSinglePass ? lblYes : lblNo });
                    pSpecs.push({ id: 'p_wifi', label: t.spec_wifi, val: hasWifi ? lblYes : lblNo });
                } else {
                    if (hasScanBool) pSpecs.push({ id: 'p_scan_bool', label: lang === 'zh' ? '掃瞄器：' : 'Scanner: ', val: lblYes });
                    if (hasFax) pSpecs.push({ id: 'p_fax', label: t.spec_fax, val: lblYes });
                    if (hasDuplex) pSpecs.push({ id: 'p_duplex', label: t.spec_duplex, val: lblYes });
                    if (hasAdf) pSpecs.push({ id: 'p_adf', label: t.spec_adf, val: lblYes });
                    if (hasSinglePass) pSpecs.push({ id: 'p_singlePass', label: t.spec_single_pass, val: lblYes });
                    if (hasWifi) pSpecs.push({ id: 'p_wifi', label: t.spec_wifi, val: lblYes });
                }
                
                if (p.scanRes && p.scanRes !== 'N' && p.scanRes.toString().trim() !== '' && p.scanRes.toString().trim() !== '-') {
                pSpecs.push({ id: 'p_scan', label: t.spec_scan_res, val: p.scanRes });
            }
            
        } else if (finderState.currentConfig?.dbKey === 'CAMERA_DB') {
            let fList = [lang === 'zh' ? p.f1_tc : p.f1_en, lang === 'zh' ? p.f2_tc : p.f2_en, lang === 'zh' ? p.f3_tc : p.f3_en].filter(f => f && f.toString().trim() !== '');
            if (fList.length > 0) pSpecs.push({ id: 'e_feat', label: '', val: `<strong>${fList.join('，')}</strong>` });
            
            let resDisplay = '-';
            if (p.resolution && !isNaN(parseFloat(p.resolution))) {
                    resDisplay = (lang === 'zh' ? Math.round(parseFloat(p.resolution) * 100) : p.resolution) + t.val_megapixels;
                } else if (p.resolution) {
                    resDisplay = p.resolution;
                }
                
                pSpecs.push({ id: 'e_res', label: t.spec_resolution, val: resDisplay });
                if (p.af) pSpecs.push({ id: 'e_af', label: t.spec_af, val: p.af });
                if (p.fps) pSpecs.push({ id: 'e_fps', label: t.spec_fps, val: t.val_fps_speed.replace('{x}', p.fps) });
                
                if (p.video) pSpecs.push({ id: 'e_vid', label: t.spec_video, val: p.video });
                if (p.card) pSpecs.push({ id: 'e_card', label: t.spec_card, val: p.card });
                if (p.weight) pSpecs.push({ id: 'e_wgt', label: t.spec_weight, val: `${p.weight}g` });
                
            } else if (finderState.currentConfig?.dbKey === 'LENS_DB') {
                if (p.weight) pSpecs.push({ id: 'r_wgt', label: t.spec_weight, val: `${p.weight}g` });
                let fList = [featureText].filter(f => f && f.toString().trim() !== '');
                if (fList.length > 0) pSpecs.push({ id: 'r_feat', label: '', val: fList.join('，') });
                
            } else {
                if (featureText) pSpecs.push({ id: 'o_feat', label: '', val: featureText });
            }
            
            allSpecsData.push(pSpecs);
        });

        let diffIds = new Set();
        let allNoneIds = new Set();
        
        if (isCompareMode) {
            let specMap = {};
            let idCount = {};
            allSpecsData.forEach(specs => {
                specs.forEach(s => {
                    if (!specMap[s.id]) { specMap[s.id] = new Set(); idCount[s.id] = 0; }
                    specMap[s.id].add(s.val); 
                    idCount[s.id]++;
                });
            });
            
            for (let id in specMap) {
                if (specMap[id].size === 1 && (specMap[id].has(t.val_no) || specMap[id].has('-'))) {
                    allNoneIds.add(id);
                }
                
                if (finalProducts.length > 1) {
                    if (specMap[id].size > 1 || idCount[id] < finalProducts.length) {
                        diffIds.add(id);
                    }
                }
            }
        }

        finalProducts.forEach((p, index) => {
            if (isHubMode) {
                let marker = groupMarkers.find(m => m.index === index);
                if (marker) {
                    if (index === 0 && stickyNav) {
                        grid.parentNode.insertBefore(stickyNav, grid);
                    }

                    const header = document.createElement('div');
                    header.id = `canon-group-${marker.index}`; 
                    header.className = 'canon-group-header'; 
                    header.style.gridColumn = "1 / -1";
                    header.style.fontSize = "26px";
                    header.style.fontWeight = "800";
                    header.style.backgroundColor = "rgba(242, 242, 247, 0.85)";
                    header.style.color = "#000000";
                    header.style.padding = "36px 36px";
                    header.style.borderRadius = "6px";
                    header.style.marginTop = index === 0 ? "10px" : "300px";
                    header.style.marginBottom = "20px";
                    header.style.letterSpacing = "0.02em";
                    header.innerText = marker.title;
                    grid.appendChild(header);

                    if (stickyNav) {
                        const navLink = document.createElement('a');
                        navLink.className = 'canon-hub-nav-item';
                        navLink.textContent = marker.title;
                        navLink.dataset.target = header.id;
                        if (index === 0) navLink.classList.add('active'); 
                        
                        navLink.addEventListener('click', (e) => {
                            e.preventDefault();
                            const target = document.getElementById(header.id);
                            if(target) {
                                const navHeight = 60;
                                if (window.getComputedStyle(grid).overflowY === 'auto' && grid.scrollHeight > grid.clientHeight) {
                                    grid.scrollBy({ top: target.getBoundingClientRect().top - grid.getBoundingClientRect().top - navHeight - 10, behavior: 'smooth' });
                                } else {
                                    const targetY = target.getBoundingClientRect().top + window.scrollY - navHeight - 10; 
                                    window.scrollTo({ top: targetY, behavior: 'smooth' });
                                }
                            }
                        });
                        stickyNav.appendChild(navLink);
                    }
                }
            }
            
            const div = document.createElement('div');
            div.className = 'canon-result-card';
            let specsHtml = '';
            let kvHtml = '';
            
            if (finderState.currentConfig?.dbKey === 'CAMERA_DB') {
                let currentKv = lang === 'zh' ? p.kv_tc : p.kv_en;
                if (currentKv && currentKv.trim() !== '') {
                    kvHtml = `<div class="hover-enlarge" data-url="${currentKv}" style="cursor:zoom-in; margin-top: 10px; margin-bottom: 30px; width:100%; aspect-ratio: 1380 / 500; background-image:url('${currentKv}'); background-size:contain; background-position:center; background-repeat:no-repeat; border-radius:8px;"></div>`;
                }
            }
            
            allSpecsData[index].forEach(s => {
                if (allNoneIds.has(s.id)) return; 
                
                let displayVal = s.val;
                if (diffIds.has(s.id) && displayVal) {
                    displayVal = `<span style="color:#7c3aed; font-weight:500; background:#f5f3ff; padding:2px 6px; border-radius:6px; margin-left:0px;">${s.val}</span>`;
                }
                specsHtml += `<li>${s.label}${displayVal}</li>`;
            });
            
            let lensSamplesHtml = '';
            if (finderState.currentConfig?.dbKey === 'LENS_DB') {
                if (p.samples && p.samples.length > 0) {
                    let thumbnails = p.samples.slice(0, 2).map((s, idx) => `<div class="sample-img-trigger lens-sample-img" data-idx="${idx}" style="cursor:pointer; background-image:url('${s}');"></div>`).join('');
                    let labelText = t.spec_samples.replace(/[：:]/g, '').trim();

                    lensSamplesHtml = `
                        <div class="lens-sample-banner">
                            <span class="lens-sample-title">${labelText}</span>
                            <div class="lens-sample-images">
                                ${thumbnails}
                            </div>
                        </div>
                    `;
                } else {
                    lensSamplesHtml = `
                        <div class="lens-sample-banner" style="visibility: hidden; pointer-events: none;"></div>
                    `;
                }
            }
            
            let priceHtmlStr = '<span style="visibility:hidden;">-</span>';
            if (['CAMERA_DB', 'LENS_DB', 'PRINTER_DB'].includes(finderState.currentConfig?.dbKey)) {
                let handleMatch = p.url.match(/\/products\/([^/?]+)/);
                let handle = handleMatch ? handleMatch[1] : '';

                let liquidData = typeof window.VA_LIQUID_PRICES !== 'undefined' ? window.VA_LIQUID_PRICES[handle] : null;

                if (liquidData && liquidData.price > 0) {
                    let currentPrice = liquidData.price / 100;
                    let compareAt = (liquidData.compare_at || 0) / 100;
                    let priceVaries = liquidData.price_varies;

                    let onSale = compareAt > currentPrice;
                    let compareHtml = '';
                    
                    if (onSale) {
                        compareHtml = `<s style="color:#1d1d1f; font-size:12px; margin-right:2px;">HK$${compareAt.toLocaleString('en-US')}</s>`;
                    }
                    
                    let mainPriceHtml = `<span style="${onSale ? 'color:#e32400; font-weight:600;' : 'color:#1d1d1f;'}">HK$${currentPrice.toLocaleString('en-US')}</span>`;
                    
                    if (priceVaries) {
                        let pre = t.price_prefix ? `<span style="font-size:14px; font-weight:400; margin-right:2px; color:#1d1d1f;">${t.price_prefix}</span>` : '';
                        let suf = t.price_suffix ? `<span style="font-size:14px; font-weight:400; margin-left:2px; color:#1d1d1f;">${t.price_suffix}</span>` : '';
                        priceHtmlStr = pre + compareHtml + mainPriceHtml + suf;
                    } else {
                        priceHtmlStr = compareHtml + mainPriceHtml;
                    }
                } else if (p.price && p.price.toString().trim() !== '' && p.price.toString().toUpperCase() !== 'TBC') {
                    let pStr = p.price.toString().trim();
                    let match = pStr.match(/[\d,.]+/);
                    if (match) {
                        let cleanNum = parseFloat(match[0].replace(/,/g, ''));
                        if (!isNaN(cleanNum)) priceHtmlStr = 'HK$' + cleanNum.toLocaleString('en-US');
                        else priceHtmlStr = pStr; 
                    } else priceHtmlStr = pStr; 
                }
            }
            
            let priceHtml = `<div class="result-price shopify-real-price">${priceHtmlStr}</div>`;

            const imgContent = p.image ? `<div class="result-img-bg" style="background-image: url('${p.image}');"></div>` : `<div style="color:#ccc;">${t.no_image}</div>`;
            
            const targetAttr = isHubMode ? '' : ' target="_blank"';
            
            const ga4Click = `if(typeof gtag === 'function') gtag('event', 'va_product_click', { va_mode: '${finderState.mode}', product_model: '${p.model}', product_sku: '${p.sku}' });`;

            let displayUrl = p.url;
            if (!isHubMode && finderState.currentConfig && !finderState.currentConfig.skipWizard) {
                displayUrl += (displayUrl.includes('?') ? '&' : '?') + 'utm_source=virtual-assistant&utm_medium=wizard';
            }

            div.innerHTML = `
                <div class="result-img-container" style="position:relative;">
                    ${generatePromoPills(p.sku, 'card')}
                    ${imgContent}
                </div>
                <div class="result-content">
                    <div class="result-model">${p.model}</div>
                    ${priceHtml}
                    ${kvHtml}
                    <ul class="result-specs">${specsHtml}</ul>
                    <a href="${displayUrl}" class="canon-finder__cta"${targetAttr} style="margin-top:auto !important;" onclick="${ga4Click}">${t.btn_buy}</a>
                    ${lensSamplesHtml}
                </div>
            `;
            grid.appendChild(div);

            div.querySelectorAll('.hover-enlarge').forEach(el => {
                const url = el.getAttribute('data-url');
                
                const showPreview = (e) => {
                    let preview = document.getElementById('canon-image-preview');
                    if(!preview) {
                        preview = document.createElement('div');
                        preview.id = 'canon-image-preview';
                        preview.innerHTML = '<div id="canon-image-preview-img"></div>';
                        preview.style.cssText = 'display:none; position:fixed; top:50%; left:50%; transform:translate(-50%, -48%); z-index:999999; pointer-events:none; background:#fff; border-radius:16px; box-shadow:0 20px 60px rgba(0,0,0,0.2), 0 0 0 1px rgba(0,0,0,0.05); padding:12px; opacity:0; transition:opacity 0.2s ease, transform 0.2s ease; align-items:center; justify-content:center;';
                        preview.querySelector('#canon-image-preview-img').style.cssText = 'width:100%; height:100%; background-size:contain; background-position:center; background-repeat:no-repeat; border-radius:8px; display:block;';
                        document.body.appendChild(preview);
                    }
                    
                    const wrapper = document.getElementById('canon-app-wrapper');
                    const wWidth = wrapper ? wrapper.clientWidth : window.innerWidth;
                    
                    let arStr = el.style.aspectRatio;
                    let arVal = 1380 / 500; 
                    if (arStr) {
                        if (arStr.includes('/')) {
                            let parts = arStr.split('/');
                            arVal = parseFloat(parts[0]) / parseFloat(parts[1]);
                        } else {
                            arVal = parseFloat(arStr) || arVal;
                        }
                    }
                    
                    let maxW = Math.min(wWidth * 0.9, window.innerWidth * 0.95);
                    let maxH = window.innerHeight * 0.8;
                    
                    let targetW = maxW;
                    let targetH = targetW / arVal;
                    
                    if (targetH > maxH) {
                        targetH = maxH;
                        targetW = targetH * arVal;
                    }
                    
                    preview.style.width = targetW + 'px';
                    preview.style.height = targetH + 'px';
                    preview.style.maxWidth = 'none';
                    preview.style.maxHeight = 'none';
                    preview.style.boxSizing = 'border-box';
                    
                    let imgNode = document.getElementById('canon-image-preview-img');
                    imgNode.style.backgroundImage = `url('${url}')`;
                    imgNode.style.width = '100%';
                    imgNode.style.height = '100%';
                    
                    preview.style.display = 'flex';
                    
                    void preview.offsetWidth; 
                    preview.style.opacity = '1';
                    preview.style.transform = 'translate(-50%, -50%)';
                };

                const hidePreview = () => {
                    const preview = document.getElementById('canon-image-preview');
                    if (preview) {
                        preview.style.opacity = '0';
                        preview.style.transform = 'translate(-50%, -48%)';
                        setTimeout(() => { if (preview.style.opacity === '0') preview.style.display = 'none'; }, 200);
                    }
                };

                el.addEventListener('mouseenter', showPreview);
                el.addEventListener('mouseleave', hidePreview);
                el.addEventListener('touchstart', showPreview, {passive: true});
                el.addEventListener('touchend', hidePreview);
                el.addEventListener('touchcancel', hidePreview);
            });
            
            div.querySelectorAll('.sample-img-trigger').forEach(el => {
                el.addEventListener('click', (e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    let modal = document.getElementById('canon-sample-modal');
                    if (!modal) {
                        modal = document.createElement('div');
                        modal.id = 'canon-sample-modal';
                        modal.innerHTML = `
                            <div class="sample-modal-overlay" style="position:fixed; top:0; left:0; right:0; bottom:0; background:rgba(0,0,0,0.85); z-index:2147483647; display:flex; flex-direction:column; align-items:center; justify-content:center; backdrop-filter:blur(10px); -webkit-backdrop-filter:blur(10px);">
                                <button id="sample-modal-close" style="position:absolute; top:20px; right:20px; background:rgba(255,255,255,0.2); color:#fff; border:none; border-radius:50%; width:40px; height:40px; font-size:24px; cursor:pointer; z-index:10; display:flex; align-items:center; justify-content:center;">&times;</button>
                                <div style="flex-grow:1; width:100%; max-height:calc(100% - 130px); display:flex; align-items:center; justify-content:center; padding:20px;">
                                    <img id="sample-modal-img" style="max-width:100%; max-height:100%; object-fit:contain; border-radius:8px; box-shadow:0 10px 30px rgba(0,0,0,0.5);">
                                </div>
                                <div id="sample-modal-thumbs" style="height:110px; width:100%; display:flex; gap:12px; overflow-x:auto; padding:15px 20px; background:rgba(0,0,0,0.4); align-items:center; scrollbar-width:none; justify-content:center;">
                                </div>
                            </div>
                        `;
                        document.body.appendChild(modal);
                        document.getElementById('sample-modal-close').onclick = () => modal.style.display = 'none';
                    }
                    
                    const mainImg = document.getElementById('sample-modal-img');
                    const thumbsContainer = document.getElementById('sample-modal-thumbs');
                    const startIdx = parseInt(el.getAttribute('data-idx'));
                    
                    const setMainImage = (idx) => {
                        mainImg.src = p.samples[idx];
                        thumbsContainer.querySelectorAll('.sample-thumb').forEach((t, i) => {
                            t.style.border = i === idx ? '2px solid #fff' : '2px solid transparent';
                            t.style.opacity = i === idx ? '1' : '0.5';
                        });
                    };

                    thumbsContainer.innerHTML = p.samples.map((url, idx) => `
                        <div class="sample-thumb" style="width:80px; height:80px; flex-shrink:0; background-image:url('${url}'); background-size:cover; background-position:center; cursor:pointer; border-radius:8px; border:2px solid transparent; opacity:0.5; transition:all 0.2s;"></div>
                    `).join('');

                    thumbsContainer.querySelectorAll('.sample-thumb').forEach((thumb, idx) => {
                        thumb.onclick = (ev) => { ev.stopPropagation(); setMainImage(idx); };
                    });

                    setMainImage(startIdx);
                    modal.style.display = 'block';
                });
            });
        });

        if (isHubMode && stickyNav) {
            const actionGroup = document.createElement('div');
            actionGroup.style.cssText = 'margin-left: auto; position: sticky; right: 0; display: flex; gap: 8px; z-index: 10; background: inherit; padding-left: 15px; box-shadow: -15px 0 20px rgba(242,242,247, 0.85); align-items: center;';

            const wizardBtn = document.createElement('button');
            wizardBtn.className = 'canon-nav-wizard-btn';
            wizardBtn.style.cssText = 'margin-left: 0; position: static; box-shadow: 0 4px 15px rgba(138, 63, 243, 0.4); right: auto;';
            wizardBtn.textContent = t.btn_find_perfect_match;
            wizardBtn.onclick = (e) => {
                e.preventDefault();
                scrollToVA();
            };

            const topBtn = document.createElement('button');
            topBtn.className = 'canon-top-btn';
            topBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg>';
            topBtn.onclick = (e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: 'smooth' }); // Back to top
            };

            actionGroup.appendChild(wizardBtn);
            actionGroup.appendChild(topBtn);
            stickyNav.appendChild(actionGroup);
        }

        if (isHubMode && finalProducts.length > 0) {
            const finalSeparator = document.createElement('div');
            finalSeparator.style.gridColumn = "1 / -1";
            finalSeparator.style.height = "2px";
            finalSeparator.style.backgroundColor = "#d2d2d7";
            finalSeparator.style.marginTop = "30px";
            finalSeparator.style.marginBottom = "10px";
            grid.appendChild(finalSeparator);
        }
        
        grid.scrollTop = 0;

        if (stickyNav) {
            setTimeout(() => {
                const navItems = stickyNav.querySelectorAll('.canon-hub-nav-item');
                const headers = grid.querySelectorAll('.canon-group-header');

                const scrollSpy = () => {
                    const gridRect = grid.getBoundingClientRect();
                    const STICKY_TOP = 65; 
                    
                    if (stickyNav.parentElement) {
                        stickyNav.style.setProperty('--nav-offset-left', `-${stickyNav.parentElement.getBoundingClientRect().left}px`);
                    }

                    if (gridRect.top <= STICKY_TOP && gridRect.bottom > 200) {
                        stickyNav.classList.add('is-stuck');
                    } else {
                        stickyNav.classList.remove('is-stuck');
                    }

                    let currentActiveId = null;
                    headers.forEach(h => {
                        const rect = h.getBoundingClientRect();
                        if (rect.top <= STICKY_TOP + 80) currentActiveId = h.id;
                    });

                    if (currentActiveId) {
                        let currentActiveBtn = stickyNav.querySelector(`[data-target="${currentActiveId}"]`);
                        if (currentActiveBtn && !currentActiveBtn.classList.contains('active')) {
                            navItems.forEach(item => item.classList.remove('active'));
                            currentActiveBtn.classList.add('active');
                            const scrollLeft = currentActiveBtn.offsetLeft - (stickyNav.offsetWidth / 2) + (currentActiveBtn.offsetWidth / 2);
                            stickyNav.scrollTo({ left: scrollLeft, behavior: 'smooth' });
                        }
                    }
                };

                window.addEventListener('scroll', scrollSpy, {passive: true});
                grid.addEventListener('scroll', scrollSpy, {passive: true});
                scrollSpy();
            }, 100);
        }
    }


    function setupOmniSearch(inputId, dropId, clearId, toggleId = null, forceMode = null) {
        const input = document.getElementById(inputId);
        const dropdown = document.getElementById(dropId);
        const clearBtn = document.getElementById(clearId);
        const toggleBtn = toggleId ? document.getElementById(toggleId) : null;
        if (!input || !dropdown) return;

        const checkAndReloadData = () => {
            if (window.CANON_GLOBAL_DATA && window.CANON_GLOBAL_DATA.PRODUCT_DB && window.CANON_GLOBAL_DATA.PRODUCT_DB.INK && window.CANON_GLOBAL_DATA.PRODUCT_DB.INK.length > 5) {
                if (!productData || !productData.INK_DB || productData.INK_DB.length < 5) {
                    if (typeof window.reloadVAData === 'function') window.reloadVAData();
                }
            }
        };
        input.addEventListener('focus', checkAndReloadData);
        input.addEventListener('click', checkAndReloadData);

        const normalize = s => (s||'').toString().toLowerCase().replace(/\s+/g,'').replace(/[\-_/]/g,'');

        let currentFocus = -1;

        function doSearch(showAll = false) {
            currentFocus = -1;
            const q = input.value;
            const nq = normalize(q);
            
            if (!nq && !showAll) { 
                dropdown.classList.remove('is-open'); 
                if(clearBtn) clearBtn.style.display = 'none'; 
                return; 
            }
            if(clearBtn) clearBtn.style.display = nq ? 'block' : 'none';

            let shortcutHtml = '';
            if (!showAll && nq.length > 0 && typeof APP_CONFIG !== 'undefined' && APP_CONFIG.menu_tree) {
                let addedTargets = new Set();
                let qLower = q.toLowerCase().trim();
                for (let key in APP_CONFIG.menu_tree) {
                    APP_CONFIG.menu_tree[key].forEach(item => {
                        if (item.type !== 'link' && item.type !== 'mode') return; 
                        let uniqueKey = item.url || item.target;
                        if (!uniqueKey || addedTargets.has(uniqueKey)) return;
                        
                        let isMatch = false;
                        let terms = [item.label.zh || '', item.label.en || '', ...(item.tags || '').split(',')];
                        for (let term of terms) {
                            if (!term) continue;
                            let tLower = term.toLowerCase().trim();
                            
                            if (qLower.length <= 2 && /^[a-z0-9]+$/.test(qLower)) {
                                let regex = new RegExp('(^|[\\s\\-_/])' + qLower.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
                                if (regex.test(tLower)) { isMatch = true; break; }
                            } else {
                                if (tLower.includes(qLower)) { isMatch = true; break; }
                                
                                let tNorm = normalize(term);
                                if (tNorm.includes(nq)) {
                                    if (!term.includes(' ') || nq.length >= 3) {
                                        isMatch = true; break;
                                    }
                                    let words = tLower.split(' ');
                                    if (words.some(w => normalize(w).includes(nq))) {
                                        isMatch = true; break;
                                    }
                                }
                            }
                        }

                        if (isMatch) {
                            let clickAction = item.type === 'link' 
                                ? `window.location.href='${item.url}'` 
                                : `canonApp.routeToMode('${item.target}'); document.getElementById('${dropId}').classList.remove('is-open'); document.getElementById('${inputId}').value='';`;
                            
                            let actionText = (typeof lang !== 'undefined' && lang === 'en') ? 'Go Now &rarr;' : '即刻去睇 &rarr;';
                            let dispLabel = item.label[typeof lang !== 'undefined' ? lang : 'zh'] || item.label.zh;

                            let gtagShortcut = `if(typeof gtag === 'function') gtag('event', 'va_omni_shortcut_click', { search_keyword: '${q.replace(/'/g, "\\'")}', shortcut_label: '${dispLabel.replace(/'/g, "\\'")}' });`;
                            let clickActionWithGtag = `${gtagShortcut} ${clickAction}`;

                            let shortcutTouchStr = `ontouchstart="this.setAttribute('data-t', '0');" ontouchmove="this.setAttribute('data-t', '1');" ontouchend="if(this.getAttribute('data-t') === '0') { event.preventDefault(); ${clickActionWithGtag} }"`;

                            
                            shortcutHtml += `<div class="omni-shortcut" style="padding:12px 16px; background:#f5f5f7; margin-bottom:8px; border-radius:8px; display:flex; justify-content:space-between; align-items:center; cursor:pointer; transition: background 0.2s;" onmouseover="this.style.background='#e8e8ed'" onmouseout="this.style.background='#f5f5f7'" onmousedown="event.preventDefault();" onclick="${clickActionWithGtag}" ${shortcutTouchStr}>
                                <div style="display:flex; align-items:center; gap:8px;">
                                    <span style="font-size:16px;">💡</span>
                                    <span style="font-weight:600; color:#1d1d1f;">${dispLabel}</span>
                                </div>
                                <span style="font-size:13px; color:#0066cc; font-weight:500;">${actionText}</span>
                            </div>`;
                            addedTargets.add(uniqueKey);
                        }
                    });
                }
            }

            if (forceMode) {
                let consumables = productData[forceMode === 'ink' ? 'INK_DB' : 'TONER_DB'];
                if (nq) {
                    consumables = consumables.filter(c => normalize(c.m).includes(nq) || normalize(c.t).includes(nq) || (c.inks && c.inks.some(ink => normalize(ink).includes(nq))));
                }
                renderSpecificDropdown(dropdown, q, consumables, forceMode);
                if (shortcutHtml) dropdown.innerHTML = `<div style="padding: 0 10px;">${shortcutHtml}</div>` + dropdown.innerHTML;
                dropdown.classList.add('is-open');
            } else {
                let cameras = [...(productData.CAMERA_DB || [])].filter(p => normalize(p.model).includes(nq));
                let lenses = [...(productData.LENS_DB || [])].filter(p => normalize(p.model).includes(nq));
                let printers = [...(productData.PRINTER_DB || [])].filter(p => normalize(p.model).includes(nq));
                
                let inkData = (productData.INK_DB || []).map(c => ({...c, _cType: 'ink'}));
                let tonerData = (productData.TONER_DB || []).map(c => ({...c, _cType: 'toner'}));
                let consumables = [...inkData, ...tonerData].filter(c => normalize(c.m).includes(nq) || normalize(c.t).includes(nq) || (c.inks && c.inks.some(ink => normalize(ink).includes(nq))));
                
                if (typeof window.VA_LIQUID_PRICES !== 'undefined') {
                    let addedHandles = new Set();
                    [...cameras, ...lenses, ...printers].forEach(p => { let m = (p.url||'').match(/\/products\/([^/?]+)/); if(m) addedHandles.add(m[1]); });
                    consumables.forEach(c => { let m = (c.u||'').match(/\/products\/([^/?]+)/); if(m) addedHandles.add(m[1]); });
                    
                    for (let handle in window.VA_LIQUID_PRICES) {
                        let item = window.VA_LIQUID_PRICES[handle];
                        let itemTitle = item.title || '';
                        if (!addedHandles.has(handle) && (normalize(itemTitle).includes(nq) || normalize(handle).includes(nq))) {
                            let formattedItem = { model: itemTitle, url: item.url || `/products/${handle}`, image: item.image, handle: handle };
                            let hLower = handle.toLowerCase();
                            let tLower = itemTitle.toLowerCase();
                            
                            if (hLower.includes('eos') || hLower.includes('powershot') || hLower.includes('ixus') || hLower.includes('camera') || tLower.includes('相機')) {
                                cameras.push(formattedItem);
                            } else if (hLower.match(/^(rf|ef|cn-e)/) || hLower.includes('lens') || tLower.includes('鏡頭')) {
                                lenses.push(formattedItem);
                            } else if (hLower.includes('cartridge') || hLower.match(/^(pg-|cl-|gi-|pfi-|cli-|bci-|ep-|mc-)/) || hLower.includes('ink') || hLower.includes('toner') || tLower.includes('墨') || tLower.includes('碳粉')) {
                                let isToner = hLower.includes('toner') || tLower.includes('碳粉') || hLower.includes('cartridge') || hLower.match(/^(ep-)/);
                                consumables.push({ m: '各款對應打印機', t: itemTitle, i: item.image, u: item.url || `/products/${handle}`, sku: handle, inks: [], _cType: isToner ? 'toner' : 'ink' });
                            } else {
                                printers.push(formattedItem); // Printer, Scanner, Accessories
                            }
                            addedHandles.add(handle);
                        }
                    }
                }
                
                renderOmniDropdown(dropdown, q, cameras, lenses, printers, consumables);
                if (shortcutHtml) dropdown.innerHTML = `<div style="padding: 0 10px;">${shortcutHtml}</div>` + dropdown.innerHTML;
                dropdown.classList.add('is-open');
            }
        }

        input.addEventListener('input', () => doSearch());
        input.addEventListener('focus', () => { if (input.value || forceMode) doSearch(true); });
        
        input.addEventListener('keydown', function(e) {
            let items = dropdown.querySelectorAll('.omni-item, .omni-shortcut, .omni-fallback-btn');
            if (!dropdown.classList.contains('is-open') || items.length === 0) {
                if (e.key === 'Enter' && (forceMode === 'ink' || forceMode === 'toner')) {
                    e.preventDefault();
                    const quickBuyBtnId = forceMode === 'ink' ? 'canonInkQuickBuyBtn' : 'canonTonerQuickBuyBtn';
                    const quickBuyBtn = document.getElementById(quickBuyBtnId);
                    if (quickBuyBtn && !quickBuyBtn.classList.contains('btn-disabled') && quickBuyBtn.style.display !== 'none') {
                        quickBuyBtn.click();
                    }
                }

                return;
            }

            if (e.key === 'ArrowDown') {
                e.preventDefault();
                currentFocus++;
                addActive(items);
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                currentFocus--;
                addActive(items);
            } else if (e.key === 'Enter') {
                e.preventDefault();
                if (currentFocus > -1 && items[currentFocus]) {
                    items[currentFocus].click();
                } else if (items.length > 0) {
                    items[0].click();
                }
            }
        });

        function addActive(items) {
            if (!items) return;
            for (let i = 0; i < items.length; i++) {
                items[i].classList.remove('is-focused');
            }
            if (currentFocus >= items.length) currentFocus = 0;
            if (currentFocus < 0) currentFocus = (items.length - 1);
            items[currentFocus].classList.add('is-focused');
            items[currentFocus].scrollIntoView({ block: 'nearest' });
        }

        if(clearBtn) clearBtn.addEventListener('click', () => { input.value = ''; doSearch(); input.focus(); });
        
        if(toggleBtn) {
            toggleBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                if(dropdown.classList.contains('is-open')) {
                    dropdown.classList.remove('is-open');
                } else {
                    doSearch(true);
                    input.focus();
                }
            });
        }
        
        document.addEventListener('click', (e) => {
            if (!input.contains(e.target) && !dropdown.contains(e.target) && (!toggleBtn || !toggleBtn.contains(e.target))) {
                dropdown.classList.remove('is-open');
            }
        });
    }

    function findConsumableForPrinter(printerModel) {
        const nm = (printerModel||'').toString().toLowerCase().replace(/\s+/g,'').replace(/[\-_/]/g,'');
        let match = productData.INK_DB.find(c => nm.includes(c.m.toLowerCase().replace(/[\-_/]/g,'')) || c.m.toLowerCase().replace(/[\-_/]/g,'').includes(nm));
        if (match) return { type: 'ink', data: match };
        match = productData.TONER_DB.find(c => nm.includes(c.m.toLowerCase().replace(/[\-_/]/g,'')) || c.m.toLowerCase().replace(/[\-_/]/g,'').includes(nm));
        if (match) return { type: 'toner', data: match };
        return null;
    }

    function highlight(text, q) {
        if(!q) return text;
        const regex = new RegExp(`(${q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
        return text.replace(regex, '<span class="omni-highlight">$1</span>');
    }

    function renderOmniDropdown(container, query, cameras, lenses, printers, consumables) {
        let html = '';
        
        const renderBlock = (items, title) => {
            if (items.length === 0) return '';
            let blockHtml = `<div class="omni-group-title">${title}</div>`;
            items.slice(0, 6).forEach(p => {
                let imgUrl = p.image || '';
                let imgHtml = imgUrl ? `<div style="width:56px; height:56px; background-image:url('${imgUrl}'); background-size:contain; background-position:center; background-repeat:no-repeat; flex-shrink:0; margin-right:16px; border-radius:8px; background-color:#fff; border:1px solid #f5f5f7;"></div>` : '';
                
                let gtagItem = `if(typeof gtag === 'function') gtag('event', 'va_omni_search_click', { search_keyword: '${query.replace(/'/g, "\\'")}', clicked_model: '${p.model.replace(/'/g, "\\'")}', item_type: 'product' });`;
                
                let itemTouchStr = `ontouchstart="this.setAttribute('data-t', '0');" ontouchmove="this.setAttribute('data-t', '1');" ontouchend="if(this.getAttribute('data-t') === '0') { event.preventDefault(); ${gtagItem} window.location.href='${p.url}'; }"`;
                let linkTouchStr = `ontouchstart="event.stopPropagation(); this.setAttribute('data-t', '0');" ontouchmove="this.setAttribute('data-t', '1');" ontouchend="if(this.getAttribute('data-t') === '0') { event.preventDefault(); event.stopPropagation(); ${gtagItem} window.location.href='${p.url}'; }"`;
                
                blockHtml += `
                    <div class="omni-item" style="display:flex; align-items:center; padding:12px 16px; height:auto !important; min-height:70px;" onmousedown="event.preventDefault();" onclick="${gtagItem} window.location.href='${p.url}'" ${itemTouchStr}>
                        ${imgHtml}
                        <div class="omni-item-main" style="flex-grow:1; display:flex; justify-content:space-between; align-items:center; min-width:0; gap:12px;">
                            
                            <div style="display:flex; flex-direction:column; flex:1 1 0%; min-width:0;">
                                <div style="font-weight:600; font-size:15px; color:#1d1d1f; white-space:normal; word-break:break-word; margin-bottom:4px;">
                                    ${highlight(p.model, query)}
                                </div>
                                
                                <div style="display:block; line-height:1.2;">
                                    ${generatePromoPills(p.sku || p.handle, 'search')}
                                </div>
                            </div>
                            
                            <a href="${p.url}" class="canon-finder__cta btn-buy-mini" onmousedown="event.preventDefault();" onclick="event.stopPropagation(); ${gtagItem}" style="position:relative !important; right:auto !important; top:auto !important; transform:none !important; flex-shrink:0 !important; white-space:nowrap !important; margin:0 !important;" ${linkTouchStr}>${t.btn_buy}</a>
                        </div>
                    </div>`;
            });
            return blockHtml;
        };

        html += renderBlock(cameras, t.group_cameras);
        html += renderBlock(lenses, t.group_lenses);
        html += renderBlock(printers, t.group_printer);

        if (consumables.length > 0) {
            html += `<div class="omni-group-title">${t.group_consumable}</div>`;
            const uniqueItems = [];
            const seenKeys = new Set();
            
            // Define normalize locally because renderOmniDropdown is outside setupOmniSearch
            const normalizeStr = s => (s||'').toString().toLowerCase().replace(/\s+/g,'').replace(/[\-_/]/g,'');
            const nq = normalizeStr(query);
            
            consumables.forEach(c => {
                let isPrinterMatch = nq ? normalizeStr(c.m).includes(nq) : false;
                
                if (isPrinterMatch) {
                    let key = 'printer:' + c.m;
                    if (!seenKeys.has(key)) { seenKeys.add(key); uniqueItems.push({ type: 'printer', raw: c }); }
                } else {
                    let key = 'ink:' + c.t;
                    if (!seenKeys.has(key)) { seenKeys.add(key); uniqueItems.push({ type: 'consumable', raw: c }); }
                }
            });
            
            uniqueItems.slice(0, 8).forEach(item => {
                let c = item.raw;
                let isPrinter = item.type === 'printer';
                
                let titleText = '';
                let subTextHtml = '';
                let hoverTips = '';
                
                if (isPrinter) {
                    let isToner = c._cType === 'toner';
                    let isPhotoPrinter = /selphy|inspic/i.test(c.m || '');
                    let tmpl = isToner ? t.omni_toner_for_printer : (isPhotoPrinter ? t.omni_paper_for_printer : t.omni_ink_for_printer);
                    titleText = tmpl.replace('{x}', highlight(c.m, query));
                    let inksStr = (c.inks && c.inks.length > 0) ? ` (${c.inks.join(', ')})` : '';
                    subTextHtml = `<span style="font-size:12px; color:#86868b; font-weight:400; margin-left: 0px; display:block; margin-top:4px;">${c.t}<span style="opacity:0.8">${inksStr}</span></span>`;
                } else {
                    titleText = highlight(c.t, query);
                    subTextHtml = `<span style="font-size:12px; color:#86868b; font-weight:400; margin-left: 0px; display:block; margin-top:4px;">${t.spec_applicable_for} <span>${highlight(c.m, query)}</span> ${t.spec_etc}</span>`;
                    if (c.inks && c.inks.length > 0) hoverTips = `<div style="font-size: 11px; color: #86868b; margin-top: 6px; white-space: normal; line-height: 1.4;"><strong>${t.ink_hover_title}</strong> ${c.inks.join(', ')}</div>`;
                }
                
                let imgUrl = c.i || '';
                let imgHtml = imgUrl ? `<div style="width:56px; height:56px; background-image:url('${imgUrl}'); background-size:contain; background-position:center; background-repeat:no-repeat; flex-shrink:0; margin-right:16px; border-radius:8px; background-color:#fff; border:1px solid #f5f5f7; margin-top:4px;"></div>` : '';
                
                let encodedC = encodeURIComponent(JSON.stringify(c)).replace(/'/g, "%27");
                let gtagConsumable = `if(typeof gtag === 'function') gtag('event', 'va_omni_search_click', { search_keyword: '${query.replace(/'/g, "\\'")}', clicked_model: '${c.t.replace(/'/g, "\\'")}', item_type: '${isPrinter ? 'printer_ink' : 'consumable'}' });`;
                
                let searchTypeArg = isPrinter ? "'printer'" : "'consumable'";
                let quickBuyAction = `event.stopPropagation(); ${gtagConsumable} canonApp.triggerGlobalQuickBuy('${encodedC}', ${searchTypeArg});`;
                let detailsAction = `event.stopPropagation(); ${gtagConsumable} window.location.href='${c.u}';`;
                
                let itemTouchStr = `ontouchstart="this.setAttribute('data-t', '0');" ontouchmove="this.setAttribute('data-t', '1');" ontouchend="if(this.getAttribute('data-t') === '0') { event.preventDefault(); ${gtagConsumable} canonApp.triggerGlobalQuickBuy('${encodedC}', ${searchTypeArg}); }"`;
                let btnTouchStr = `ontouchstart="event.stopPropagation(); this.setAttribute('data-t', '0');" ontouchmove="this.setAttribute('data-t', '1');" ontouchend="if(this.getAttribute('data-t') === '0') { event.preventDefault(); event.stopPropagation(); ${gtagConsumable} canonApp.triggerGlobalQuickBuy('${encodedC}', ${searchTypeArg}); }"`;
                let linkTouchStr = `ontouchstart="event.stopPropagation(); this.setAttribute('data-t', '0');" ontouchmove="this.setAttribute('data-t', '1');" ontouchend="if(this.getAttribute('data-t') === '0') { event.preventDefault(); event.stopPropagation(); ${gtagConsumable} window.location.href='${c.u}'; }"`;

                html += `
                    <div class="omni-item omni-consumable-item" style="display:flex; align-items:flex-start; border-bottom:1px solid #f5f5f7; padding:12px 16px;" onmousedown="event.preventDefault();" onclick="${gtagConsumable} canonApp.triggerGlobalQuickBuy('${encodedC}', ${searchTypeArg});" ${itemTouchStr}>
                        ${imgHtml}
                        <div class="omni-item-main" style="flex-grow:1; justify-content:space-between; align-items: flex-start; flex-direction:row; gap:10px;">
                            <div style="display:flex; flex-direction: column; gap:4px; max-width: calc(100% - 95px);">
                                <div>
                                    <span style="font-weight:600; font-size:15px; color:#1d1d1f; display:flex; align-items:center; flex-wrap:wrap; gap:4px;">
                                        <span>${titleText}</span>
                                        ${generatePromoPills(c.sku, 'search')}
                                    </span>
                                    ${subTextHtml}
                                </div>
                                ${hoverTips}
                            </div>
                            <div style="display:flex; flex-direction:column; gap:6px; flex-shrink:0; min-width:85px;">
                                <button class="canon-finder__cta btn-buy-mini" style="align-self:stretch !important; width:auto !important; background:#0070c9 !important; color:#fff !important; border:none !important; padding:6px 12px !important; font-size:12px !important; white-space:nowrap !important;" onmousedown="event.preventDefault();" onclick="${quickBuyAction}" ${btnTouchStr}>${lang==='zh'?'幫我落埋單':'Quick Buy'}</button>
                                <a href="${c.u}" class="canon-finder__cta btn-buy-mini reset-btn" style="align-self:stretch !important; width:auto !important; padding:6px 12px !important; text-align:center; font-size:12px !important; justify-content:center; box-shadow:none !important; white-space:nowrap !important;" onmousedown="event.preventDefault();" onclick="${detailsAction}" ${linkTouchStr}>${lang==='zh'?'詳情':'Details'}</a>
                            </div>
                        </div>
                    </div>`;
            });
        }

        let searchBaseUrl = lang === 'en' ? 'https://store.hk.canon/en/search' : 'https://store.hk.canon/search';
        let gtagFallback = `if(typeof gtag === 'function') gtag('event', 'va_omni_fallback_click', { search_keyword: '${query.replace(/'/g, "\\'")}' });`;
        html += `<a href="${searchBaseUrl}?q=${encodeURIComponent(query)}" class="omni-fallback-btn" onclick="${gtagFallback}">${t.search_fallback.replace('{query}', query)}</a>`;
        container.innerHTML = html;
    }

    function renderSpecificDropdown(container, query, consumables, mode) {
        container.innerHTML = ''; 
        
        let uniqueConsumables = [];
        let seenKeys = new Set();
        
        const normalizeKey = s => (s||'').toString().toLowerCase().replace(/\s+/g,'').replace(/[\-_/]/g,'');
        const nq = normalizeKey(query);

        consumables.forEach(c => {
            let isInkMatch = nq ? normalizeKey(c.t).includes(nq) || (c.inks && c.inks.some(ink => normalizeKey(ink).includes(nq))) : false;
            let isPrinterMatch = nq ? normalizeKey(c.m).includes(nq) : true;

            if (isInkMatch && !isPrinterMatch) {
                let key = 'ink:' + c.t;
                if (!seenKeys.has(key)) {
                    seenKeys.add(key);
                    uniqueConsumables.push({ type: 'ink', main: c.t, sub: c.m, raw: c });
                }
            } else {
                let key = 'printer:' + c.m;
                if (!seenKeys.has(key)) {
                    seenKeys.add(key);
                    uniqueConsumables.push({ type: 'printer', main: c.m, sub: c.t, raw: c });
                }
            }
        });

        if (uniqueConsumables.length === 0) { 
            container.innerHTML = `<div class="omni-item" style="cursor:default; color:#86868b;">${t.no_relevant_models}</div>`; 
            return; 
        }
        
        uniqueConsumables.sort((a, b) => a.main.localeCompare(b.main));
        
        uniqueConsumables.forEach(item => {
            const div = document.createElement('div');
            div.className = 'omni-item';
            
            if (item.type === 'ink') {
                div.innerHTML = `<div class="omni-item-main" style="justify-content:flex-start; gap:10px;"><span>${highlight(item.main, query)}</span> <span style="font-size:12px; color:#86868b; font-weight:400;">(${t.spec_applicable_for}: <span>${highlight(item.sub, query)}</span> ${t.spec_etc})</span></div>`;
            } else {
                let applicableLabel = t.spec_applicable_ink;
                if (mode === 'ink' && /selphy|inspic/i.test(item.main || '')) {
                    applicableLabel = lang === 'en' ? 'Suitable Photo Paper' : '適用相紙';
                }
                let displayLabel = mode === 'ink' ? applicableLabel : t.spec_applicable_toner;
                div.innerHTML = `<div class="omni-item-main" style="justify-content:flex-start; gap:10px;"><span>${highlight(item.main, query)}</span> <span style="font-size:12px; color:#86868b; font-weight:400;">(${displayLabel}: <span>${highlight(item.sub, query)}</span>)</span></div>`;
            }
            
            div.onclick = () => { 
                selectConsumable(item.raw, mode, item.type === 'ink' ? 'consumable' : 'printer'); 
                container.classList.remove('is-open'); 
            };
            container.appendChild(div);
        });
    }

    function selectConsumable(row, mode, searchType = 'printer') {
        const isInk = mode === 'ink';
        const isConsumableSearch = searchType === 'consumable';
        
        let activeInput = document.getElementById(isInk ? 'canonInkInput' : 'canonTonerInput');
        let omniInput = document.getElementById('canonOmniInput');
        let searchKeyword = activeInput.value.trim() || (omniInput ? omniInput.value.trim() : '');

        if (typeof gtag === 'function') {
            gtag('event', 'va_consumable_select', {
                va_mode: mode,
                search_type: searchType,
                search_keyword: searchKeyword,
                printer_model: row.m,
                consumable_model: row.t
            });
        }

        document.getElementById(isInk ? 'canonInkInput' : 'canonTonerInput').value = isConsumableSearch ? row.t : row.m;
        
        const rowEl = document.getElementById(isInk ? 'canonInkRow' : 'canonTonerRow');
        rowEl.classList.remove('is-empty');
        
        const nameEl = document.getElementById(isInk ? 'canonInkName' : 'canonTonerName');
        nameEl.textContent = row.t;
        nameEl.style.color = "#1d1d1f";
            const promoContainer = document.getElementById(isInk ? 'inkPromoPills' : 'tonerPromoPills');
            if (promoContainer) {
                promoContainer.innerHTML = generatePromoPills(row.sku, 'search');
            }

        
        if (isInk) {
            const isPhotoPrinter = /selphy|inspic/i.test(row.m || '');
            const metaLabelEl = document.getElementById('canonInkMetaLabel');
            if (metaLabelEl) {
                metaLabelEl.innerText = isPhotoPrinter 
                    ? (lang === 'en' ? 'Suitable Photo Paper Series:' : '適用之相紙系列：') 
                    : t.ink_suitable;
            }

            const detailsContainer = document.getElementById('canonInkListDetails');
            if (isConsumableSearch) {
                detailsContainer.innerHTML = '';
            } else {
                const badgesHtml = row.inks.map(ink => `<span class="canon-ink-badge">${ink}</span>`).join('');
                const tmpl = isPhotoPrinter ? t.spec_supported_papers : t.spec_supported_inks;
                const titleStr = tmpl.replace('{x}', row.m);
                detailsContainer.innerHTML = badgesHtml ? `<div style="font-size: 12px; color: #86868b; margin-bottom: 6px; margin-top: 8px;">${titleStr}</div><div style="display:flex; flex-wrap:wrap; gap:6px;">${badgesHtml}</div>` : '';
            }
        }

        const buyBtn = document.getElementById(isInk ? 'canonInkBuyBtn' : 'canonTonerBuyBtn');
        buyBtn.href = row.u;
        buyBtn.removeAttribute('target');
        buyBtn.classList.remove('btn-disabled');
        buyBtn.style.display = ''; 
        buyBtn.onclick = null; 
        
        const qbBtn = document.getElementById(isInk ? 'canonInkQuickBuyBtn' : 'canonTonerQuickBuyBtn');
        if (qbBtn) { 
            qbBtn.classList.remove('btn-disabled');
            qbBtn.style.display = 'flex';
            qbBtn.onclick = () => {
                qbBtn.style.display = 'none';
                if (buyBtn) buyBtn.style.display = 'none';
                renderInlineCheckout(row.sku, isInk ? 'canonInkInlineCheckout' : 'canonTonerInlineCheckout', isInk ? 'canonInkRow' : 'canonTonerRow', searchType, row);
            };
        }

        const inlineContainer = document.getElementById(isInk ? 'canonInkInlineCheckout' : 'canonTonerInlineCheckout');
        if (inlineContainer) { 
            inlineContainer.style.display = 'none';
            inlineContainer.innerHTML = ''; 
        }

        const imgDiv = document.getElementById(isInk ? 'canonInkImg' : 'canonTonerImg');
        imgDiv.style.backgroundImage = `url('${row.i}')`;
        imgDiv.style.width = '90px';
        imgDiv.style.height = '90px';
    }
    
    function parsePreorderValue(val, isZh, vTitle) {
        if (!val) return null;
        const trimmed = String(val).trim();
        if (trimmed === '') return null;

        // Check if YYYY-MM-DD
        const dateRegex = /^(\d{4})-(\d{2})-(\d{2})$/;
        const match = trimmed.match(dateRegex);

        const prefixZh = vTitle ? `${vTitle} 為預訂貨品` : `此乃預訂貨品`;
        const prefixEn = vTitle ? `${vTitle} is a pre-order item` : `This is a pre-order item`;

        if (match) {
            const year = parseInt(match[1], 10);
            const month = parseInt(match[2], 10);
            const day = parseInt(match[3], 10);

            const targetDate = new Date(year, month - 1, day, 23, 59, 59);
            const today = new Date();

            if (targetDate <= today) {
                return null;
            }

            const monthsEn = [
                "January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
            ];
            
            // Format: "X 為預訂貨品，預計送貨日期：XXXX 年 X 月 X 日"
            const text = isZh ? `${prefixZh}，預計送貨日期：${year} 年 ${month} 月 ${day} 日` : `${prefixEn}, expected delivery date: ${monthsEn[month-1]} ${day}, ${year}`;
            const propVal = isZh ? `本訂單所有貨品最早送貨日期：${year} 年 ${month} 月 ${day} 日` : `Earliest delivery date for all items in this order: ${monthsEn[month-1]} ${day}, ${year}`;
            
            const consent = isZh 
                ? `本人同意以下安排：此乃預訂貨品。同一訂單之所有產品將最早一同於 ${year} 年 ${month} 月 ${day} 日送貨。如同一訂單有其他預訂貨品，則以最遲之日期作準。(如訂單中部分貨品有現貨，而你想先收到這些產品，請獨立為預訂貨品建立新訂單。) 必須先付全數金額。訂單不能取消及退款。`
                : `I agree to the following arrangements: This is a pre-order item. All items in the same order will be delivered together earliest on ${monthsEn[month-1]} ${day}, ${year}. If the order contains other pre-order items, the latest delivery date will apply. (If your order includes in-stock items and you wish to receive them first, please place a separate order for the pre-order items). Full payment is required in advance. Orders cannot be cancelled or refunded.`;

            return {
                type: 'date',
                val: trimmed,
                text: text,
                propVal: propVal,
                consent: consent,
                targetDate: targetDate
            };
        } else {
            const days = parseInt(trimmed, 10);
            if (isNaN(days) || days <= 0) return null;

            const today = new Date();
            const targetDate = new Date(today.getTime() + days * 24 * 60 * 60 * 1000);

            const text = isZh ? `${prefixZh}，預計 ${days} 天後送貨` : `${prefixEn}, expected delivery in ${days} days`;
            const propVal = isZh ? `本訂單所有貨品最快於 ${days} 天後送貨` : `Earliest delivery for all items in this order: in ${days} days`;
            
            const consent = isZh
                ? `本人同意以下安排：此乃預訂貨品。同一訂單之所有產品最快將於 ${days} 天後一同送貨。如同一訂單有其他預訂貨品，則以最遲之日期作準。(如訂單中部分貨品有現貨，而你想先收到這些產品，請獨立為預訂貨品建立新訂單。) 必須先付全數金額。訂單不能取消及退款。`
                : `I agree to the following arrangements: This is a pre-order item. All items in the same order will be delivered together earliest in ${days} days. If the order contains other pre-order items, the latest delivery date will apply. (If your order includes in-stock items and you wish to receive them first, please place a separate order for the pre-order items). Full payment is required in advance. Orders cannot be cancelled or refunded.`;

            return {
                type: 'days',
                val: days,
                text: text,
                propVal: propVal,
                consent: consent,
                targetDate: targetDate
            };
        }
    }

    const formatMoney = (cents) => 'HK$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    
    function renderInlineCheckout(sku, containerId, rowId, searchType, rowData) {
        const container = document.getElementById(containerId);
        const row = document.getElementById(rowId);
        const imgEl = row.querySelector('.canon-finder__thumb-bg');

        imgEl.style.width = '60px';
        imgEl.style.height = '60px';

        container.style.display = 'block';
        setTimeout(() => {
            const y = container.getBoundingClientRect().top + window.scrollY - 100;
            window.scrollTo({top: y, behavior: 'smooth'});
        }, 50);

        let variants = window.CANON_GLOBAL_DATA?.SHOPIFY_DATA?.variants[sku] || [];
        let liquidData = window.VA_LIQUID_PRICES?.[sku];
        
        let matchedBundles = [];
        if (liquidData) {
            let pId = liquidData.id;
            let pColls = liquidData.collections || [];
            const now = Math.floor(Date.now() / 1000);
            (window.CANON_GLOBAL_DATA?.SHOPIFY_DATA?.bundles || []).forEach(b => {
                let sTime = b.start_time || b.start;
                let eTime = b.end_time || b.end;
                if (typeof sTime === 'string') sTime = Math.floor(new Date(sTime).getTime() / 1000);
                if (typeof eTime === 'string') eTime = Math.floor(new Date(eTime).getTime() / 1000) + 86399;
                
                if (sTime && sTime > now) return;
                if (eTime && eTime < now) return;

                let isMatch = b.storewide || (pId && b.product_ids?.includes(pId)) || (pColls.length > 0 && b.collection_ids && pColls.some(cid => b.collection_ids.includes(cid)));
                if (isMatch) matchedBundles.push(b);
            });
        }

        // Filtering & Labeling logic for specific ink series
        const isFilterTarget = VA_CONSUMABLE_CONFIG.applyAll || VA_CONSUMABLE_CONFIG.whitelistHandles.includes(sku);
        let allPrintersForThisSeries = [];
        if (isFilterTarget && searchType === 'consumable') {
            const dbName = sku.includes('toner') ? 'TONER_DB' : 'INK_DB';
            allPrintersForThisSeries = (productData[dbName] || []).filter(c => c.sku === sku);
        }

        // Retrieve and render matching promotions in compact format
        let promoHtml = '';
        if (liquidData) {
            let pId = String(liquidData.id || '').trim();
            let pColls = liquidData.collections || [];
            
            let pVarIdsStr = [];
            if (variants) {
                variants.forEach(v => pVarIdsStr.push(String(v.id || v).trim()));
            }
            pVarIdsStr = [...new Set(pVarIdsStr)].filter(Boolean);

            const now = Math.floor(Date.now() / 1000);
            const isMatch = (promo) => {
                let sTime = promo.start_time || promo.start;
                let eTime = promo.end_time || promo.end;
                if (typeof sTime === 'string') sTime = Math.floor(new Date(sTime).getTime() / 1000);
                if (typeof eTime === 'string') eTime = Math.floor(new Date(eTime).getTime() / 1000) + 86399;
                
                if (sTime && sTime > now) return false;
                if (eTime && eTime < now) return false;

                if (promo.storewide === true || promo.storewide === 'true') return true;
                
                let pIdsStr = promo.product_ids || [];
                if (typeof pIdsStr === 'string') pIdsStr = pIdsStr.split(',').map(s => s.trim());
                if (pId && pIdsStr.map(String).includes(pId)) return true;

                let vpIdsStr = promo.variant_parent_ids || [];
                if (typeof vpIdsStr === 'string') vpIdsStr = vpIdsStr.split(',').map(s => s.trim());
                else if (Array.isArray(vpIdsStr)) vpIdsStr = vpIdsStr.map(String);
                if (pId && vpIdsStr.includes(pId)) return true;

                let cIdsStr = promo.collection_ids || [];
                if (typeof cIdsStr === 'string') cIdsStr = cIdsStr.split(',').map(s => s.trim());
                if (pColls.length > 0 && cIdsStr.some(cid => pColls.map(String).includes(String(cid)))) return true;

                let vIdsStr = promo.variant_ids || [];
                if (typeof vIdsStr === 'string') vIdsStr = vIdsStr.split(',').map(s => s.trim());
                if (pVarIdsStr.length > 0 && vIdsStr.length > 0 && pVarIdsStr.some(vid => vIdsStr.map(String).includes(vid))) return true;

                return false;
            };

            let matchedPromos = [];
            let allPromos = [...(window.CANON_GLOBAL_DATA?.SHOPIFY_DATA?.bundles || []), ...(window.CANON_GLOBAL_DATA?.SHOPIFY_DATA?.promotions || [])];
            allPromos.forEach(p => {
                let handle = p.handle || '';
                if (handle === 'canon-store-exclusive' || handle.includes('weee') || handle.includes('tradein')) return;
                if (isMatch(p)) matchedPromos.push(p);
            });

            if (matchedPromos.length > 0) {
                let pCount = matchedPromos.length;
                let promoTitleText = lang === 'zh' ? `${pCount} 項優惠` : `${pCount} ${pCount > 1 ? 'promotions' : 'promotion'}`;

                promoHtml += `<div class="inline-checkout-section inline-promo-section" style="margin-bottom: 16px; border-bottom: 1px solid #f5f5f7; padding-bottom: 12px;">`;
                promoHtml += `<div class="inline-checkout-title" style="font-size: 14px; font-weight:600; color: #1d1d1f; margin-bottom: 8px; display: flex; align-items: center; gap: 6px;">
                    <i class="ph-fill ph-ticket" style="color: #e32400; font-size: 16px;"></i>
                    <span>${promoTitleText}</span>
                </div>`;
                promoHtml += `<div style="display: flex; flex-direction: column; gap: 4px;">`;
                matchedPromos.forEach((p, idx) => {
                    promoHtml += generatePromoCardHtml(p, idx, 'inline_compact');
                });
                promoHtml += `</div></div>`;
            }
        }

        let html = promoHtml + '<div class="inline-checkout-section"><div class="inline-checkout-title">' + (lang==='zh'?'選擇型號及數量':'Select Variants & Quantity') + '</div><div class="inline-variant-list">';
        
        if (variants.length === 0) {
             html += `<div style="padding:10px; color:#86868b; font-size:13px;">${lang==='zh'?'沒有相關庫存資料':'No inventory data available'}</div>`;
        }

        variants.forEach(v => {
            let onlyApplicableHtml = '';
            
            if (isFilterTarget) {
                const normVTitle = normalizeConsumable(v.title);
                if (searchType === 'printer' && rowData && rowData.inks) {
                    const isSupported = rowData.inks.some(ink => normVTitle.includes(normalizeConsumable(ink)));
                    if (!isSupported) return; 
                } else if (searchType === 'consumable' && allPrintersForThisSeries.length > 0) {
                    const supportedPrinters = allPrintersForThisSeries.filter(p => p.inks && p.inks.some(ink => normVTitle.includes(normalizeConsumable(ink))));
                    if (supportedPrinters.length > 0 && supportedPrinters.length < allPrintersForThisSeries.length) {
                        const modelList = supportedPrinters.map(p => p.m).join(', ');
                        onlyApplicableHtml = `<div style="color:#e32400; font-size:11px; font-weight:500; margin-top:2px;">${t.only_applicable_for}${modelList}</div>`;
                    }
                }
            }

            let pStr = formatMoney(v.price);
            let outOfStock = !v.available;
            let opacity = outOfStock ? '0.5' : '1';
            let preorderNoticeHtml = '';
            const po = (v && v.is_preorder === true) ? parsePreorderValue(v.preorder_lead_days, lang === 'zh') : null;
            if (po) {
                preorderNoticeHtml = `
                    <div class="v-preorder-notice" style="color: #CC0000; font-size: 11px; font-weight: 500; margin-top: 2px;">
                        ${po.text}
                    </div>
                `;
            }
            html += `
                <div class="inline-variant-item" style="opacity: ${opacity}; display: flex; align-items: center;">
                    ${v.image ? `<img src="${v.image}" style="width: 44px; height: 44px; object-fit: contain; margin-right: 12px; background: #f5f5f7; border-radius: 6px; flex-shrink: 0;">` : ''}
                    <div class="inline-variant-info">
                        <span class="inline-variant-name">${v.title}</span>
                        ${onlyApplicableHtml}
                        ${preorderNoticeHtml}
                        <span class="inline-variant-price">${outOfStock ? (lang==='zh'?'售罄':'Sold Out') : pStr}</span>
                    </div>
                    <div class="inline-qty-ctrl">
                        <button class="inline-qty-btn qty-minus" data-vid="${v.id}" data-price="${v.price}" ${outOfStock?'disabled':''}>-</button>
                        <input type="text" class="inline-qty-val" id="qty-${v.id}" value="0" disabled>
                        <button class="inline-qty-btn qty-plus" data-vid="${v.id}" data-price="${v.price}" ${outOfStock?'disabled':''}>+</button>
                    </div>
                </div>
            `;
        });
        html += '</div></div>';

        let stepIdx = 2;
        matchedBundles.forEach(bundle => {
            bundle.steps.forEach(step => {
                if (step.products && step.products.length > 0) {
                    html += `<div class="inline-checkout-section bundle-step-container" data-step="${step.step}" data-bundle-id="${bundle.id}"><div class="inline-checkout-title step-heading">${stepIdx}. ${step.title}</div><div class="inline-bundle-list addon-list" style="display:flex; flex-direction:column;">`;
                    
                    let rawStepType = (step.type || 'single_radio').toString().toLowerCase();
                    let bType = 'single_radio';
                    if (rawStepType.includes('free') || rawStepType.includes('gift')) bType = 'single_radio_freegift';
                    else if (rawStepType.includes('check') || rawStepType.includes('multi')) bType = 'multi_checkbox';
                    else if (rawStepType.includes('qty') || rawStepType.includes('quantity')) bType = 'multi_qty';

                    if (bType === 'single_radio' || bType === 'single_radio_freegift') {
                        html += `
                            <label class="inline-bundle-item addon-item none-option is-active">
                                <input type="radio" class="inline-bundle-input" name="bundle_${bundle.id}_${step.step}" value="" data-price="0" checked style="margin-right:10px;">
                                <span class="a-title" style="font-size:14px; font-weight:500;">${lang==='zh'?'不需要':'No, thanks'}</span>
                            </label>
                        `;
                    }

                    step.products.forEach(addon => {
                        addon.variants.forEach(v => {
                            if (v.available) {
                                let priceDisplay = `+ ${formatMoney(v.price)}`;
                                let dataPrice = v.price;
                                if (bType === 'single_radio_freegift') {
                                     priceDisplay = lang==='zh'? `免費 (原價 ${formatMoney(v.price)})` : `Free (Original ${formatMoney(v.price)})`;
                                     dataPrice = 0;
                                }
                                html += `
                                    <label class="inline-bundle-item addon-item">
                                        ${bType === 'single_radio' || bType === 'single_radio_freegift'
                                            ? `<input type="radio" name="bundle_${bundle.id}_${step.step}" value="${v.id}" data-price="${dataPrice}" class="inline-bundle-input" style="margin-right:10px;">` 
                                            : `<input type="checkbox" class="inline-bundle-input" value="${v.id}" data-price="${dataPrice}" style="margin-right:10px;">`
                                        }
                                        ${v.image ? `<img src="${v.image}" alt="">` : ''}
                                        <div style="flex-grow:1;">
                                            <div class="a-title" style="font-size:13px; font-weight:500;">${addon.title}${addon.variants.length > 1 && v.title !== 'Default Title' ? ' - '+v.title : ''}</div>
                                            <div class="a-price" style="font-size:13px; color:#555;">${priceDisplay}</div>
                                        </div>
                                    </label>
                                `;
                            }
                        });
                    });
                    html += '</div></div>';
                    stepIdx++;
                }
            });
        });

        html += `
            <div id="${containerId}-preorder-disclaimer-wrap" style="margin-top: 15px; display: none;"></div>
            <div class="inline-total-bar">
                <div style="display:flex; flex-direction:column;">
                    <span style="font-size:13px; color:#86868b;">${lang==='zh'?'總計:':'Total:'}</span>
                    <span class="inline-total-price" id="${containerId}-total">HK$0.00</span>
                </div>
                <button class="inline-checkout-btn" id="${containerId}-checkout-btn" disabled>${lang==='zh'?'確定及付款':'Checkout'}</button>
            </div>
        `;

        container.innerHTML = html;

        // ==========================================
        // Apply Advanced JSON Logic for Inline Checkout
        // ==========================================
        matchedBundles.forEach(bundle => {
            if (!bundle.advanced_json) return;
            let overrideData = null;
            try {
                if (typeof bundle.advanced_json === 'string') {
                    let cleanJson = bundle.advanced_json
                        .replace(/&quot;/g, '"')
                        .replace(/&amp;/g, '&')
                        .replace(/&lt;/g, '<')
                        .replace(/&gt;/g, '>')
                        .replace(/&#39;/g, "'")
                        .replace(/[\u201C\u201D]/g, '"')
                        .replace(/[\u2018\u2019]/g, "'")
                        .replace(/\r?\n|\r/g, ' ')
                        .replace(/,\s*([\}\]])/g, '$1');
                    overrideData = JSON.parse(cleanJson);
                    if (typeof overrideData === 'string') overrideData = JSON.parse(overrideData);
                } else {
                    overrideData = bundle.advanced_json;
                }
            } catch (e) {
                console.warn("Override JSON parse error (Inline Checkout):", e, bundle.advanced_json);
                return;
            }
            
            if (!overrideData || typeof overrideData !== 'object') return;
            
            let baseData = overrideData;
            if (overrideData[lang] && typeof overrideData[lang] === 'object' && !Array.isArray(overrideData[lang])) {
                baseData = overrideData[lang];
            }
            
            let bundlesData = baseData.bundles || baseData;
            if (bundlesData[lang] && typeof bundlesData[lang] === 'object' && !Array.isArray(bundlesData[lang])) {
                bundlesData = bundlesData[lang];
            }
            if (!bundlesData || typeof bundlesData !== 'object') return;

            container.querySelectorAll(`.bundle-step-container[data-bundle-id="${bundle.id}"]`).forEach(stepContainer => {
                const sIdx = stepContainer.getAttribute('data-step');
                let override = bundlesData[sIdx] || bundlesData[String(sIdx)];
                if (!override) return;

                if (override[lang] && typeof override[lang] === 'object' && !Array.isArray(override[lang])) {
                    override = Object.assign({}, override, override[lang]);
                }

                if (override.title !== undefined) {
                    const heading = stepContainer.querySelector('.step-heading');
                    if (heading) {
                        const match = heading.innerText.match(/^(\d+\.\s*)/);
                        heading.innerText = (match ? match[1] : '') + override.title;
                    }
                }
                if (override.hide_price_display === true) stepContainer.querySelectorAll('.a-price:not(.v-soldout)').forEach(el => el.style.display = 'none');
                if (override.display_price_override !== undefined) stepContainer.querySelectorAll('.addon-item:not(.none-option) .a-price:not(.v-soldout)').forEach(el => el.innerText = override.display_price_override);
                
                if (override.discount_type !== undefined) {
                    stepContainer.querySelectorAll('input[data-price]').forEach(el => {
                        if (el.value !== "") {
                            let originalPrice = el.getAttribute('data-original-price') || el.getAttribute('data-price') || 0;
                            el.setAttribute('data-original-price', originalPrice);
                            let newPrice = parseInt(originalPrice, 10);
                            if (override.discount_type === 'free') newPrice = 0;
                            else if (override.discount_type === 'fixed_amount') newPrice = Math.max(0, newPrice - (parseFloat(override.discount_value || 0) * 100));
                            else if (override.discount_type === 'percentage') newPrice = Math.max(0, newPrice * (1 - (parseFloat(override.discount_value || 0) / 100)));
                            el.setAttribute('data-price', Math.round(newPrice));
                        }
                    });
                } else if (override.calculation_price !== undefined) {
                    stepContainer.querySelectorAll('input[data-price]').forEach(el => {
                        if (el.value !== "") el.setAttribute('data-price', Math.round(parseFloat(override.calculation_price) * 100));
                    });
                }

                if (override.allow_none === false) {
                    const noneInput = stepContainer.querySelector('input[value=""]');
                    if (noneInput && noneInput.closest('.addon-item')) noneInput.closest('.addon-item').style.display = 'none';
                }
                if (override.none_label !== undefined) {
                    const noneInput = stepContainer.querySelector('input[value=""]');
                    if (noneInput && noneInput.closest('.addon-item').querySelector('.a-title')) noneInput.closest('.addon-item').querySelector('.a-title').innerText = override.none_label;
                }
                if (override.move_none_to_last === true) {
                    const noneInput = stepContainer.querySelector('input[value=""]');
                    if (noneInput && noneInput.closest('.addon-item')) noneInput.closest('.addon-item').style.order = "99";
                } else if (override.move_none_to_last === false) {
                    const noneInput = stepContainer.querySelector('input[value=""]');
                    if (noneInput && noneInput.closest('.addon-item')) {
                        noneInput.closest('.addon-item').style.order = "0";
                        if (noneInput.type === 'radio') {
                            noneInput.checked = true;
                        }
                    }
                }
                if (override.show_only_variants !== undefined && Array.isArray(override.show_only_variants)) {
                    const allowedIds = override.show_only_variants.map(String);
                    stepContainer.querySelectorAll('input, select').forEach(input => {
                        let val = input.value;
                        if (val !== "" && !allowedIds.includes(val) && input.closest('.addon-item')) {
                            input.closest('.addon-item').style.display = 'none';
                        }
                    });
                }
                if (override.hidden_variants !== undefined && Array.isArray(override.hidden_variants)) {
                    const hiddenIds = override.hidden_variants.map(String);
                    stepContainer.querySelectorAll('input, select').forEach(input => {
                        let val = input.value;
                        if (val !== "" && hiddenIds.includes(val) && input.closest('.addon-item')) {
                            input.closest('.addon-item').style.display = 'none';
                        }
                    });
                }
                if (override.default_variant !== undefined) {
                    const defaultId = String(override.default_variant);
                    stepContainer.querySelectorAll('input').forEach(input => {
                        let isMatch = input.value === defaultId;
                        if (isMatch) {
                            if ((input.type === 'radio' || input.type === 'checkbox') && !input.disabled) input.checked = true;
                            if (override.locked === true) {
                                input.disabled = true;
                                if (input.closest('.addon-item')) {
                                    input.closest('.addon-item').classList.add('locked-gift');
                                    input.closest('.addon-item').style.pointerEvents = 'none';
                                    input.closest('.addon-item').style.opacity = '0.7';
                                }
                            }
                        } else if (override.hide_others === true && input.value !== "") {
                            if (input.closest('.addon-item')) input.closest('.addon-item').style.display = 'none';
                        }
                    });
                }
            });
        });

        const calcTotal = () => {
            let totalCents = 0;
            let totalQty = 0;
            container.querySelectorAll('.inline-qty-val').forEach(inp => {
                let q = parseInt(inp.value, 10);
                if (q > 0) {
                    let btn = inp.nextElementSibling;
                    totalCents += q * parseInt(btn.getAttribute('data-price'), 10);
                    totalQty += q;
                }
            });

            container.querySelectorAll('.inline-bundle-input:checked').forEach(inp => {
                totalCents += parseInt(inp.getAttribute('data-price'), 10);
            });

            document.getElementById(`${containerId}-total`).innerText = formatMoney(totalCents);
            
            // Preorder logic inside inline checkout
            let activePreorders = [];
            container.querySelectorAll('.inline-qty-val').forEach(inp => {
                let q = parseInt(inp.value, 10);
                if (q > 0) {
                    let vid = parseInt(inp.nextElementSibling.getAttribute('data-vid'), 10);
                    let v = variants.find(variant => variant.id === vid);
                    if (v) {
                        const po = (v && v.is_preorder === true) ? parsePreorderValue(v.preorder_lead_days, lang === 'zh') : null;
                        if (po) activePreorders.push(po);
                    }
                }
            });

            // Sort by targetDate descending to find the furthest preorder
            activePreorders.sort((a, b) => b.targetDate - a.targetDate);
            const furthestPreorder = activePreorders[0];

            const disclaimerWrap = document.getElementById(`${containerId}-preorder-disclaimer-wrap`);
            const checkoutBtn = document.getElementById(`${containerId}-checkout-btn`);

            if (furthestPreorder) {
                if (checkoutBtn) {
                    checkoutBtn.innerText = lang==='zh' ? '預訂' : 'Pre-order';
                }
                if (disclaimerWrap) {
                    disclaimerWrap.style.display = 'block';
                    disclaimerWrap.innerHTML = `
                        <label style="cursor: pointer; display: flex; align-items: flex-start; gap: 6px; font-size: 11px; line-height: 1.4; color: #CC0000; text-align: left; margin-bottom: 12px; font-weight: normal;">
                            <input type="checkbox" id="${containerId}-preorder-agree" style="margin-top: 2px;">
                            <span>
                                ${furthestPreorder.consent}
                            </span>
                        </label>
                    `;
                    
                    const agreeCheck = document.getElementById(`${containerId}-preorder-agree`);
                    if (agreeCheck && checkoutBtn) {
                        checkoutBtn.disabled = totalQty === 0 || !agreeCheck.checked;
                        agreeCheck.addEventListener('change', () => {
                            checkoutBtn.disabled = totalQty === 0 || !agreeCheck.checked;
                        });
                    }
                }
            } else {
                if (checkoutBtn) {
                    checkoutBtn.innerText = lang==='zh' ? '確定及付款' : 'Checkout';
                    checkoutBtn.disabled = totalQty === 0;
                }
                if (disclaimerWrap) {
                    disclaimerWrap.style.display = 'none';
                    disclaimerWrap.innerHTML = '';
                }
            }

            container.querySelectorAll('.inline-bundle-item').forEach(lbl => {
                let input = lbl.querySelector('input');
                if (input && input.checked) lbl.classList.add('is-active');
                else lbl.classList.remove('is-active');
            });
        };

        container.querySelectorAll('.qty-minus').forEach(btn => {
            btn.addEventListener('click', (e) => {
                let inp = e.target.nextElementSibling;
                let val = parseInt(inp.value, 10);
                if (val > 0) inp.value = val - 1;
                calcTotal();
            });
        });

        container.querySelectorAll('.qty-plus').forEach(btn => {
            btn.addEventListener('click', (e) => {
                let inp = e.target.previousElementSibling;
                let val = parseInt(inp.value, 10);
                if (val < 99) inp.value = val + 1;
                calcTotal();
            });
        });

        container.querySelectorAll('.inline-bundle-input').forEach(inp => {
            inp.addEventListener('change', calcTotal);
        });

        document.getElementById(`${containerId}-checkout-btn`).addEventListener('click', (e) => {
            e.target.disabled = true;
            e.target.innerText = lang==='zh'?'處理中...':'Processing...';
            
            let items = [];
            container.querySelectorAll('.inline-qty-val').forEach(inp => {
                let q = parseInt(inp.value, 10);
                if (q > 0) {
                    let vid = parseInt(inp.nextElementSibling.getAttribute('data-vid'), 10);
                    items.push({ id: vid, quantity: q });
                }
            });

            container.querySelectorAll('.inline-bundle-input:checked').forEach(inp => {
                if (inp.value) {
                    items.push({ id: parseInt(inp.value, 10), quantity: 1 });
                }
            });

            if (typeof gtag === 'function') {
                gtag('event', 'va_direct_checkout', {
                    va_mode: finderState.mode,
                    items: items.map(item => ({ item_id: item.id, quantity: item.quantity }))
                });
            }

            let rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
            
            let itemsWithProperties = items.map(item => {
                let v = variants.find(variant => variant.id === item.id);
                const po = (v && v.is_preorder === true) ? parsePreorderValue(v.preorder_lead_days, lang === 'zh') : null;
                if (po) {
                    const propKey = lang === 'zh' ? "預訂貨品" : "Pre-order";
                    const propVal = po.propVal;
                    return {
                        ...item,
                        properties: { [propKey]: propVal }
                    };
                }
                return item;
            });

            fetch(rootUrl + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: itemsWithProperties })
            })
            .then(res => {
                if (!res.ok) throw new Error('Add to cart failed');
                window.location.href = rootUrl + 'checkout?utm_source=virtual-assistant&utm_medium=call';
            })
            .catch(err => {
                console.error(err);
                alert(lang==='zh'?'你所選的產品可能庫存不足，或者你的購物車中有產品已缺貨。你可嘗試減少所選產品之數量，及按網站右上角的購物袋符號、檢查你的購物車內的產品。':'The product you selected may have insufficient stock, or there are out‑of‑stock items in your shopping cart. You may try reducing the quantity of the selected product. Please click the shopping bag icon at the top right corner of the website to review the items in your cart.');
                e.target.disabled = false;
                e.target.innerText = lang==='zh'?'確定及付款':'Checkout';
            });
        });
        
        calcTotal(); // Trigger once to immediately reflect advanced json defaults
    }

    function renderConsumablesTags(mode) {
        const cId = mode === 'ink' ? 'ink-hot-tags' : 'toner-hot-tags';
        const inputId = mode === 'ink' ? 'canonInkInput' : 'canonTonerInput';
        const container = document.getElementById(cId);
        if (!container) return;
        const tags = mode === 'ink' ? ["PG-745", "PG-740", "GI-790", "GI-71"] : ["Cartridge 054", "Cartridge 337", "Cartridge 071"];
        
        container.innerHTML = tags.map(tag => `<span class="quick-tag-pill" onclick="window.canonTriggerSearch('${inputId}', '${tag}')">${tag}</span>`).join('');
    }

    function initProductPromotions() {
        const root = document.getElementById('canon-promo-bundle-root');
        const jsonEl = document.getElementById('canon-current-product-json');
        if (!root || !jsonEl) return;

        try {
            // Stop running until data is fetched
            if (!window.CANON_GLOBAL_DATA || !window.CANON_GLOBAL_DATA.PRODUCT_DB) return;

            const cp = JSON.parse(jsonEl.textContent);
            const shopData = window.CANON_GLOBAL_DATA?.SHOPIFY_DATA || window.CANON_GLOBAL_DATA || { bundles: [], promotions: [] };
            const now = Math.floor(Date.now() / 1000);
            const isZh = lang === 'zh';

            const isMatch = (promo) => {
                let sTime = promo.start_time || promo.start;
                let eTime = promo.end_time || promo.end;
                if (typeof sTime === 'string') sTime = Math.floor(new Date(sTime).getTime() / 1000);
                if (typeof eTime === 'string') eTime = Math.floor(new Date(eTime).getTime() / 1000) + 86399;
                
                if (sTime && sTime > now) return false;
                if (eTime && eTime < now) return false;

                if (promo.storewide === true || promo.storewide === 'true') return true;
                
                let pIds = promo.product_ids || promo.products || [];
                if (typeof pIds === 'string') pIds = pIds.split(',');
                
                let cIds = promo.collection_ids || promo.collections || [];
                if (typeof cIds === 'string') cIds = cIds.split(',');
                
                if (pIds.some(id => String(id) === String(cp.id))) return true;
                if (cp.collections && cIds.some(cid => cp.collections.some(ccid => String(ccid) === String(cid)))) return true;
                
                return false;
            };

            // Ignored in product pages if "Yes, banner only" is chosen
            const activeBundles = (shopData.bundles || []).filter(b => b.pinned !== 'Yes, banner only' && isMatch(b));
            const activePromos = (shopData.promotions || []).filter(p => p.handle !== 'canon-store-exclusive' && p.pinned !== 'Yes, banner only' && isMatch(p));
            const exclusivePromo = (shopData.promotions || []).find(p => p.handle === 'canon-store-exclusive');

            let cardsHtml = '';

            if (exclusivePromo) {
                let excVariants = [];
                
                let pIdsStr = exclusivePromo.product_ids || [];
                if (typeof pIdsStr === 'string') pIdsStr = pIdsStr.split(',').map(s => s.trim());
                else if (Array.isArray(pIdsStr)) pIdsStr = pIdsStr.map(String);

                let vIdsStr = exclusivePromo.variant_ids || [];
                if (typeof vIdsStr === 'string') vIdsStr = vIdsStr.split(',').map(s => s.trim());
                else if (Array.isArray(vIdsStr)) vIdsStr = vIdsStr.map(String);

                let cIdsStr = exclusivePromo.collection_ids || [];
                if (typeof cIdsStr === 'string') cIdsStr = cIdsStr.split(',').map(s => s.trim());
                else if (Array.isArray(cIdsStr)) cIdsStr = cIdsStr.map(String);

                let isWholeProduct = false;
                
                if (exclusivePromo.storewide === true || exclusivePromo.storewide === 'true') {
                    isWholeProduct = true;
                } else if (pIdsStr.includes(String(cp.id))) {
                    isWholeProduct = true;
                } else if (cp.collections && cIdsStr.length > 0) {
                    if (cIdsStr.some(cid => cp.collections.some(ccid => String(ccid) === String(cid)))) {
                         isWholeProduct = true;
                    }
                }

                if (cp.variants) {
                    if (isWholeProduct) {
                        excVariants = [...cp.variants];
                    } else if (vIdsStr.length > 0) {
                        excVariants = cp.variants.filter(v => vIdsStr.includes(String(v.id)));
                    }
                }

                if (excVariants.length > 0) {
                    let vTitlesStr = '';
                    if (isWholeProduct && (excVariants.length <= 1 || excVariants[0].title === 'Default Title')) {
                        vTitlesStr = cp.title;
                    } else {
                        vTitlesStr = excVariants.map(v => v.title === 'Default Title' ? cp.title : v.title).join(isZh ? '、' : ', ');
                    }

                    cardsHtml += `
                        <div class="perk-card exclusive-glass-card">
                          <div class="perk-top-row">
                            <div class="perk-visual is-svg">
                              <svg viewBox="0 0 24 24" width="32" height="32" stroke="url(#exclusive-gradient)" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                <defs><linearGradient id="exclusive-gradient" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#8a3ff3"/><stop offset="50%" stop-color="#fe7cc5"/><stop offset="100%" stop-color="#ffb8e0"/></linearGradient></defs>
                                <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path>
                              </svg>
                            </div>
                            <div class="perk-details">
                              <div class="perk-title exclusive-animated-text" style="font-size: 14px; margin-bottom: 2px;">${isZh ? '【Canon 商店限定】' : '【Canon Store Exclusive】'}</div>
                              <div class="perk-desc">${isZh ? `${vTitlesStr}：於 Canon 網上商店及佳能數碼影像坊獨家發售。` : `${vTitlesStr}: exclusively available at Canon Online Store and Canon Image Square.`}</div>
                            </div>
                          </div>
                        </div>`;
                }
            }

            const renderCard = (p) => {
                let hasModal = p.detail || p.tnc || p.detail_image;
                let onlyImage = p.image && !p.icon && !p.promo_title && !p.promo_desc;
                let html = '';
                
                if (onlyImage) {
                    if (hasModal) html += `<div class="perk-card dynamic-card open-tnc-btn-bundle-${p.id}" style="cursor: pointer;">`;
                    else if (p.link_url) html += `<a href="${p.link_url}" target="_blank" class="perk-card dynamic-card">`;
                    else html += `<div class="perk-card dynamic-card">`;
                    html += `<div class="perk-image-only"><img src="${p.image}" alt="Promotion"></div>`;
                    html += hasModal || !p.link_url ? `</div>` : `</a>`;
                } else {
                    html += `<div class="perk-card dynamic-card"><div class="perk-top-row"><div class="perk-visual">`;
                    if (p.icon) html += `<img src="${p.icon}" alt="Icon" style="width: 32px; height: 32px; object-fit: contain;">`;
                    else html += `<svg viewBox="0 0 24 24" width="32" height="32" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" style="color:#555;"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>`;
                    html += `</div><div class="perk-details">`;
                    
                    if (p.promo_title) html += `<div class="perk-title">${p.promo_title}</div>`;
                    if (p.promo_desc) html += `<div class="perk-desc">${p.promo_desc}</div>`;
                    
                    if (p.link_url || hasModal) {
                        html += `<div class="promo-links">`;
                        if (p.link_url) html += `<a href="${p.link_url}" target="_blank" class="promo-hyperlink">${p.link_text || (isZh ? '詳情' : 'Details')}</a>`;
                        if (hasModal) {
                            let btnText = isZh ? '條款及細則' : 'Terms & Conditions';
                            if (p.detail || p.detail_image) btnText = (p.tnc && isZh) ? '詳情及條款' : (p.tnc ? 'Details & Terms' : (isZh ? '詳情' : 'Details'));
                            html += `<button class="promo-tnc-btn open-tnc-btn-bundle-${p.id}">${btnText}</button>`;
                        }
                        html += `</div>`;
                    }
                    html += `</div></div>`;
                    if (p.image) html += `<div class="perk-bottom-image"><img src="${p.image}" alt="Promotion"></div>`;
                    html += `</div>`;
                }
                return html;
            };

            activeBundles.forEach(b => cardsHtml += renderCard(b));
            activePromos.forEach(p => cardsHtml += renderCard(p));
            document.getElementById('canon-dynamic-promo-container').innerHTML = cardsHtml;

            document.querySelectorAll('.canon-tnc-wrapper-cls').forEach(el => el.remove());

            let modalsHtml = '';
            [...activeBundles, ...activePromos].forEach(p => {
                if (!(p.detail || p.tnc || p.detail_image)) return;
                modalsHtml += `<div id="tnc-modal-overlay-bundle-${p.id}" class="modal-overlay tnc-overlay" style="display: none;"><div class="modal-container tnc-container"><div class="modal-header"><h2 class="modal-title">${isZh ? '優惠詳情及條款' : 'Details & Terms'}</h2><button class="modal-close-btn">&times;</button></div><div class="modal-content-scroll tnc-content">${p.detail_image ? `<div class="promo-detail-images" style="margin-bottom: 20px;"><img src="${p.detail_image}" style="width: 100%; border-radius: 8px; display: block; margin-bottom: 10px;"></div>` : ''}${p.detail ? `<div class="promo-detail-section">${p.detail}</div>` : ''}${p.tnc ? `<div class="promo-tnc-section" ${p.detail||p.detail_image ? 'style="margin-top: 30px; padding-top: 20px; border-top: 1px dashed #d2d2d7;"' : ''}><h4 style="font-size:14px; margin-bottom:10px; color:#888;">${isZh ? '條款及細則:' : 'Terms & Conditions:'}</h4>${p.tnc}</div>` : ''}</div></div></div>`;
            });
            let modalWrapper = document.createElement('div');
            modalWrapper.className = 'canon-tnc-wrapper-cls';
            modalWrapper.innerHTML = modalsHtml;
            document.body.appendChild(modalWrapper);

            document.querySelectorAll('.promo-tnc-btn, [class*="open-tnc-btn-bundle-"]').forEach(btn => {
                btn.addEventListener('click', (e) => { e.preventDefault(); const targetClass = Array.from(btn.classList).find(c => c.startsWith('open-tnc-btn-bundle-')); if(targetClass) { const modal = document.getElementById(`tnc-modal-overlay-bundle-${targetClass.replace('open-tnc-btn-bundle-', '')}`); if(modal) { modal.style.display = 'flex'; document.body.classList.add('modal-open'); } } });
            });
            document.querySelectorAll('.tnc-overlay').forEach(modal => {
                const closeBtn = modal.querySelector('.modal-close-btn');
                if (closeBtn) closeBtn.addEventListener('click', () => { modal.style.display = 'none'; document.body.classList.remove('modal-open'); });
                modal.addEventListener('click', e => { if (e.target === modal) { modal.style.display = 'none'; document.body.classList.remove('modal-open'); } });
            });

            window.CANON_ACTIVE_BUNDLES = activeBundles;
            window.CANON_CURRENT_PRODUCT = cp;

            initPurchaseModal(cp, activeBundles, isZh);

        } catch (error) {
            console.error("Bundle Render Error", error);
            const loadingBtn = document.getElementById('fallback-loading-btn');
            const nativeForm = document.getElementById('native-add-to-cart-form');
            if (loadingBtn) loadingBtn.style.display = 'none';
            if (nativeForm) nativeForm.style.display = 'block';
        }
    }

    function initPurchaseModal(cp, activeBundles, isZh) {
        const btnContainer = document.getElementById('canon-purchase-btn-container');
        const modalContainer = document.getElementById('canon-purchase-modal-container');
        if (!btnContainer || !modalContainer) return;

        try { 
        
        const isInk = (cp.tags || []).some(t => t === '墨水' || t === '碳粉');
        const hasBundle = activeBundles.some(b => b.steps && b.steps.length > 0);
        const hasVariants = cp.variants && cp.variants.length > 1;
        const isAvailable = cp.available;

        let totalVariantsCount = 0;
        let preorderVariants = [];
        let hasPreorder = false;
        let allPreorder = false;

        if (cp.variants) {
            totalVariantsCount = cp.variants.length;
            preorderVariants = cp.variants.filter(v => v.is_preorder === true && parsePreorderValue(v.preorder_lead_days, isZh) !== null);
            hasPreorder = preorderVariants.length > 0;
            allPreorder = hasPreorder && (preorderVariants.length === totalVariantsCount);
        }

        let firstAvail = (cp.variants && cp.variants.length > 0) ? (cp.variants.find(v => v.available) || cp.variants[0]) : null;

        let showModal = false;
        let triggerText = isZh ? '加入購物車' : 'Add to Cart';

        if (!isAvailable) {
            triggerText = isZh ? '售罄' : 'Sold Out';
        } else if (isInk) {
            showModal = true;
            if (hasPreorder) {
                triggerText = isZh ? '選擇預訂型號、數量及預訂' : 'Select Pre-order Model, Qty & Pre-order';
            } else {
                triggerText = isZh ? '選擇型號、數量及購買' : 'Select Model, Qty & Buy';
            }
        } else if (hasBundle || hasVariants) {
            showModal = true;
            if (allPreorder) {
                triggerText = isZh ? '立即預訂' : 'Pre-order Now';
            } else {
                triggerText = isZh ? '立即購買' : 'Buy Now';
            }
        }

        // Render Primary Button
        if (!isAvailable) {
            btnContainer.innerHTML = `<button class="primary-purchase-btn" disabled>${triggerText}</button>`;
        } else if (showModal) {
            let allSameLeadDay = false;
            if (hasPreorder) {
                const uniqueLeadDays = new Set(preorderVariants.map(v => String(v.preorder_lead_days).trim()));
                allSameLeadDay = uniqueLeadDays.size === 1;
            }

            if (allPreorder && allSameLeadDay && firstAvail) {
                const po = (firstAvail && firstAvail.is_preorder === true) ? parsePreorderValue(firstAvail.preorder_lead_days, isZh) : null;
                btnContainer.innerHTML = `
                    <div class="preorder-notice-box" style="margin-bottom: 12px; text-align: left; padding: 12px; border: 1px solid #CC0000; border-radius: 0px; background-color: #FFF5F5;">
                        <span style="color:#CC0000; font-size:14px; font-weight:700; display:block; margin:0;">
                            ${po ? po.text : ''}
                        </span>
                    </div>
                    <button id="open-purchase-modal" class="primary-purchase-btn">${triggerText}</button>
                `;
            } else if (hasPreorder) {
                let preorderNames = preorderVariants
                    .map(v => {
                        let vTitle = v.title === 'Default Title' ? cp.title : v.title;
                        const po = (v && v.is_preorder === true) ? parsePreorderValue(v.preorder_lead_days, isZh, vTitle) : null;
                        return po ? `• ${po.text}` : '';
                    })
                    .filter(Boolean)
                    .join('<br>');
                
                let introText = '';
                if (allPreorder && !allSameLeadDay) {
                    introText = '';
                } else {
                    introText = (isZh ? '部分型號為預訂貨品：' : 'Some models are pre-order items:') + '<br>';
                }

                btnContainer.innerHTML = `
                    <div class="preorder-notice-box" style="margin-bottom: 12px; text-align: left; padding: 12px; border: 1px solid #CC0000; border-radius: 0px; background-color: #FFF5F5;">
                        <span style="color:#CC0000; font-size:13px; font-weight:500; display:block; line-height: 1.4; margin:0;">
                            ${introText}${preorderNames}
                        </span>
                    </div>
                    <button id="open-purchase-modal" class="primary-purchase-btn">${triggerText}</button>
                `;
            } else {
                btnContainer.innerHTML = `<button id="open-purchase-modal" class="primary-purchase-btn">${triggerText}</button>`;
            }
        } else {
            const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
            let firstAvail = (cp.variants && cp.variants.length > 0) ? (cp.variants.find(v => v.available) || cp.variants[0]) : null;
            const po = (firstAvail && firstAvail.is_preorder === true) ? parsePreorderValue(firstAvail.preorder_lead_days, isZh) : null;
            if (po) {
                const propKey = isZh ? '預訂貨品' : 'Pre-order';
                const propVal = po.propVal;
                
                btnContainer.innerHTML = `
                    <div class="preorder-notice-box" style="margin-bottom: 12px; text-align: left; padding: 12px; border: 1px solid #CC0000; border-radius: 0px; background-color: #FFF5F5;">
                        <span style="color:#CC0000; font-size:14px; font-weight:700; display:block; margin-bottom:4px;">
                            ${po.text}
                        </span>
                        <label style="cursor: pointer; display: flex; align-items: flex-start; gap: 6px; font-size: 11px; line-height: 1.4; color: #CC0000; margin: 0;">
                            <input type="checkbox" id="direct-preorder-agree" style="margin-top: 2px;">
                            <span>
                                ${po.consent}
                            </span>
                        </label>
                    </div>
                    <form method="post" action="${rootUrl}cart/add" id="fallback-atc-form">
                      <input type="hidden" name="id" value="${firstAvail.id}">
                      <input type="hidden" name="return_to" value="${rootUrl}cart">
                      <input type="hidden" name="properties[${propKey}]" value="${propVal}">
                      <button type="submit" id="direct-preorder-submit" class="primary-purchase-btn" disabled>${isZh ? '預訂' : 'Pre-order'}</button>
                    </form>
                `;
                setTimeout(() => {
                    const agreeCheck = document.getElementById('direct-preorder-agree');
                    const submitBtn = document.getElementById('direct-preorder-submit');
                    if (agreeCheck && submitBtn) {
                        agreeCheck.addEventListener('change', () => {
                            submitBtn.disabled = !agreeCheck.checked;
                        });
                    }
                }, 100);
            } else {
                btnContainer.innerHTML = `
                    <form method="post" action="${rootUrl}cart/add" id="fallback-atc-form">
                      <input type="hidden" name="id" value="${firstAvail.id}">
                      <input type="hidden" name="return_to" value="${rootUrl}cart">
                      <button type="submit" class="primary-purchase-btn">${triggerText}</button>
                    </form>
                `;
            }
        }

        if (!showModal) return;

        const oldPurchaseOverlay = document.getElementById('purchase-modal-overlay');
        if (oldPurchaseOverlay) {
            oldPurchaseOverlay.remove();
            document.body.classList.remove('modal-open');
        }

        const formatMoney = (cents) => 'HK$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        // Start Modal HTML
        let modalHtml = `
            <div id="purchase-modal-overlay" class="modal-overlay" style="display: none;">
              <div class="modal-container bundle-modal-specific">
                <div class="modal-header">
                  <h2 class="modal-title">${isZh ? '選擇最適合你的組合' : 'Customize Your Package'}</h2>
                  <button id="close-purchase-modal" class="modal-close-btn">&times;</button>
                </div>
                <div class="modal-content-scroll">
        `;

        let stepIdx = 1;

        // Step 1: Variants or Ink Quantities
        modalHtml += `<div class="modal-step"><h3 class="step-heading">${hasBundle ? stepIdx + '. ' : ''}${isZh ? '選擇型號' : 'Select Model'}</h3>`;
        
        if (isInk) {
            modalHtml += `<div class="addon-list grid-layout">`;
            cp.variants.forEach(v => {
                let vImg = v.image || cp.featured_image;
                let vTitle = v.title === 'Default Title' ? cp.title : v.title;
                let preorderNoticeHtml = '';
                const po = (v && v.is_preorder === true) ? parsePreorderValue(v.preorder_lead_days, isZh) : null;
                if (po) {
                    preorderNoticeHtml = `
                        <span class="v-preorder-notice" style="color: #CC0000; font-size: 11px; font-weight: 500; display: block; margin-top: 4px;">
                            ${po.text}
                        </span>
                    `;
                }
                modalHtml += `
                    <label class="addon-item is-qty-mode ${!v.available ? 'out-of-stock' : ''}">
                        <input type="hidden" class="main-input-qty-val" value="${v.id}" data-price="${v.price}">
                        ${vImg ? `<div class="addon-img-wrap"><img src="${vImg}" alt=""></div>` : ''}
                        <div class="addon-info">
                            <span class="a-title">${vTitle}</span>
                            <span class="a-price ${!v.available ? 'v-soldout' : ''}">${v.available ? formatMoney(v.price) : (isZh ? '售罄' : 'Sold Out')}</span>
                            ${preorderNoticeHtml}
                        </div>
                        <div class="qty-selector-wrap" onclick="event.preventDefault();">
                            <select class="main-qty-select" ${!v.available ? 'disabled' : `data-price="${v.price}"`}>
                                ${Array.from({length: 11}, (_, i) => `<option value="${i}">${i}</option>`).join('')}
                            </select>
                        </div>
                    </label>
                `;
            });
            modalHtml += `</div>`;
        } else {
            modalHtml += `<div class="variant-grid">`;
            let firstAvailableFound = false;
            cp.variants.forEach(v => {
                let checked = '';
                if (v.available && !firstAvailableFound) { checked = 'checked'; firstAvailableFound = true; }
                let vTitle = v.title === 'Default Title' ? cp.title : v.title;
                let preorderNoticeHtml = '';
                const po = (v && v.is_preorder === true) ? parsePreorderValue(v.preorder_lead_days, isZh) : null;
                if (po) {
                    preorderNoticeHtml = `
                        <span class="v-preorder-notice" style="color: #CC0000; font-size: 11px; font-weight: 500; display: block; margin-top: 4px;">
                            ${po.text}
                        </span>
                    `;
                }
                modalHtml += `
                    <label class="variant-card ${!v.available ? 'out-of-stock' : ''}">
                        <input type="radio" name="modal_variant" value="${v.id}" data-price="${v.price}" class="variant-radio" ${checked} ${!v.available ? 'disabled' : ''}>
                        <div class="card-box">
                            ${v.image ? `<div class="variant-img-wrap" style="width: 100%; height: 60px; margin-bottom: 8px; display: flex; align-items: center; justify-content: center;"><img src="${v.image}" style="max-width: 100%; max-height: 100%; object-fit: contain;"></div>` : ''}
                            <span class="v-title">${vTitle}</span>
                            <span class="v-price ${!v.available ? 'v-soldout' : ''}">${v.available ? formatMoney(v.price) : (isZh ? '售罄' : 'Sold Out')}</span>
                            ${preorderNoticeHtml}
                        </div>
                    </label>
                `;
            });
            modalHtml += `</div>`;
        }
        modalHtml += `</div>`;
        stepIdx++;

        // Step 2+: Bundle Options
        if (hasBundle) {
            activeBundles.forEach(bundle => {
                (bundle.steps || []).forEach(step => {
                    if (step.products && step.products.length > 0) {
                        modalHtml += `
                            <div class="modal-step bundle-step-container" data-step="${step.step}" data-bundle-id="${bundle.id}">
                                <h3 class="step-heading">${stepIdx}. ${step.title}</h3>
                                <div class="addon-list grid-layout">
                        `;
                        let rawStepType = (step.type || 'single_radio').toString().toLowerCase();
                        let bType = 'single_radio';
                        if (rawStepType.includes('free') || rawStepType.includes('gift')) bType = 'single_radio_freegift';
                        else if (rawStepType.includes('qty') || rawStepType.includes('quantity')) bType = 'multi_qty';
                        else if (rawStepType.includes('check') || rawStepType.includes('multi')) bType = 'multi_checkbox';
                        
                        let anyGiftAvailable = (step.products || []).some(addon => (addon.variants || []).some(v => v.available));

                        if (bType === 'single_radio' || bType === 'single_radio_freegift') {
                            let noneChecked = (bType === 'single_radio') || (bType === 'single_radio_freegift' && !anyGiftAvailable);

                            modalHtml += `
                                <label class="addon-item none-option" ${bType === 'single_radio_freegift' ? 'style="order: 99;"' : ''}>
                                    <input type="radio" name="bundle_step_${bundle.id}_${step.step}" class="addon-input-radio" value="" data-price="0" ${noneChecked ? 'checked' : ''}>
                                    <div class="addon-info"><span class="a-title">${isZh ? '不需要' : 'No, thanks'}</span></div>
                                    <div class="check-indicator"></div>
                                </label>
                            `;
                        }

                        let firstGiftFound = false;
                        step.products.forEach(addon => {
                            addon.variants.forEach(v => {
                                let isChecked = false;
                                let giftLabelAttr = '';
                                let displayStyle = '';
                                
                                if (bType === 'single_radio_freegift') {
                                    giftLabelAttr = `data-gift-label="${isZh ? '🎁 限時優惠' : 'Limited-Time Offer'}"`;
                                    
                                    if (v.available) {
                                        if (!firstGiftFound) {
                                            isChecked = true; 
                                            firstGiftFound = true; 
                                        } else {
                                            displayStyle = 'display:none;'; 
                                        }
                                    }
                                    
                                }

                                modalHtml += `<label class="addon-item ${bType === 'multi_qty' ? 'is-qty-mode' : ''} ${!v.available ? 'out-of-stock' : ''} ${bType === 'single_radio_freegift' ? 'has-gift-label' : ''}" ${giftLabelAttr} style="${displayStyle}">`;

                                let dataPrice = bType === 'single_radio_freegift' ? 0 : v.price;

                                if (bType === 'single_radio' || bType === 'single_radio_freegift') {
                                    modalHtml += `<input type="radio" name="bundle_step_${bundle.id}_${step.step}" class="addon-input-radio" value="${v.id}" data-price="${dataPrice}" ${!v.available ? 'disabled' : ''} ${isChecked ? 'checked' : ''}>`;
                                } else if (bType === 'multi_checkbox') {
                                    modalHtml += `<input type="checkbox" class="addon-input-checkbox" value="${v.id}" data-price="${dataPrice}" ${!v.available ? 'disabled' : ''}>`;
                                } else if (bType === 'multi_qty') {
                                    modalHtml += `<input type="hidden" class="addon-input-qty-val" value="${v.id}" data-price="${dataPrice}">`;
                                }

                                let vImg = v.image || addon.image;
                                if (vImg) modalHtml += `<div class="addon-img-wrap"><img src="${vImg}" alt=""></div>`;

                                let addonTitle = addon.title + (addon.variants.length > 1 && v.title !== 'Default Title' ? ' - ' + v.title : '');
                                let priceText = !v.available ? `<span class="a-price v-soldout">${isZh ? '售罄' : 'Sold Out'}</span>` : 
                                                (bType === 'single_radio_freegift' ? `<span class="a-price">${isZh ? `免費 (原價 ${formatMoney(v.price)})` : `Free (Original ${formatMoney(v.price)})`}</span>` : `<span class="a-price">+ ${formatMoney(v.price)}</span>`);

                                let preorderNoticeHtml = '';
                                const po = (v && v.is_preorder === true) ? parsePreorderValue(v.preorder_lead_days, isZh) : null;
                                if (po) {
                                    preorderNoticeHtml = `<span class="v-preorder-notice" style="color: #CC0000; font-size: 11px; font-weight: 500; display: block; margin-top: 4px;">${po.text}</span>`;
                                }

                                modalHtml += `<div class="addon-info"><span class="a-title">${addonTitle}</span>${priceText}${preorderNoticeHtml}</div>`;

                                if (bType === 'single_radio' || bType === 'single_radio_freegift' || bType === 'multi_checkbox') {
                                    modalHtml += `<div class="check-indicator"></div>`;
                                } else if (bType === 'multi_qty') {
                                    modalHtml += `<div class="qty-selector-wrap" onclick="event.preventDefault();"><select class="addon-qty-select" ${!v.available ? 'disabled' : `data-price="${v.price}"`}>${Array.from({length: 11}, (_, i) => `<option value="${i}">${i}</option>`).join('')}</select></div>`;
                                }
                                modalHtml += `</label>`;
                            });
                        });
                        modalHtml += `</div></div>`;
                        stepIdx++;
                    }
                });
            });
        }

        let initTotal = isInk ? 'HK$0.00' : formatMoney((cp.variants.find(v=>v.available)||cp.variants[0]).price);
        modalHtml += `
                </div>
                <div class="modal-footer">
                  <div id="modal-preorder-disclaimer-wrap" style="margin-bottom: 12px; display: none;"></div>
                  <div class="price-summary">
                    <span class="summary-label">${isZh ? '總計:' : 'Total:'}</span>
                    <span id="modal-total-price" class="summary-value">${initTotal}</span>
                  </div>
                  <button id="modal-add-btn" class="checkout-btn" data-text-normal="${isZh ? '加入購物車' : 'Add to Cart'}" data-text-processing="${isZh ? '處理中...' : 'Processing...'}" data-text-error="${isZh ? '發生錯誤' : 'Error'}">
                    ${isZh ? '加入購物車' : 'Add to Cart'}
                  </button>
                </div>
              </div>
            </div>
        `;
        modalContainer.innerHTML = modalHtml;
        document.body.appendChild(document.getElementById('purchase-modal-overlay'));

        // ==========================================
        // Apply Advanced JSON Logic
        // ==========================================
        activeBundles.forEach(bundle => {
            if (!bundle.advanced_json) return;
            let overrideData = null;
            try {
                if (typeof bundle.advanced_json === 'string') {
                    let cleanJson = bundle.advanced_json
                        .replace(/&quot;/g, '"')
                        .replace(/&amp;/g, '&')
                        .replace(/&lt;/g, '<')
                        .replace(/&gt;/g, '>')
                        .replace(/&#39;/g, "'")
                        .replace(/[\u201C\u201D]/g, '"')
                        .replace(/[\u2018\u2019]/g, "'")
                        .replace(/\r?\n|\r/g, ' ')
                        .replace(/,\s*([\}\]])/g, '$1');
                    overrideData = JSON.parse(cleanJson);
                    if (typeof overrideData === 'string') overrideData = JSON.parse(overrideData);
                } else {
                    overrideData = bundle.advanced_json;
                }
            } catch (e) {
                console.warn("Override JSON parse error (Purchase Modal):", e, bundle.advanced_json);
                return;
            }
            
            if (!overrideData || typeof overrideData !== 'object') return;
            
            let baseData = overrideData;
            if (overrideData[lang] && typeof overrideData[lang] === 'object' && !Array.isArray(overrideData[lang])) {
                baseData = overrideData[lang];
            }
            
            let bundlesData = baseData.bundles || baseData;
            if (bundlesData[lang] && typeof bundlesData[lang] === 'object' && !Array.isArray(bundlesData[lang])) {
                bundlesData = bundlesData[lang];
            }
            if (!bundlesData || typeof bundlesData !== 'object') return;

            document.querySelectorAll(`.bundle-step-container[data-bundle-id="${bundle.id}"]`).forEach(stepContainer => {
                const sIdx = stepContainer.getAttribute('data-step');
                let override = bundlesData[sIdx] || bundlesData[String(sIdx)];
                if (!override) return;
                
                if (override[lang] && typeof override[lang] === 'object' && !Array.isArray(override[lang])) {
                    override = Object.assign({}, override, override[lang]);
                }

                if (override.title !== undefined) {
                    const heading = stepContainer.querySelector('.step-heading');
                    if (heading) {
                        const match = heading.innerText.match(/^(\d+\.\s*)/);
                        heading.innerText = (match ? match[1] : '') + override.title;
                    }
                }
                if (override.hide_price_display === true) stepContainer.querySelectorAll('.a-price:not(.v-soldout)').forEach(el => el.style.display = 'none');
                if (override.display_price_override !== undefined) stepContainer.querySelectorAll('.addon-item:not(.none-option) .a-price:not(.v-soldout)').forEach(el => el.innerText = override.display_price_override);
                
                if (override.discount_type !== undefined) {
                    stepContainer.querySelectorAll('input[data-price], select[data-price]').forEach(el => {
                        if (el.value !== "") {
                            let originalPrice = el.getAttribute('data-original-price') || el.getAttribute('data-price') || 0;
                            el.setAttribute('data-original-price', originalPrice);
                            let newPrice = parseInt(originalPrice, 10);
                            if (override.discount_type === 'free') newPrice = 0;
                            else if (override.discount_type === 'fixed_amount') newPrice = Math.max(0, newPrice - (parseFloat(override.discount_value || 0) * 100));
                            else if (override.discount_type === 'percentage') newPrice = Math.max(0, newPrice * (1 - (parseFloat(override.discount_value || 0) / 100)));
                            el.setAttribute('data-price', Math.round(newPrice));
                        }
                    });
                } else if (override.calculation_price !== undefined) {
                    stepContainer.querySelectorAll('input[data-price], select[data-price]').forEach(el => {
                        if (el.value !== "") el.setAttribute('data-price', Math.round(parseFloat(override.calculation_price) * 100));
                    });
                }

                if (override.allow_none === false) {
                    const noneInput = stepContainer.querySelector('input[value=""]');
                    if (noneInput && noneInput.closest('.addon-item')) noneInput.closest('.addon-item').style.display = 'none';
                }
                if (override.none_label !== undefined) {
                    const noneInput = stepContainer.querySelector('input[value=""]');
                    if (noneInput && noneInput.closest('.addon-item').querySelector('.a-title')) noneInput.closest('.addon-item').querySelector('.a-title').innerText = override.none_label;
                }
                if (override.move_none_to_last === true) {
                    const noneInput = stepContainer.querySelector('input[value=""]');
                    if (noneInput && noneInput.closest('.addon-item')) noneInput.closest('.addon-item').style.order = "99";
                } else if (override.move_none_to_last === false) {
                    const noneInput = stepContainer.querySelector('input[value=""]');
                    if (noneInput && noneInput.closest('.addon-item')) {
                        noneInput.closest('.addon-item').style.order = "0";
                        if (noneInput.type === 'radio') {
                            noneInput.checked = true;
                        }
                    }
                }
                if (override.max_qty !== undefined) {
                    stepContainer.querySelectorAll('.addon-qty-select').forEach(sel => {
                        Array.from(sel.options).forEach(opt => { if (parseInt(opt.value, 10) > override.max_qty) opt.remove(); });
                    });
                }
                if (override.show_only_variants !== undefined && Array.isArray(override.show_only_variants)) {
                    const allowedIds = override.show_only_variants.map(String);
                    stepContainer.querySelectorAll('input, select').forEach(input => {
                        let val = input.value;
                        if (input.classList.contains('addon-qty-select')) {
                            const hiddenInput = input.closest('.addon-item').querySelector('.addon-input-qty-val');
                            if (hiddenInput) val = hiddenInput.value;
                        }
                        if (val !== "" && !allowedIds.includes(val) && input.closest('.addon-item')) {
                            input.closest('.addon-item').style.display = 'none';
                        }
                    });
                }
                if (override.hidden_variants !== undefined && Array.isArray(override.hidden_variants)) {
                    const hiddenIds = override.hidden_variants.map(String);
                    stepContainer.querySelectorAll('input, select').forEach(input => {
                        let val = input.value;
                        if (input.classList.contains('addon-qty-select')) {
                            const hiddenInput = input.closest('.addon-item').querySelector('.addon-input-qty-val');
                            if (hiddenInput) val = hiddenInput.value;
                        }
                        if (val !== "" && hiddenIds.includes(val) && input.closest('.addon-item')) {
                            input.closest('.addon-item').style.display = 'none';
                        }
                    });
                }
                if (override.default_variant !== undefined) {
                    const defaultId = String(override.default_variant);
                    stepContainer.querySelectorAll('input, select').forEach(input => {
                        let isMatch = input.value === defaultId;
                        if (input.classList.contains('addon-qty-select')) {
                            const hiddenInput = input.closest('.addon-item').querySelector('.addon-input-qty-val');
                            if (hiddenInput && hiddenInput.value === defaultId) isMatch = true;
                        }
                        if (isMatch) {
                            if ((input.type === 'radio' || input.type === 'checkbox') && !input.disabled) input.checked = true;
                            else if (input.tagName === 'SELECT' && !input.disabled) input.value = override.default_qty !== undefined ? String(override.default_qty) : "1";
                            if (override.locked === true) {
                                input.disabled = true;
                                if (input.closest('.addon-item')) {
                                    input.closest('.addon-item').classList.add('locked-gift');
                                    input.closest('.addon-item').style.pointerEvents = 'none';
                                }
                            }
                        } else if (override.hide_others === true && input.value !== "") {
                            if (input.closest('.addon-item')) input.closest('.addon-item').style.display = 'none';
                        }
                    });
                }
                if (override.variant_labels !== undefined) {
                    Object.keys(override.variant_labels).forEach(vid => {
                        stepContainer.querySelectorAll(`input[value="${vid}"]`).forEach(input => {
                            if (input.closest('.addon-item')) {
                                input.closest('.addon-item').classList.add('has-gift-label');
                                input.closest('.addon-item').setAttribute('data-gift-label', override.variant_labels[vid]);
                            }
                        });
                    });
                }
            });
        });

        // ==========================================
        // Event Listeners
        // ==========================================
        const purchaseOverlay = document.getElementById('purchase-modal-overlay');
        const openBtn = document.getElementById('open-purchase-modal');
        const closeBtn = document.getElementById('close-purchase-modal');

        if(openBtn) openBtn.addEventListener('click', () => { purchaseOverlay.style.display = 'flex'; document.body.classList.add('modal-open'); });
        if(closeBtn) closeBtn.addEventListener('click', () => { purchaseOverlay.style.display = 'none'; document.body.classList.remove('modal-open'); });
        if(purchaseOverlay) purchaseOverlay.addEventListener('click', e => { if(e.target === purchaseOverlay) { purchaseOverlay.style.display = 'none'; document.body.classList.remove('modal-open'); } });

        const updatePrice = () => {
            let cents = 0;
            const selectedVariant = document.querySelector('.variant-radio:checked');
            if (selectedVariant) cents += parseInt(selectedVariant.getAttribute('data-price') || 0);

            document.querySelectorAll('.main-qty-select, .addon-qty-select').forEach(sel => {
                const qty = parseInt(sel.value, 10) || 0;
                const price = parseInt(sel.getAttribute('data-price') || 0);
                cents += (qty * price);
            });

            document.querySelectorAll('.addon-input-radio:checked, .addon-input-checkbox:checked').forEach(inp => {
                cents += parseInt(inp.getAttribute('data-price') || 0);
            });

            const totalEl = document.getElementById('modal-total-price');
            if (totalEl) totalEl.innerText = formatMoney(cents);

            // Preorder Disclaimer Logic
            let activePreorders = [];
            
            // Check main variant/ink
            if (isInk) {
                document.querySelectorAll('.main-qty-select').forEach(sel => {
                    const qty = parseInt(sel.value, 10) || 0;
                    if (qty > 0) {
                        const hiddenInput = sel.closest('.addon-item').querySelector('.main-input-qty-val');
                        if (hiddenInput && hiddenInput.value) {
                            const vid = parseInt(hiddenInput.value, 10);
                            const variant = cp.variants.find(v => v.id === vid);
                            if (variant) {
                                const po = (variant && variant.is_preorder === true) ? parsePreorderValue(variant.preorder_lead_days, isZh) : null;
                                if (po) activePreorders.push(po);
                            }
                        }
                    }
                });
            } else {
                const selectedVariantRadio = document.querySelector('.variant-radio:checked');
                if (selectedVariantRadio) {
                    const vid = parseInt(selectedVariantRadio.value, 10);
                    const variant = cp.variants.find(v => v.id === vid);
                    if (variant) {
                        const po = (variant && variant.is_preorder === true) ? parsePreorderValue(variant.preorder_lead_days, isZh) : null;
                        if (po) activePreorders.push(po);
                    }
                }
            }

            // Check bundle options
            document.querySelectorAll('.addon-qty-select').forEach(sel => {
                const qty = parseInt(sel.value, 10) || 0;
                if (qty > 0) {
                    const hiddenInput = sel.closest('.addon-item').querySelector('.addon-input-qty-val');
                    if (hiddenInput && hiddenInput.value) {
                        const vid = parseInt(hiddenInput.value, 10);
                        activeBundles.forEach(bundle => {
                            if (!bundle.steps) return;
                            bundle.steps.forEach(step => {
                                if (!step.products) return;
                                step.products.forEach(addon => {
                                    if (!addon.variants) return;
                                    const variant = addon.variants.find(v => v.id === vid);
                                    if (variant) {
                                        const po = (variant && variant.is_preorder === true) ? parsePreorderValue(variant.preorder_lead_days, isZh) : null;
                                        if (po) activePreorders.push(po);
                                    }
                                });
                            });
                        });
                    }
                }
            });

            document.querySelectorAll('.addon-input-radio:checked, .addon-input-checkbox:checked').forEach(inp => {
                if (inp.value && inp.value !== "") {
                    const vid = parseInt(inp.value, 10);
                    activeBundles.forEach(bundle => {
                        if (!bundle.steps) return;
                        bundle.steps.forEach(step => {
                            if (!step.products) return;
                            step.products.forEach(addon => {
                                if (!addon.variants) return;
                                const variant = addon.variants.find(v => v.id === vid);
                                if (variant) {
                                    const po = (variant && variant.is_preorder === true) ? parsePreorderValue(variant.preorder_lead_days, isZh) : null;
                                    if (po) activePreorders.push(po);
                                }
                            });
                        });
                    });
                }
            });

            // Sort by targetDate descending to find the furthest preorder
            activePreorders.sort((a, b) => b.targetDate - a.targetDate);
            const furthestPreorder = activePreorders[0];

            const disclaimerWrap = document.getElementById('modal-preorder-disclaimer-wrap');
            const modalAddBtn = document.getElementById('modal-add-btn');

            if (furthestPreorder) {
                if (modalAddBtn) {
                    modalAddBtn.setAttribute('data-text-normal', isZh ? '立即預訂' : 'Pre-order Now');
                    modalAddBtn.setAttribute('data-text-processing', isZh ? '預訂中...' : 'Processing...');
                    modalAddBtn.innerText = isZh ? '立即預訂' : 'Pre-order Now';
                }
                if (disclaimerWrap) {
                    disclaimerWrap.style.display = 'block';
                    disclaimerWrap.innerHTML = `
                        <label style="cursor: pointer; display: flex; align-items: flex-start; gap: 6px; font-size: 11px; line-height: 1.4; color: #CC0000; text-align: left; margin-bottom: 12px; font-weight: normal;">
                            <input type="checkbox" id="modal-preorder-agree" style="margin-top: 2px;">
                            <span>
                                ${furthestPreorder.consent}
                            </span>
                        </label>
                    `;
                    
                    const agreeCheck = document.getElementById('modal-preorder-agree');
                    if (agreeCheck && modalAddBtn) {
                        modalAddBtn.disabled = !agreeCheck.checked;
                        agreeCheck.addEventListener('change', () => {
                            modalAddBtn.disabled = !agreeCheck.checked;
                        });
                    }
                }
            } else {
                if (modalAddBtn) {
                    modalAddBtn.setAttribute('data-text-normal', isZh ? '加入購物車' : 'Add to Cart');
                    modalAddBtn.setAttribute('data-text-processing', isZh ? '處理中...' : 'Processing...');
                    modalAddBtn.innerText = isZh ? '加入購物車' : 'Add to Cart';
                    modalAddBtn.disabled = false;
                }
                if (disclaimerWrap) {
                    disclaimerWrap.style.display = 'none';
                    disclaimerWrap.innerHTML = '';
                }
            }
        };

        document.querySelectorAll('.variant-radio, .main-qty-select, .addon-input-radio, .addon-input-checkbox, .addon-qty-select').forEach(el => el.addEventListener('change', updatePrice));
        updatePrice(); 

        const addBtn = document.getElementById('modal-add-btn');
        if (addBtn) {
            addBtn.addEventListener('click', () => {
                let items = [];
                const selectedVariant = document.querySelector('.variant-radio:checked');
                if (selectedVariant) items.push({ id: parseInt(selectedVariant.value, 10), quantity: 1 });

                document.querySelectorAll('.main-qty-select, .addon-qty-select').forEach(sel => {
                    const qty = parseInt(sel.value, 10) || 0;
                    if (qty > 0) {
                        const hiddenInput = sel.closest('.addon-item').querySelector('.main-input-qty-val, .addon-input-qty-val');
                        if (hiddenInput && hiddenInput.value) items.push({ id: parseInt(hiddenInput.value, 10), quantity: qty });
                    }
                });

                document.querySelectorAll('.addon-input-radio:checked, .addon-input-checkbox:checked').forEach(inp => {
                    if (inp.value && inp.value !== "") items.push({ id: parseInt(inp.value, 10), quantity: 1 });
                });

                if (items.length === 0) {
                    alert(isZh ? "請至少選擇一件產品" : "Please select at least one item");
                    return;
                }

                if (typeof gtag === 'function') {
                    gtag('event', 'va_direct_checkout', {
                        va_mode: 'product_modal',
                        items: items.map(item => ({ item_id: item.id, quantity: item.quantity }))
                    });
                }

                addBtn.innerText = addBtn.getAttribute('data-text-processing');
                addBtn.disabled = true;

                const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

                let itemsWithProperties = items.map(item => {
                    let variant = cp.variants.find(v => v.id === item.id);
                    if (!variant) {
                        activeBundles.forEach(bundle => {
                            if (!bundle.steps) return;
                            bundle.steps.forEach(step => {
                                if (!step.products) return;
                                step.products.forEach(addon => {
                                    if (!addon.variants) return;
                                    const matchedVariant = addon.variants.find(v => v.id === item.id);
                                    if (matchedVariant) variant = matchedVariant;
                                });
                            });
                        });
                    }
                    const po = (variant && variant.is_preorder === true) ? parsePreorderValue(variant.preorder_lead_days, isZh) : null;
                    if (po) {
                        const propKey = isZh ? "預訂貨品" : "Pre-order";
                        const propVal = po.propVal;
                        return {
                            ...item,
                            properties: { [propKey]: propVal }
                        };
                    }
                    return item;
                });

                fetch(rootUrl + 'cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: itemsWithProperties })
                })
                .then(res => { if (!res.ok) throw res; return res.json(); })
                .then(() => window.location.href = rootUrl + 'cart')
                .catch(err => {
                    console.error(err);
                    addBtn.innerText = addBtn.getAttribute('data-text-error');
                    addBtn.disabled = false;
                    setTimeout(() => addBtn.innerText = addBtn.getAttribute('data-text-normal'), 3000);
                    alert(isZh ? "你所選的產品可能庫存不足，或者你的購物車中有產品已缺貨。你可嘗試減少所選產品之數量，及按網站右上角的購物袋符號、檢查你的購物車內的產品。" : "The product you selected may have insufficient stock, or there are out‑of‑stock items in your shopping cart. You may try reducing the quantity of the selected product. Please click the shopping bag icon at the top right corner of the website to review the items in your cart.");
                });
            });
        }
        
        } catch (error) {
            console.error("Bundle Render Error", error);
            const loadingBtn = document.getElementById('fallback-loading-btn');
            const nativeForm = document.getElementById('native-add-to-cart-form');
            if (loadingBtn) loadingBtn.style.display = 'none';
            if (nativeForm) nativeForm.style.display = 'block';
        }

    }

    function getPromoApplicableText(p) {
        let isZh = (lang === 'zh');
        let isStorewide = (p.storewide === true || p.storewide === 'true' || p.storewide === 'Yes'); 
        let textColor = '#1d1d1f';

        if (isStorewide) {
            return `<span style="font-size:12px; font-weight:500; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; padding-left:2px; color:${textColor};">${isZh ? '全店適用' : 'Storewide'}</span>`;
        }

        let cIdsStr = p.collections || p.collection_ids || [];
        if (typeof cIdsStr === 'string') cIdsStr = cIdsStr.split(',').map(s=>s.trim()).filter(Boolean);

        let pIdsStr = p.product_ids || p.products || [];
        if (typeof pIdsStr === 'string') pIdsStr = pIdsStr.split(',').map(s=>s.trim()).filter(Boolean);

        if (pIdsStr.length === 0 && cIdsStr.length > 0) {
            let cNames = cIdsStr.map(c => {
                let cl = String(c).toLowerCase();
                if (cl.includes('ink')) return isZh ? '指定墨水' : 'Selected Inks';
                if (cl.includes('toner')) return isZh ? '指定碳粉' : 'Selected Toners';
                if (cl.includes('camera') || cl === 'eosr') return isZh ? '相機' : 'Cameras';
                if (cl.includes('lens') || cl === 'rf') return isZh ? '鏡頭' : 'Lenses';
                if (cl.includes('printer')) return isZh ? '打印機' : 'Printers';
                return c;
            });
            return `<span style="font-size:12px; font-weight:500; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; padding-left:2px; color:${textColor};">${cNames.join(', ')}</span>`;
        }

        let pData = (productData['CAMERA_DB']||[]).concat(productData['LENS_DB']||[]).concat(productData['PRINTER_DB']||[]).concat(productData['INK_DB']||[]).concat(productData['TONER_DB']||[]);
        let relatedNames = [];
        pIdsStr.slice(0, 2).forEach(id => {
            let match = pData.find(item => window.VA_LIQUID_PRICES && window.VA_LIQUID_PRICES[item.sku] && String(window.VA_LIQUID_PRICES[item.sku].id) === String(id));
            if (!match) match = pData.find(item => String(item.sku) === String(id) || String(item.handle) === String(id));
            if (match) relatedNames.push({ name: match.model || match.t || match.title || match.name || id, image: match.image || match.i });
        });

        if (relatedNames.length === 0) {
             return `<span style="font-size:12px; font-weight:500; display:block; width:100%; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; padding-left:2px; color:${textColor};">${isZh ? '指定產品' : 'Selected Products'}</span>`;
        }

        let applicableTextHtml = '';
        relatedNames.forEach((item, idx) => {
            applicableTextHtml += `
            <div style="width:24px; height:24px; background:#fff; border-radius:4px; display:flex; align-items:center; justify-content:center; flex-shrink:0; ${idx>0?'margin-left:4px;':''}; border: 1px solid #e5e5ea; padding:2px; box-sizing:border-box;">
                ${item.image ? `<img src="${item.image}" style="max-width:100%; max-height:100%; object-fit:contain;">` : ''}
            </div>
            <span style="font-size:12px; font-weight:500; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; color:${textColor}; margin-left:4px;">${item.name}</span>
            `;
        });
        if (pIdsStr.length > 2) applicableTextHtml += `<span style="font-size:12px; font-weight:500; color:${textColor}; margin-left:2px; flex-shrink:0;">${isZh?' 等指定型號':' and others'}</span>`;
        
        return applicableTextHtml;
    }

    function generatePromoCardHtml(p, idx, layout = '') {
        let isZh = (lang === 'zh');
        if (layout === 'inline_compact') {
            let title = p.promo_title || p.title;
            let desc = p.promo_desc || '';
            let encodedP = encodeURIComponent(JSON.stringify(p)).replace(/'/g, "%27");
            let onClickAction = `window.canonApp.openPromoModal('${encodedP}')`;
            let cleanDesc = desc ? desc.replace(/<[^>]*>/g, '') : '';
            return `
                <div class="inline-compact-promo-card" style="display: flex; align-items: flex-start; gap: 10px; background: #fafafa; border: 1px solid #e5e5ea; border-radius: 8px; padding: 10px 12px; margin-bottom: 8px; cursor: pointer; transition: all 0.2s;" onmouseover="this.style.borderColor='#86868b'; this.style.background='#f5f5f7';" onmouseout="this.style.borderColor='#e5e5ea'; this.style.background='#fafafa';" onclick="event.stopPropagation(); ${onClickAction}">
                    <div style="background: #e32400; color: #fff; border-radius: 50%; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; font-size: 14px;">
                        <i class="ph-fill ph-gift" style="font-size: 14px; color: #fff;"></i>
                    </div>
                    <div style="flex-grow: 1; min-width: 0; text-align: left;">
                        <div style="font-size: 13px; font-weight: 600; color: #1d1d1f; margin-bottom: 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${title}</div>
                        ${cleanDesc ? `<div style="font-size: 11px; color: #86868b; line-height: 1.3; display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical; overflow: hidden;">${cleanDesc}</div>` : ''}
                    </div>
                    <div style="font-size: 11px; color: #0070c9; font-weight: 500; flex-shrink: 0; align-self: center; display: flex; align-items: center; gap: 2px;">
                        <span>${isZh ? '詳情' : 'Details'}</span>
                        <i class="ph ph-caret-right" style="font-size: 12px; color: #0070c9;"></i>
                    </div>
                </div>
            `;
        }

        if (p.pinned === 'Yes, banner only' && p.image) {
            let linkAction = '';
            if (p.link_url) {
                linkAction = `onclick="window.open('${p.link_url}', '_blank')"`;
            } else if (p.url) {
                linkAction = `onclick="window.location.href='${p.url}'"`;
            }
            let cursorStyle = linkAction ? 'cursor:pointer;' : '';
            let extraStyle = layout === 'split_auto' ? 'width:100%; max-width:none;' : '';
            return `
                <div class="canon-banner-card promo-banner-only" style="${extraStyle} border:none; box-shadow:none; background:transparent; ${cursorStyle}" ${linkAction}>
                    <img src="${p.image}" alt="Promotion Banner" style="width:100%; height:auto; border-radius:16px; display:block; box-shadow: 0 4px 15px rgba(0,0,0,0.05);">
                </div>
            `;
        }

        isZh = (lang === 'zh');
        let title = p.promo_title || p.title;
        let desc = p.promo_desc || '';
        let applicableTextHtml = getPromoApplicableText(p);
        let encodedP = encodeURIComponent(JSON.stringify(p)).replace(/'/g, "%27");
        let onClickAction = `window.canonApp.openPromoModal('${encodedP}')`;
        
        let extraStyle = layout === 'split_auto' ? 'width:100%; max-width:none;' : '';
        let topHtml = '';

        if (p.image && p.image.trim() !== '') {
            topHtml = `
                <div style="aspect-ratio:800/290; background-image:url('${p.image}'); background-size:cover; background-position:center; position:relative; border-bottom:1px solid #f5f5f7;">
                </div>`;
        } else {
            let colorIdx = idx % 5;
            topHtml = `
                <div class="promo-bg-${colorIdx}" style="aspect-ratio:800/290; display:flex; align-items:center; padding:20px; border-bottom:1px solid #f5f5f7;">
                    <i class="ph-fill ph-gift" style="font-size:28px; margin-right:12px; color:#fff; opacity:0.9;"></i>
                    <div style="color:#fff; font-weight:700; font-size:18px; line-height:1.3; display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden;">${title}</div>
                </div>`;
        }

        // Pill tag: <div style="position:absolute; top:12px; left:12px; background:#e32400; color:#fff; font-size:11px; font-weight:700; padding:4px 10px; border-radius:6px; box-shadow:0 2px 6px rgba(0,0,0,0.15);">${p.promo_title || (isZh ? '限時優惠' : 'Limited Offer')}</div>

        // Remove visibility:hidden; to show
        let bottomTitleStyle = (p.image && p.image.trim() !== '') ? '' : 'visibility:hidden;';

        return `
            <div class="canon-banner-card" style="${extraStyle} display:flex; flex-direction:column; background:#fff; cursor:pointer;" onclick="${onClickAction}">
                ${topHtml}
                <div style="padding:15px; display:flex; flex-direction:column; flex-grow:1;">
                    <div style="font-size:16px; margin-bottom:8px; color:#1d1d1f; font-weight:600; ${bottomTitleStyle}">${title}</div>
                    <div style="font-size:12px; color:#555; line-height:1.4; display:-webkit-box; -webkit-line-clamp:3; -webkit-box-orient:vertical; overflow:hidden; margin-bottom:15px; flex-grow:1;">${desc}</div>
                    
                    <div style="margin-top:auto; padding-top:12px; border-top:1px solid #e5e5ea; display:flex; justify-content:space-between; align-items:center; gap:8px;">
                        <div style="display:flex; flex-direction:column; gap:4px; flex:1; min-width:0; overflow:hidden;">
                            <span style="font-size:10px; font-weight:700; color:#86868b; text-transform:uppercase; line-height:1;">${t.spec_applicable_for}:</span>
                            <div style="display:flex; align-items:center; gap:4px; overflow:hidden; width:100%;">${applicableTextHtml}</div>
                        </div>
                        <div style="background:#1d1d1f; color:#fff; padding:6px 14px; font-size:11px; font-weight:700; border-radius:99px; line-height:1; flex-shrink:0;">${isZh?'詳情':'Details'}</div>
                    </div>
                </div>
            </div>
        `;
    }

    function triggerAutoBanners() {
        const wrapper = document.querySelector('.canon-va-wrapper-fix');
        if (!wrapper) return;
        const layout = wrapper.getAttribute('data-inline-layout');
        const maxBanners = parseInt(wrapper.getAttribute('data-max-banners')) || 4;
        
        if (layout !== 'split_auto' && layout !== 'full_auto') return;
        
        let containerId = layout === 'full_auto' ? 'canon-auto-banners-full-container' : 'canon-auto-banners-side-container';
        
        if (layout === 'full_auto') {
            if (finderState.mode === 'toner') {
                containerId = 'canon-auto-banners-toner-container';
            } else if (finderState.mode === 'ink') {
                containerId = 'canon-auto-banners-ink-container';
            }
        }
        
        const container = document.getElementById(containerId);
        if (!container) return;

        let shopData = window.CANON_GLOBAL_DATA?.SHOPIFY_DATA || { bundles: [], promotions: [] };
        let allPromos = [...(shopData.bundles || []), ...(shopData.promotions || [])];
        const now = Math.floor(Date.now() / 1000);
        
        let validPromos = allPromos.filter(promo => {
            if (promo.handle === 'canon-store-exclusive') return false;
            let sTime = promo.start_time || promo.start;
            let eTime = promo.end_time || promo.end;
            if (typeof sTime === 'string') sTime = Math.floor(new Date(sTime).getTime() / 1000);
            if (typeof eTime === 'string') eTime = Math.floor(new Date(eTime).getTime() / 1000) + 86399;
            if (sTime && sTime > now) return false;
            if (eTime && eTime < now) return false;
            return true;
        });

        let matchedPromos = [];
        if (finderState.mode === 'full') {
            matchedPromos = validPromos;
        } else {
            matchedPromos = validPromos.filter(promo => {
                let modes = promo.applicable_modes || [];
                if (modes.includes('all')) return true;
                let currentMode = finderState.mode.toLowerCase();
                if (currentMode.endsWith('_wizard')) currentMode = currentMode.replace('_wizard', '');
                if (currentMode === 'lens') currentMode = 'rf';
                if (currentMode === 'camera') currentMode = 'eosr';
                if (currentMode.startsWith('printer')) return modes.includes('printer');
                return modes.includes(currentMode);
            });
        }

        matchedPromos.sort((a, b) => {
            let aPin = a.pinned === 'Yes' || a.pinned === 'true' || a.pinned === 'Yes, banner only' ? 1 : 0;
            let bPin = b.pinned === 'Yes' || b.pinned === 'true' || b.pinned === 'Yes, banner only' ? 1 : 0;
            if (aPin !== bPin) return bPin - aPin;
            let aStorewide = a.storewide === true || a.storewide === 'true' ? 0 : 1; 
            let bStorewide = b.storewide === true || b.storewide === 'true' ? 0 : 1;
            if (aStorewide !== bStorewide) return bStorewide - aStorewide;
            return (b.start_time || 0) - (a.start_time || 0); 
        });

        if (matchedPromos.length === 0) {
            container.style.display = 'none';
            return;
        }

        container.style.display = 'block';
        let displayPromos = matchedPromos.slice(0, maxBanners);
        let hasMore = matchedPromos.length > maxBanners;

        let html = `
            <div class="relative w-full">
                <div class="banner-header-area">
                    <h2 class="banner-header-title">
                        <i class="ph-fill ph-ticket text-2xl text-red-600"></i>
                        ${lang === 'zh' ? '推介產品及優惠' : 'Recommended Products & Offers'}
                    </h2>
                    ${layout === 'full_auto' ? `
                    <div class="banner-nav-btns">
                        <button class="banner-scroll-btn" onclick="document.getElementById('canon-banner-track').scrollBy({ left: -336, behavior: 'smooth' });"><i class="ph-bold ph-caret-left"></i></button>
                        <button class="banner-scroll-btn" onclick="document.getElementById('canon-banner-track').scrollBy({ left: 336, behavior: 'smooth' });"><i class="ph-bold ph-caret-right"></i></button>
                    </div>` : ''}
                </div>
                <div id="canon-banner-track" class="${layout === 'full_auto' ? 'canon-banner-track' : 'canon-banner-grid'}" style="${layout === 'split_auto' ? 'display:flex; flex-direction:column; gap:16px;' : ''}">
        `;

        displayPromos.forEach((p, idx) => {
            html += generatePromoCardHtml(p, idx, layout);
        });

        if (hasMore) {
            let shownIds = displayPromos.map(p => p.id);
            let shownIdsJson = encodeURIComponent(JSON.stringify(shownIds));
            let extraStyle = layout==='split_auto' ? 'width:100%; max-width:none; flex-direction:row; padding:15px; justify-content:flex-start; gap:15px;' : '';
            let iconMargin = layout==='split_auto' ? 'margin:0;' : 'margin-bottom:12px;';

            html += `
                <div class="canon-banner-card promo-more-card" style="${extraStyle}" onclick="window.canonApp.openAllPromosModal('${shownIdsJson}')">
                    <div class="promo-more-icon" style="${iconMargin}"><i class="ph-bold ph-arrow-right"></i></div>
                    <div style="${layout==='split_auto'?'text-align:left;':''}">
                        <h3 class="promo-more-text">${lang === 'zh' ? '查看更多優惠' : 'View More Offers'}</h3>
                    </div>
                </div>
            `;
        }

        html += `</div></div>`;
        container.innerHTML = html;
    }

    function renderLatestPromosMode() {
        const grid = document.getElementById('result-grid');
        grid.innerHTML = '';
        grid.classList.add('latest-promos-grid'); 
        
        let shopData = window.CANON_GLOBAL_DATA?.SHOPIFY_DATA || { bundles: [], promotions: [] };
        let allPromos = [...(shopData.bundles || []), ...(shopData.promotions || [])];
        const now = Math.floor(Date.now() / 1000);
        
        let validPromos = allPromos.filter(promo => {
            if (promo.handle === 'canon-store-exclusive') return false;
            let sTime = promo.start_time || promo.start;
            let eTime = promo.end_time || promo.end;
            if (typeof sTime === 'string') sTime = Math.floor(new Date(sTime).getTime() / 1000);
            if (typeof eTime === 'string') eTime = Math.floor(new Date(eTime).getTime() / 1000) + 86399;
            if (sTime && sTime > now) return false;
            if (eTime && eTime < now) return false;
            return true;
        });

        validPromos.sort((a, b) => (b.start_time || 0) - (a.start_time || 0));

        if (validPromos.length === 0) {
            grid.innerHTML = `<div style="text-align:center; width:100%; padding:40px; color:#86868b;">${lang==='zh'?'目前未有最新優惠':'No offers available right now.'}</div>`;
            return;
        }

        let wrapper = document.querySelector('.canon-va-wrapper-fix');
        let maxAll = wrapper ? parseInt(wrapper.getAttribute('data-max-all-promos')) || 0 : 0;
        if (maxAll > 0) validPromos = validPromos.slice(0, maxAll);

        validPromos.forEach((p, idx) => {
            grid.insertAdjacentHTML('beforeend', generatePromoCardHtml(p, idx, 'split_auto'));
        });

        let backBtnContainer = document.createElement('div');
        backBtnContainer.style.cssText = "grid-column: 1 / -1; margin-top: 20px; text-align: left;";
        backBtnContainer.innerHTML = `<div class="canon-finder__cta reset-btn" style="cursor:pointer; display:inline-flex;" onclick="canonApp.goBack(); document.getElementById('canon-app-wrapper').scrollIntoView({behavior:'smooth'});">&lt; ${lang==='zh'?'返回上一頁':'Back'}</div>`;
        grid.appendChild(backBtnContainer);
    }

    function openPromoModal(encodedP, parentId = null) {
        let p = JSON.parse(decodeURIComponent(encodedP));
        let oldOverlay = document.getElementById('canon-auto-promo-modal');
        if (oldOverlay) oldOverlay.remove();
        let isZh = (lang === 'zh');

        let relatedNames = [];
        let isStorewide = (p.storewide === true || p.storewide === 'true' || p.storewide === 'Yes');
        
        if (isStorewide) {
             relatedNames.push({ name: isZh ? '全店適用' : 'Storewide', image: '', url: '' });
        } else {
            let pIdsStr = p.product_ids || p.products || [];
            if (typeof pIdsStr === 'string') pIdsStr = pIdsStr.split(',').map(s=>s.trim()).filter(Boolean);
            
            let cIdsStr = p.collections || p.collection_ids || [];
            if (typeof cIdsStr === 'string') cIdsStr = cIdsStr.split(',').map(s=>s.trim()).filter(Boolean);

            if (pIdsStr.length === 0 && cIdsStr.length > 0) {
                let cNames = cIdsStr.map(c => {
                    let cl = String(c).toLowerCase();
                    if (cl.includes('ink')) return isZh ? '指定墨水' : 'Selected Inks';
                    if (cl.includes('toner')) return isZh ? '指定碳粉' : 'Selected Toners';
                    if (cl.includes('camera') || cl === 'eosr') return isZh ? '相機' : 'Cameras';
                    if (cl.includes('lens') || cl === 'rf') return isZh ? '鏡頭' : 'Lenses';
                    if (cl.includes('printer')) return isZh ? '打印機' : 'Printers';
                    return c;
                });
                relatedNames.push({ name: cNames.join(', '), image: '', url: '' });
            } else {
                let pData = (productData['CAMERA_DB']||[]).concat(productData['LENS_DB']||[]).concat(productData['PRINTER_DB']||[]).concat(productData['INK_DB']||[]).concat(productData['TONER_DB']||[]);
                pIdsStr.forEach(id => {
                    let match = pData.find(item => window.VA_LIQUID_PRICES && window.VA_LIQUID_PRICES[item.sku] && String(window.VA_LIQUID_PRICES[item.sku].id) === String(id));
                    if (!match) match = pData.find(item => String(item.sku) === String(id) || String(item.handle) === String(id));
                    if (match) relatedNames.push({ name: match.model || match.t || match.title || match.name || id, image: match.image || match.i, url: match.url || match.u });
                });
            }
        }

        let modelsHtml = '';
        if (relatedNames.length > 0 && relatedNames[0].name !== (isZh?'指定產品':'Selected Products')) {
            relatedNames.forEach(item => {
                if (item.url) {
                    modelsHtml += `
                        <a href="${item.url}" target="_blank" style="display:flex; align-items:center; gap:12px; padding:8px; background:#f9f9f9; border-radius:12px; border:1px solid #e5e5ea; margin-bottom:8px; text-decoration:none; color:#1d1d1f; transition:all 0.2s;" onmouseover="this.style.borderColor='#86868b';" onmouseout="this.style.borderColor='#e5e5ea';">
                            ${item.image ? `<div style="width:40px; height:40px; background:#fff; border-radius:8px; display:flex; align-items:center; justify-content:center; border:1px solid #e5e5ea; padding:4px; flex-shrink:0;"><img src="${item.image}" style="max-width:100%; max-height:100%; object-fit:contain;"></div>` : ''}
                            <span style="font-weight:500; font-size:14px;">${item.name}</span>
                        </a>
                    `;
                } else {
                    modelsHtml += `
                        <li style="display:flex; align-items:center; gap:12px; padding:8px; background:#f9f9f9; border-radius:12px; border:1px solid #e5e5ea; margin-bottom:8px; list-style:none;">
                            ${item.image ? `<div style="width:40px; height:40px; background:#fff; border-radius:8px; display:flex; align-items:center; justify-content:center; border:1px solid #e5e5ea; padding:4px; flex-shrink:0;"><img src="${item.image}" style="max-width:100%; max-height:100%; object-fit:contain;"></div>` : ''}
                            <span style="font-weight:500; font-size:14px;">${item.name}</span>
                        </li>
                    `;
                }
            });
        } else {
            modelsHtml = `<li style="padding:8px; font-size:14px; background:#f9f9f9; border-radius:12px; border:1px solid #e5e5ea; list-style:none;">${isZh?'指定產品':'Selected Products'}</li>`;
        }

        let tncHtml = p.tnc ? `<h4 style="font-weight:700; color:#1d1d1f; margin-bottom:12px; font-size:14px; text-transform:uppercase; letter-spacing:0.05em;">${isZh?'條款及細則:':'Terms & Conditions:'}</h4><div style="font-size:12px; color:#555; line-height:1.6;">${p.tnc}</div>` : '';
        let detailHtml = p.detail ? `<h4 style="font-weight:700; color:#1d1d1f; margin-bottom:12px; font-size:14px; text-transform:uppercase; letter-spacing:0.05em;">${isZh?'優惠詳情:':'Offer Details:'}</h4><div style="font-size:14px; color:#333; line-height:1.6; margin-bottom:24px;">${p.detail}</div>` : '';
        let detailImageHtml = p.detail_image ? `<img src="${p.detail_image}" style="width:100%; border-radius:8px; margin-bottom:24px;">` : '';

        let topBannerHtml = p.image ? `<img src="${p.image}" style="width:100%; height:auto; aspect-ratio:800/290; border-radius:12px; margin-bottom:20px; object-fit:cover; border:1px solid #e5e5ea; background-color:#f5f5f7;">` : '';
        let descHtml = p.promo_desc ? `<div style="font-size:14px; color:#555; margin-bottom:24px; line-height:1.6; padding-bottom:16px; border-bottom:1px dashed #e5e5ea;">${p.promo_desc}</div>` : '';
        
        let linkUrl = p.link_url || p.url || p.promo_link || p.action_link || ""; 
        let linkHtml = '';
        if (linkUrl && linkUrl.trim() !== '') {
            linkHtml = `<div style="margin-top:24px; padding-top:16px; border-top:1px solid #e5e5ea; text-align:right;">
                <a href="${linkUrl}" target="_blank" style="display:inline-flex; align-items:center; gap:8px; text-decoration:none; max-width:max-content; margin-left:auto; border-radius:24px; background:#e32400; color:#fff; border:none; padding:12px 24px; font-weight:700; font-size:14px;">${isZh?'詳情':'Details'}</a>
            </div>`;
        }

        let rightColHtml = topBannerHtml + descHtml + detailImageHtml + detailHtml + tncHtml + linkHtml;

        let closeAction = parentId 
            ? `event.stopPropagation(); this.closest('.modal-overlay').remove(); document.getElementById('${parentId}').style.display='flex';` 
            : `event.stopPropagation(); this.closest('.modal-overlay').remove(); document.body.classList.remove('modal-open');`;

        let touchCloseAction = parentId
            ? `event.preventDefault(); event.stopPropagation(); this.closest('.modal-overlay').remove(); document.getElementById('${parentId}').style.display='flex';`
            : `event.preventDefault(); event.stopPropagation(); this.closest('.modal-overlay').remove(); document.body.classList.remove('modal-open');`;

        let html = `
            <div id="canon-auto-promo-modal" class="modal-overlay tnc-overlay" style="display: flex;" onclick="if(event.target === this) { ${closeAction} }" ontouchend="if(event.target === this) { ${touchCloseAction} }" ontouchstart="event.stopPropagation();">
                <div class="modal-container promo-wide-modal">
                    <div class="modal-header">
                        <h3 style="font-weight:700; font-size:20px; margin:0; letter-spacing:-0.01em;">${p.promo_title || p.title}</h3>
                        <button class="modal-close-btn" onclick="${closeAction}" ontouchend="${touchCloseAction}" ontouchstart="event.stopPropagation();">&times;</button>
                    </div>
                    <div class="modal-content-scroll promo-detail-split">
                        <div class="promo-detail-left">
                            <h4 style="font-weight:700; color:#1d1d1f; margin-bottom:12px; font-size:14px; text-transform:uppercase; letter-spacing:0.05em;">${isZh?'適用於以下產品:':'Applicable to:'}</h4>
                            <ul class="promo-model-list">${modelsHtml}</ul>
                        </div>
                        <div class="promo-detail-right">
                            ${rightColHtml}
                        </div>
                    </div>
                </div>
            </div>
        `;
        document.body.insertAdjacentHTML('beforeend', html);
        document.body.classList.add('modal-open');
    }

    function openAllPromosModal(shownIdsJson = '[]') {
        let oldOverlay = document.getElementById('canon-all-promos-modal');
        if (oldOverlay) oldOverlay.remove();

        let shopData = window.CANON_GLOBAL_DATA?.SHOPIFY_DATA || { bundles: [], promotions: [] };
        let allPromos = [...(shopData.bundles || []), ...(shopData.promotions || [])];
        const now = Math.floor(Date.now() / 1000);
        
        let validPromos = allPromos.filter(promo => {
            if (promo.handle === 'canon-store-exclusive') return false;
            let sTime = promo.start_time || promo.start;
            let eTime = promo.end_time || promo.end;
            if (typeof sTime === 'string') sTime = Math.floor(new Date(sTime).getTime() / 1000);
            if (typeof eTime === 'string') eTime = Math.floor(new Date(eTime).getTime() / 1000) + 86399;
            if (sTime && sTime > now) return false;
            if (eTime && eTime < now) return false;
            return true;
        });

        if (finderState.mode !== 'full' && finderState.mode !== 'latest_promos') {
            validPromos = validPromos.filter(promo => {
                let modes = promo.applicable_modes || [];
                if (modes.includes('all')) return true;
                
                let currentMode = finderState.mode.toLowerCase();
                if (currentMode.endsWith('_wizard')) currentMode = currentMode.replace('_wizard', '');
                if (currentMode === 'lens') currentMode = 'rf';
                if (currentMode === 'camera') currentMode = 'eosr';
                if (currentMode.startsWith('printer')) return modes.includes('printer');
                
                return modes.includes(currentMode);
            });
        }

        validPromos.sort((a, b) => (b.start_time || 0) - (a.start_time || 0));

        let excludeIds = [];
        try {
            excludeIds = JSON.parse(decodeURIComponent(shownIdsJson));
        } catch(e) {}
        
        if (excludeIds.length > 0) {
            validPromos = validPromos.filter(p => !excludeIds.includes(p.id));
        }

        let wrapper = document.querySelector('.canon-va-wrapper-fix');
        let maxAll = wrapper ? parseInt(wrapper.getAttribute('data-max-all-promos')) || 0 : 0;
        if (maxAll > 0) validPromos = validPromos.slice(0, maxAll);

        let listHtml = '<div class="promo-all-grid">';
        validPromos.forEach((p, idx) => {
            let isStyleA = !!(p.image && p.image.trim() !== '');
            let applicableTextHtml = getPromoApplicableText(p);
            
            let encodedP = encodeURIComponent(JSON.stringify(p)).replace(/'/g, "%27");
            let onClickAction = `document.getElementById('canon-all-promos-modal').style.display='none'; setTimeout(() => window.canonApp.openPromoModal('${encodedP}', 'canon-all-promos-modal'), 10);`;

            // Promotion banner card (with photo)

            if (isStyleA) {
                let title = p.promo_title || p.title;
                listHtml += `
                    <div class="canon-banner-card promo-style-a" onclick="${onClickAction}">
                        <div class="promo-img-box">
                            <img src="${p.image}" alt="Promo">
                        </div>
                        <div class="promo-content">
                            <div style="font-size:16px; margin-bottom:8px; color:#1d1d1f; font-weight:600;">${title}</div>
                            ${p.promo_desc ? `<div style="font-size:12px; color:#555; line-height:1.4; display:-webkit-box; -webkit-line-clamp:3; -webkit-box-orient:vertical; overflow:hidden; margin-bottom:12px;">${p.promo_desc}</div>` : ''}
                            <div class="promo-for-box">
                                <span class="promo-for-label">${t.spec_applicable_for}:</span>
                                <div class="promo-for-items">${applicableTextHtml}</div>
                            </div>
                        </div>
                    </div>
                `;
            } else {
                let colorIdx = idx % 5;
                let title = p.promo_title || p.title;
                listHtml += `
                    <div class="canon-banner-card promo-style-a" onclick="${onClickAction}">
                        <div class="promo-img-box promo-bg-${colorIdx}" style="aspect-ratio: 800/290; padding:20px; display:flex; flex-direction:row; align-items:center; justify-content:flex-start;">
                            <i class="ph-fill ph-gift" style="font-size:24px; margin-right:12px; color:#fff; opacity:0.9;"></i>
                            <div style="color:#fff; font-weight:700; font-size:18px; line-height:1.2; display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden;">${title}</div>
                        </div>
                        <div class="promo-content">
                            ${p.promo_desc ? `<div style="font-size:12px; color:#555; line-height:1.4; display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden; margin-bottom:8px;">${p.promo_desc}</div>` : ''}
                            <div class="promo-for-box">
                                <span class="promo-for-label">${t.spec_applicable_for}:</span>
                                <div class="promo-for-items">${applicableTextHtml}</div>
                            </div>
                        </div>
                    </div>
                `;
            }
        });
        listHtml += '</div>';

        let html = `
            <div id="canon-all-promos-modal" class="modal-overlay tnc-overlay" style="display: flex;">
                <div class="modal-container tnc-container" style="background:#f5f5f7 !important;">
                    <div class="modal-header" style="background:#fff;">
                        <h3 style="font-weight:700; font-size:20px; margin:0; letter-spacing:-0.01em;">${lang==='zh'?'所有優惠':'All Offers'}</h3>
                        <button class="modal-close-btn" onclick="this.closest('.modal-overlay').remove(); document.body.classList.remove('modal-open');">&times;</button>
                    </div>
                    <div class="modal-content-scroll promo-list-container">
                        <p style="font-size:13px; color:#86868b; text-align:center; margin-bottom:8px;">${lang==='zh'?'向下捲動查看所有優惠':'Scroll down to view all offers'}</p>
                        ${listHtml}
                    </div>
                </div>
            </div>
        `;
        document.body.insertAdjacentHTML('beforeend', html);
        document.body.classList.add('modal-open');
    }

    function showVAPromosListModal(sku) {
        let liquidData = typeof window.VA_LIQUID_PRICES !== 'undefined' ? window.VA_LIQUID_PRICES[sku] : null;
        let data = (window.CANON_GLOBAL_DATA && window.CANON_GLOBAL_DATA.SHOPIFY_DATA) ? window.CANON_GLOBAL_DATA.SHOPIFY_DATA : (window.CANON_GLOBAL_DATA || { bundles: [], promotions: [] });
        
        if (!liquidData) return;
        
        let pId = String(liquidData.id || '').trim();
        let pColls = liquidData.collections || [];
        
        let pVarIdsStr = [];
        let pVarsRaw = liquidData.variants;
        if (pVarsRaw) {
            if (typeof pVarsRaw === 'string') {
                pVarsRaw.split(',').forEach(v => pVarIdsStr.push(String(v).trim()));
            } else if (Array.isArray(pVarsRaw)) {
                pVarsRaw.forEach(v => pVarIdsStr.push(String(typeof v === 'object' ? (v.id || v) : v).trim()));
            } else if (typeof pVarsRaw === 'object') {
                Object.keys(pVarsRaw).forEach(k => pVarIdsStr.push(String(k).trim()));
            }
        }
        if (data.variants && data.variants[sku]) {
            data.variants[sku].forEach(v => pVarIdsStr.push(String(typeof v === 'object' ? (v.id || v) : v).trim()));
        }
        pVarIdsStr = [...new Set(pVarIdsStr)].filter(Boolean);

        const now = Math.floor(Date.now() / 1000);

        const isMatch = (promo) => {
            let sTime = promo.start_time || promo.start;
            let eTime = promo.end_time || promo.end;
            if (typeof sTime === 'string') sTime = Math.floor(new Date(sTime).getTime() / 1000);
            if (typeof eTime === 'string') eTime = Math.floor(new Date(eTime).getTime() / 1000) + 86399;
            
            if (sTime && sTime > now) return false;
            if (eTime && eTime < now) return false;

            if (promo.storewide === true || promo.storewide === 'true') return true;
            
            let pIdsStr = promo.product_ids || [];
            if (typeof pIdsStr === 'string') pIdsStr = pIdsStr.split(',').map(s => s.trim());
            if (pId && pIdsStr.map(String).includes(pId)) return true;

            let vpIdsStr = promo.variant_parent_ids || [];
            if (typeof vpIdsStr === 'string') vpIdsStr = vpIdsStr.split(',').map(s => s.trim());
            else if (Array.isArray(vpIdsStr)) vpIdsStr = vpIdsStr.map(String);
            if (pId && vpIdsStr.includes(pId)) return true;

            let cIdsStr = promo.collection_ids || [];
            if (typeof cIdsStr === 'string') cIdsStr = cIdsStr.split(',').map(s => s.trim());
            if (pColls.length > 0 && cIdsStr.some(cid => pColls.map(String).includes(String(cid)))) return true;

            let vIdsStr = promo.variant_ids || [];
            if (typeof vIdsStr === 'string') vIdsStr = vIdsStr.split(',').map(s => s.trim());
            if (pVarIdsStr.length > 0 && vIdsStr.length > 0 && pVarIdsStr.some(vid => vIdsStr.map(String).includes(vid))) return true;

            return false;
        };

        let matchedPromos = [];
        let allPromos = [...(data.bundles || []), ...(data.promotions || [])];
        allPromos.forEach(p => {
            let handle = p.handle || '';
            if (handle === 'canon-store-exclusive' || handle.includes('weee') || handle.includes('tradein')) return;
            if (isMatch(p)) matchedPromos.push(p);
        });

        if (matchedPromos.length === 0) return;

        if (matchedPromos.length === 1) {
            let encodedP = encodeURIComponent(JSON.stringify(matchedPromos[0])).replace(/'/g, "%27");
            openPromoModal(encodedP);
            return;
        }

        let listHtml = '';
        matchedPromos.forEach((p, idx) => {
            listHtml += generatePromoCardHtml(p, idx, 'split_auto');
        });

        let isZh = (lang === 'zh');
        let count = matchedPromos.length;
        let titleText = isZh ? `${count} 項優惠` : `${count} ${count > 1 ? 'promotions' : 'promotion'}`;
        let oldOverlay = document.getElementById('canon-va-promos-list-modal');
        if (oldOverlay) oldOverlay.remove();

        let html = `
            <div id="canon-va-promos-list-modal" class="modal-overlay tnc-overlay" style="display: flex;" onclick="if(event.target === this) { event.stopPropagation(); this.remove(); document.body.classList.remove('modal-open'); }" ontouchend="if(event.target === this) { event.preventDefault(); event.stopPropagation(); this.remove(); document.body.classList.remove('modal-open'); }" ontouchstart="event.stopPropagation();">
                <div class="modal-container promo-wide-modal" style="max-height: 85vh; max-width: 800px; padding-bottom: 20px;">
                    <div class="modal-header">
                        <h3 style="font-weight:700; font-size:20px; margin:0; letter-spacing:-0.01em;">${titleText}</h3>
                        <button class="modal-close-btn" onclick="event.stopPropagation(); this.closest('.modal-overlay').remove(); document.body.classList.remove('modal-open');" ontouchend="event.preventDefault(); event.stopPropagation(); this.closest('.modal-overlay').remove(); document.body.classList.remove('modal-open');" ontouchstart="event.stopPropagation();">&times;</button>
                    </div>
                    <div class="modal-content-scroll" style="padding: 24px; max-height: calc(85vh - 70px); overflow-y: auto;">
                        <div class="latest-promos-grid" style="display: grid; grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); gap: 16px;">
                            ${listHtml}
                        </div>
                    </div>
                </div>
            </div>
        `;
        document.body.insertAdjacentHTML('beforeend', html);
        document.body.classList.add('modal-open');

        let modalEl = document.getElementById('canon-va-promos-list-modal');
        modalEl.querySelectorAll('.canon-banner-card').forEach((card, idx) => {
            let p = matchedPromos[idx];
            let encodedP = encodeURIComponent(JSON.stringify(p)).replace(/'/g, "%27");
            card.onclick = (e) => {
                e.stopPropagation();
                modalEl.style.display = 'none';
                openPromoModal(encodedP, 'canon-va-promos-list-modal');
            };
        });
    }

    const appInterface = { 
        init: function(e) { init(typeof e === 'string' ? e : undefined); }, 
        resetFlow: resetFlow,
        wizardGoBack: wizardGoBack,
        goBack: goBack,
        toggleLanguage: toggleLanguage,
        initProductPromotions: initProductPromotions,
        openPromoModal: openPromoModal,
        openAllPromosModal: openAllPromosModal,
        showVAPromosListModal: showVAPromosListModal,
        routeToMode: function(target) {
            finderState.history.push({ mode: finderState.mode, menuId: finderState.currentMenuId, menuTitle: finderState.currentMenuTitle });
            routeTo(target);
        },
        triggerGlobalQuickBuy: function(encodedC, searchType = 'consumable') {
            try {
                let c = JSON.parse(decodeURIComponent(encodedC));
                let isInk = c._cType === 'ink';
                let targetMode = isInk ? 'ink' : 'toner';

                document.getElementById('canonOmniDropdown').classList.remove('is-open');

                // Route to the ink/toner finder mode
                window.canonApp.routeToMode(targetMode);

                // Auto select the consumable
                selectConsumable(c, targetMode, searchType);

                // Trigger quick buy automatically
                setTimeout(() => {
                    const qbBtn = document.getElementById(isInk ? 'canonInkQuickBuyBtn' : 'canonTonerQuickBuyBtn');
                    if (qbBtn && !qbBtn.classList.contains('btn-disabled')) {
                        qbBtn.click();
                    }
                }, 50);
            } catch (e) {
                console.error('Error triggering global quick buy:', e);
            }
        }
    };
    
    window.canonApp = appInterface;
    return appInterface;
})();

var CANON_APPS = window.CANON_APPS || [
    { 
        name: 'Virtual Assistant',
        selector: '#canon-app-wrapper',
        initMethod: 'init', 
        updateMethod: 'resetFlow',
        updateArgs: [true]
    },
    { 
        name: 'Promotion Block',
        selector: '#canon-promo-bundle-root', 
        initMethod: 'initProductPromotions', 
        updateMethod: 'initProductPromotions',
        updateArgs: []
    }
    // For future apps
    // { name: 'Compare Tool', selector: '#canon-compare', initMethod: 'initCompare', updateMethod: 'initCompare' }
];

function fetchCanonData() {
    const activeApps = CANON_APPS.filter(app => document.querySelector(app.selector));
    
    console.log(`🚀 [System] Boot sequence started. Found ${activeApps.length} active app(s):`, activeApps.map(a => a.name).join(', '));

    if (window.CANON_GLOBAL_DATA && window.CANON_GLOBAL_DATA.PRODUCT_DB && window.CANON_GLOBAL_DATA.PRODUCT_DB.CAMERA && window.CANON_GLOBAL_DATA.PRODUCT_DB.CAMERA.length > 2) {
        console.log("✅ [System] DB already exists in memory. Bypassing fetch.");
        if (typeof canonApp !== 'undefined') {
            activeApps.forEach(app => {
                const el = document.querySelector(app.selector);
                if (el && !el.dataset.booted && typeof canonApp[app.initMethod] === 'function') {
                    console.log(`🟢 [UI] Initializing ${app.name}...`);
                    canonApp[app.initMethod]();
                    el.dataset.booted = 'true';
                }
            });
        }
        return;
    }

    const CACHE_KEY = 'canon_va_data_cache';
    
    const injectAndBoot = (html, isBackgroundUpdate = false) => {
        try {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            
            const allScripts = tempDiv.querySelectorAll('script');
            let targetScriptText = '';
            for (let i = 0; i < allScripts.length; i++) {
                let content = allScripts[i].innerHTML || allScripts[i].textContent || allScripts[i].text || '';
                if (content.includes('CANON_GLOBAL_DATA')) {
                    targetScriptText = content;
                    break;
                }
            }
            
            if (targetScriptText) {
                if (isBackgroundUpdate) {
                    const oldScript = document.getElementById('canon-va-data-script');
                    if (oldScript) oldScript.remove();
                }

                const newScript = document.createElement('script');
                newScript.id = 'canon-va-data-script'; 
                newScript.textContent = targetScriptText;
                document.body.appendChild(newScript);
                
                console.log(`🧠 [DB] Script injected successfully. ${isBackgroundUpdate ? '(Background Update)' : '(Initial Load)'}`);

                // Wait 150ms to ensure browser has ran script completely
                setTimeout(() => {
                    if (typeof window.reloadVAData === 'function') window.reloadVAData();
                    
                    if (typeof canonApp !== 'undefined') {
                        if (!isBackgroundUpdate) {
                            console.log("🟢 [UI] DB is ready! Initializing Apps now...");
                            activeApps.forEach(app => {
                                const el = document.querySelector(app.selector);
                                if (el && !el.dataset.booted && typeof canonApp[app.initMethod] === 'function') {
                                    canonApp[app.initMethod]();
                                    el.dataset.booted = 'true';
                                    console.log(`🚀 [App Booted] ${app.name}`);
                                }
                            });
                            console.log("⚡ [UI] All Apps Booted Successfully!");
                        } else {
                            console.log("🔄 [UI] Applying new DB update to UI...");
                            activeApps.forEach(app => {
                                const el = document.querySelector(app.selector);
                                // Updated only after app is loaded
                                if (el && el.dataset.booted && typeof canonApp[app.updateMethod] === 'function') {
                                    canonApp[app.updateMethod](...(app.updateArgs || []));
                                    console.log(`🔄 [App Updated] ${app.name}`);
                                }
                            });
                            console.log("✨ [UI] Apps Updated with FRESH Data!");
                        }
                    }

                    const loader = document.getElementById('va-liquid-loader');
                    if (loader) {
                        loader.style.opacity = '0';
                        setTimeout(() => loader.remove(), 300);
                    }
                }, 150);
            } else {
                console.warn("⚠️ [DB] Invalid Data. Target script not found. Clearing cache...");
                localStorage.removeItem(CACHE_KEY);
            }
        } catch (e) {
            console.error("❌ [DB] Error in injectAndBoot:", e);
            localStorage.removeItem(CACHE_KEY);
        }
    };

    const cachedData = localStorage.getItem(CACHE_KEY);
    let hasCache = false;

    if (cachedData && cachedData.includes('CANON_GLOBAL_DATA')) {
        console.log("📦 [Cache] Valid Cache found! Injecting instantly (0ms)...");
        injectAndBoot(cachedData, false);
        hasCache = true;
    } else {
        console.log("⏳ [Cache] No valid Cache. Waiting for Native Loading Screens...");
    }

    console.log("📡 [Fetch] Fetching latest DB from Server to verify/update...");

    let searchUrl = '/search?view=canon-data';
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        let root = window.Shopify.routes.root;
        if (!root.endsWith('/')) root += '/';
        searchUrl = root + 'search?view=canon-data';
    }

    // Cache-busting: append timestamp so proxy sees a unique URL each time
    searchUrl += '&_cb=' + Date.now();

    fetch(searchUrl)
        .then(response => {
            if (!response.ok) throw new Error("Network response was not ok");
            return response.text();
        })
        .then(newHtml => {
            if (newHtml.includes('CANON_GLOBAL_DATA')) {
                if (!hasCache || cachedData !== newHtml) {
                    console.log(hasCache ? "🚨 [Fetch] Server DB is different from Cache! Updating now..." : "✅ [Fetch] Server DB downloaded successfully.");
                    localStorage.setItem(CACHE_KEY, newHtml);
                    injectAndBoot(newHtml, hasCache);
                } else {
                    console.log("👍 [Fetch] Cache is perfectly up-to-date with Server.");
                }
            }
        })
        .catch(err => {
            console.error("❌ [Fetch] Failed to fetch VA Database from Server:", err);
            if (!hasCache && typeof canonApp !== 'undefined') {
                activeApps.forEach(app => {
                    const el = document.querySelector(app.selector);
                    if (el && !el.dataset.booted && typeof canonApp[app.initMethod] === 'function') {
                        canonApp[app.initMethod]();
                        el.dataset.booted = 'true';
                    }
                });
            }
        });
}

var canonAppInitTriggered = window.canonAppInitTriggered || false;
function tryInitVA() {
    // Fetch DB when there is any registered app
    const hasAnyApp = CANON_APPS.some(app => document.querySelector(app.selector));

    if (hasAnyApp && typeof canonApp !== 'undefined') {
        if (!canonAppInitTriggered) {
            canonAppInitTriggered = true;
            fetchCanonData(); 
        }
    } else {
        window.vaRetryCount = (window.vaRetryCount || 0) + 1;
        if (window.vaRetryCount < 40) {
            setTimeout(tryInitVA, 50);
        }
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInitVA);
} else {
    tryInitVA();
}